import { openBlock as w, createElementBlock as g, createElementVNode as m, resolveComponent as T, normalizeClass as re, createTextVNode as se, toDisplayString as _, createCommentVNode as P, renderSlot as be, createVNode as O, createBlock as Q, withCtx as k, Fragment as fe, renderList as he, withKeys as F, withModifiers as Y, getCurrentScope as Ia, onScopeDispose as Aa, toRef as qa, readonly as Ra, customRef as Va, ref as ee, watch as Pe, computed as W, toValue as ie, unref as S, createStaticVNode as La, resolveDynamicComponent as tt, withDirectives as $e, mergeProps as ze, toHandlers as Ge, vModelDynamic as mr, vModelText as pt, resolveDirective as Ua, normalizeStyle as je, vShow as Na, Transition as Ar, getCurrentInstance as Fa, onBeforeMount as Wa, isRef as ur, reactive as pr, onBeforeUnmount as ja, isReactive as Ha, isReadonly as Ba, inject as qr, provide as Rr, nextTick as Vr, isProxy as Ya, toRaw as za } from "vue";
const D = (e, r) => {
  const t = e.__vccOpts || e;
  for (const [a, n] of r)
    t[a] = n;
  return t;
}, Ga = {
  name: "ErrorIcon"
}, Qa = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ka(e, r, t, a, n, i) {
  return w(), g("svg", Qa, r[0] || (r[0] = [
    m("path", {
      d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
      fill: "#CC314B"
    }, null, -1),
    m("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.5 9.50001L7.5 4.5H8.50002V9.50001H7.5Z",
      fill: "white"
    }, null, -1),
    m("path", {
      d: "M7.5 10.5H8.50002V11.5L7.5 11.5V10.5Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Za = /* @__PURE__ */ D(Ga, [["render", Ka]]), Xa = {
  name: "QuestionComponent",
  components: {
    ErrorIcon: Za
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    charCounter: {
      type: String,
      default: ""
    },
    showError: Boolean,
    errorMessage: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    required: Boolean,
    sectionChild: Boolean
  }
}, Ja = ["id"], ei = {
  key: 0,
  class: "sr-only"
}, ti = {
  key: 1,
  "aria-hidden": "true",
  class: "tw-text-error"
}, ri = {
  key: 2,
  class: "tw-text-gray-40 tw-text-[12px] xs:tw-text-[16px] tw-italic tw-font-normal"
}, ni = ["id"], ai = {
  key: 1,
  class: "tw-flex tw-justify-end"
}, ii = { class: "tw-text-xs tw-font-normal tw-text-gray-40" }, oi = {
  key: 2,
  class: "tw-flex tw-align-middle tw-items-center tw-mt-[24px]"
}, si = ["id"];
function li(e, r, t, a, n, i) {
  const o = T("error-icon");
  return w(), g("div", {
    class: re(["tw-p-3 tw-pb-5 tw-w-full", {
      "tw-border-error tw-border-2 tw-rounded": t.showError,
      "tw-ml-3": t.sectionChild
    }])
  }, [
    m("label", {
      id: t.id,
      class: "tw-text-[16px] xs:tw-text-[24px] tw-font-bold tw-tracking-[0.8px]"
    }, [
      se(_(t.title) + " ", 1),
      t.required ? (w(), g("span", ei, _(e.$t("formComponents.required")), 1)) : P("", !0),
      t.required ? (w(), g("span", ti, "*")) : (w(), g("span", ri, _(e.$t("formComponents.optional")), 1))
    ], 8, Ja),
    t.description ? (w(), g("p", {
      key: 0,
      id: `description-${t.id}`,
      class: "tw-text-[14px] xs:tw-text-[16px] tw-text-gray-regular tw-tracking-[0.4px]"
    }, _(t.description), 9, ni)) : P("", !0),
    be(e.$slots, "default"),
    t.charCounter ? (w(), g("div", ai, [
      m("span", ii, _(t.charCounter), 1)
    ])) : P("", !0),
    t.showError ? (w(), g("div", oi, [
      O(o, { class: "tw-mr-1" }),
      m("span", {
        id: `error-message-${t.id}`,
        class: "tw-text-[14px] tw-tracking-[0.4px] tw-text-error"
      }, _(t.errorMessage), 9, si)
    ])) : P("", !0)
  ], 2);
}
const ke = /* @__PURE__ */ D(Xa, [["render", li]]), _e = {
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    focusedByKeyboard: Boolean,
    showError: Boolean,
    required: Boolean,
    sectionChild: Boolean
  }
}, ui = {
  name: "FcChoicePicker",
  components: {
    Question: ke
  },
  mixins: [_e],
  props: {
    multiple: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [Array, String, Number],
      default: ""
    },
    choices: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    selectContainer(e) {
      this.multiple ? this.checkMultiple(e) : this.checkSingle(e);
    },
    checkMultiple(e) {
      this.isChecked(e) ? this.inputVal = this.inputVal.filter((r) => r !== e) : this.inputVal = [...this.inputVal, e];
    },
    checkSingle(e) {
      this.inputVal = this.isChecked(e) ? "" : e;
    },
    isChecked(e) {
      return this.multiple ? this.inputVal.includes(e) : this.inputVal === e;
    },
    setFocusChoice(e, r) {
      const t = this.choices[0].id, a = this.choices[this.choices.length - 1].id;
      if (r.code === "ArrowDown") {
        this.$refs[`choice-${e + 1}`] ? this.$refs[`choice-${e + 1}`][0].focus() : this.$refs[`choice-${t}`][0].focus();
        return;
      }
      r.code === "ArrowUp" && (this.$refs[`choice-${e - 1}`] ? this.$refs[`choice-${e - 1}`][0].focus() : this.$refs[`choice-${a}`][0].focus());
    }
  }
}, di = ["role", "aria-labelledby", "onClick", "onKeydown"], ci = ["id", "name", "value", "checked", "aria-checked", "aria-invalid", "aria-description", "aria-describedby"], fi = ["id", "name", "value", "checked", "aria-checked", "aria-invalid", "aria-description", "aria-describedby"], hi = { class: "tw-text-[14px] xs:tw-text-[16px]" };
function mi(e, r, t, a, n, i) {
  const o = T("question");
  return w(), Q(o, {
    id: `group-label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    required: e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => [
      (w(!0), g(fe, null, he(t.choices, (s, u) => (w(), g("div", {
        id: "radiogroup",
        key: u,
        ref_for: !0,
        ref: `choice-${s.id}`,
        class: re(["first-of-type:tw-mt-[24px] tw-p-2.5 tw-border-2 tw-my-3 tw-rounded tw-max-w-md tw-flex tw-items-center tw-cursor-pointer tw-relative focus-within:tw-border-2", [
          e.focusedByKeyboard ? "focus-within:tw-border-accessible-focus" : "focus-within:tw-border-primary",
          i.isChecked(s.id) ? "tw-bg-primary/10 tw-border-primary" : "tw-border-primary/30"
        ]]),
        role: t.multiple ? "group" : "radiogroup",
        "aria-labelledby": `group-label-${e.id}`,
        onClick: (l) => i.selectContainer(s.id),
        onKeydown: [
          F(Y((l) => i.setFocusChoice(s.id, l), ["prevent"]), ["up"]),
          F(Y((l) => i.setFocusChoice(s.id, l), ["prevent"]), ["down"]),
          F(Y((l) => i.selectContainer(s.id), ["prevent"]), ["enter"]),
          F(Y((l) => i.selectContainer(s.id), ["prevent"]), ["space"]),
          r[0] || (r[0] = F(Y((l) => e.$emit("close-modal"), ["stop"]), ["esc"]))
        ]
      }, [
        t.multiple ? (w(), g("input", {
          key: 0,
          id: `choice-${s.id}`,
          type: "checkbox",
          role: "checkbox",
          name: `group-${e.id}`,
          value: s.id,
          checked: i.isChecked(s.id),
          "aria-checked": i.isChecked(s.id),
          "aria-invalid": e.showError,
          "aria-description": s.title,
          "aria-labelledby": "radiogroup",
          "aria-describedby": e.showError ? `error-message-group-label-${e.id}` : null,
          class: "tw-accent-primary tw-mr-1.5",
          style: { appearance: "auto" }
        }, null, 8, ci)) : (w(), g("input", {
          key: 1,
          id: `choice-${s.id}`,
          ref_for: !0,
          ref: `choice-${s.id}`,
          type: "radio",
          role: "radio",
          name: `group-${e.id}`,
          value: s.id,
          checked: i.isChecked(s.id),
          "aria-checked": i.isChecked(s.id),
          "aria-labelledby": "radiogroup",
          "aria-invalid": e.showError,
          "aria-description": s.title,
          "aria-describedby": e.showError ? `error-message-group-label-${e.id}` : null,
          class: "sr-only"
        }, null, 8, fi)),
        m("span", hi, _(s.title), 1)
      ], 42, di))), 128))
    ]),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "required", "section-child"]);
}
const Wn = /* @__PURE__ */ D(ui, [["render", mi], ["__scopeId", "data-v-754d5e12"]]), pi = {}, wi = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function gi(e, r) {
  return w(), g("svg", wi, r[0] || (r[0] = [
    m("path", {
      d: "M12 13.8202L16.1608 9.31814C16.3193 9.14664 16.5904 9.14664 16.7489 9.31814C16.8906 9.47156 16.8906 9.7082 16.7489 9.86162L12 15L7.25114 9.86162C7.10935 9.7082 7.10935 9.47156 7.25114 9.31814C7.40964 9.14664 7.68069 9.14664 7.83919 9.31814L12 13.8202Z",
      fill: "#383147"
    }, null, -1)
  ]));
}
const jn = /* @__PURE__ */ D(pi, [["render", gi]]);
function wr(e) {
  return Ia() ? (Aa(e), !0) : !1;
}
const gr = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const vi = Object.prototype.toString, Hn = (e) => vi.call(e) === "[object Object]", qe = () => {
}, ut = /* @__PURE__ */ yi();
function yi() {
  var e, r;
  return gr && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((r = window == null ? void 0 : window.navigator) == null ? void 0 : r.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function He(e) {
  return Array.isArray(e) ? e : [e];
}
function bi(...e) {
  if (e.length !== 1)
    return qa(...e);
  const r = e[0];
  return typeof r == "function" ? Ra(Va(() => ({ get: r, set: qe }))) : ee(r);
}
function Bn(e, r, t) {
  return Pe(
    e,
    r,
    {
      ...t,
      immediate: !0
    }
  );
}
const Yn = gr ? window : void 0;
function Je(e) {
  var r;
  const t = ie(e);
  return (r = t == null ? void 0 : t.$el) != null ? r : t;
}
function Ke(...e) {
  const r = [], t = () => {
    r.forEach((s) => s()), r.length = 0;
  }, a = (s, u, l, d) => (s.addEventListener(u, l, d), () => s.removeEventListener(u, l, d)), n = W(() => {
    const s = He(ie(e[0])).filter((u) => u != null);
    return s.every((u) => typeof u != "string") ? s : void 0;
  }), i = Bn(
    () => {
      var s, u;
      return [
        (u = (s = n.value) == null ? void 0 : s.map((l) => Je(l))) != null ? u : [Yn].filter((l) => l != null),
        He(ie(n.value ? e[1] : e[0])),
        He(S(n.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ie(n.value ? e[3] : e[2])
      ];
    },
    ([s, u, l, d]) => {
      if (t(), !(s != null && s.length) || !(u != null && u.length) || !(l != null && l.length))
        return;
      const h = Hn(d) ? { ...d } : d;
      r.push(
        ...s.flatMap(
          (y) => u.flatMap(
            (v) => l.map((c) => a(y, v, c, h))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    i(), t();
  };
  return wr(t), o;
}
let Lr = !1;
function zn(e, r, t = {}) {
  const { window: a = Yn, ignore: n = [], capture: i = !0, detectIframe: o = !1 } = t;
  if (!a)
    return qe;
  if (ut && !Lr) {
    Lr = !0;
    const f = { passive: !0 };
    Array.from(a.document.body.children).forEach((p) => Ke(p, "click", qe, f)), Ke(a.document.documentElement, "click", qe, f);
  }
  let s = !0;
  const u = (f) => ie(n).some((p) => {
    if (typeof p == "string")
      return Array.from(a.document.querySelectorAll(p)).some((b) => b === f.target || f.composedPath().includes(b));
    {
      const b = Je(p);
      return b && (f.target === b || f.composedPath().includes(b));
    }
  });
  function l(f) {
    const p = ie(f);
    return p && p.$.subTree.shapeFlag === 16;
  }
  function d(f, p) {
    const b = ie(f), $ = b.$.subTree && b.$.subTree.children;
    return $ == null || !Array.isArray($) ? !1 : $.some((q) => q.el === p.target || p.composedPath().includes(q.el));
  }
  const h = (f) => {
    const p = Je(e);
    if (f.target != null && !(!(p instanceof Element) && l(e) && d(e, f)) && !(!p || p === f.target || f.composedPath().includes(p))) {
      if (f.detail === 0 && (s = !u(f)), !s) {
        s = !0;
        return;
      }
      r(f);
    }
  };
  let y = !1;
  const v = [
    Ke(a, "click", (f) => {
      y || (y = !0, setTimeout(() => {
        y = !1;
      }, 0), h(f));
    }, { passive: !0, capture: i }),
    Ke(a, "pointerdown", (f) => {
      const p = Je(e);
      s = !u(f) && !!(p && !f.composedPath().includes(p));
    }, { passive: !0 }),
    o && Ke(a, "blur", (f) => {
      setTimeout(() => {
        var p;
        const b = Je(e);
        ((p = a.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(b != null && b.contains(a.document.activeElement)) && r(f);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean);
  return () => v.forEach((f) => f());
}
const Ci = {
  name: "FcDropdown",
  components: {
    "caret-down-icon": jn,
    Question: ke
  },
  mixins: [_e],
  props: {
    choices: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [Number, String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    const e = ee(null);
    let r = ee(!1);
    function t() {
      r.value = !1;
    }
    function a() {
      r.value = !0;
    }
    function n() {
      r.value = !r.value;
    }
    return zn(e, t), { dropdownOpen: r, openDropdown: a, toggleDropdown: n, closeDropdown: t, listbox1: e };
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    label() {
      var e, r, t;
      return this.multiple && ((e = this.inputVal) != null && e.length) ? `Option${((r = this.inputVal) == null ? void 0 : r.length) > 1 ? "s" : ""} selected` : !this.multiple & this.inputVal !== "" ? ((t = this.choices.find((a) => a.id === this.inputVal)) == null ? void 0 : t.title) || "" : "Select an option";
    },
    hasValue() {
      var e;
      return this.multiple ? (e = this.inputVal) == null ? void 0 : e.length : this.inputVal !== "";
    }
  },
  methods: {
    dropdownButtonAction(e) {
      if (e.code === "Tab") return this.closeDropdown();
      switch (e.preventDefault(), e.code) {
        case "Enter":
          return this.toggleDropdown();
        case "Space":
          return this.toggleDropdown();
        case "Home":
          this.openDropdown(), this.$nextTick(() => {
            this.$refs["listbox-option-0"][0].focus();
          });
          return;
        case "End":
          this.openDropdown(), this.$nextTick(() => {
            this.$refs[`listbox-option-${this.choices.length - 1}`][0].focus();
          });
          return;
        case "ArrowDown":
          if (this.dropdownOpen) {
            this.$refs["listbox-option-0"][0].focus();
            return;
          } else {
            this.openDropdown();
            return;
          }
        case "ArrowUp":
          this.openDropdown(), this.$nextTick(() => {
            this.$refs["listbox-option-0"][0].focus();
          });
          return;
        default:
          this.closeDropdown();
      }
    },
    isChecked(e) {
      var r;
      return this.multiple ? (r = this.inputVal) == null ? void 0 : r.includes(e) : this.inputVal === e;
    },
    keydownAction(e, r, t) {
      switch (e.code) {
        case "Enter":
          return this.selectChoice(r);
        case "Space":
          return this.selectChoice(r);
        case "Home":
          return this.$refs["listbox-option-0"][0].focus();
        case "End":
          return this.$refs[`listbox-option-${this.choices.length - 1}`][0].focus();
        case "ArrowDown":
          return this.nextChoice(t);
        case "ArrowUp":
          return this.previousChoice(t);
        case "Escape":
          this.closeDropdown(), this.$refs["dropdown-button"].focus();
          return;
        case "Tab":
          this.closeDropdown(), this.$refs["dropdown-button"].focus();
          return;
        default:
          this.closeDropdown(), this.$refs["dropdown-button"].focus();
      }
    },
    selectChoice(e) {
      return this.multiple ? this.checkMultiple(e) : this.checkSingle(e);
    },
    previousChoice(e) {
      return e === 0 ? this.$refs[`listbox-option-${this.choices.length - 1}`][0].focus() : this.$refs[`listbox-option-${e - 1}`][0].focus();
    },
    nextChoice(e) {
      return e === this.choices.length - 1 ? this.$refs["listbox-option-0"][0].focus() : this.$refs[`listbox-option-${e + 1}`][0].focus();
    },
    checkMultiple(e) {
      return this.isChecked(e) ? this.inputVal = this.inputVal.filter((r) => r !== e) : this.inputVal = [...this.inputVal, e];
    },
    checkSingle(e) {
      this.isChecked(e) ? this.inputVal = "" : this.inputVal = e, this.closeDropdown(), this.$refs["dropdown-button"].focus();
    }
  }
}, xi = { class: "tw-my-1 tw-relative tw-max-w-md tw-mt-[24px]" }, _i = ["id", "aria-labelledby", "aria-expanded", "aria-invalid", "aria-describedby"], Ti = { class: "tw-flex tw-items-center" }, Di = { class: "tw-ml-1 tw-flex tw-items-center tw-text-[14px] xs:tw-text-[16px] tw-text-gray-40" }, $i = {
  key: 0,
  class: "tw-mr-2 tw-border-primary tw-border tw-rounded-xl tw-w-[24px] tw-h-[24px] tw-flex tw-justify-center tw-items-center"
}, Oi = { class: "tw-ml-3 tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-2 tw-pointer-events-none" }, ki = ["aria-labelledby", "aria-activedescendant", "aria-multiselectable"], Mi = ["aria-selected", "onClick", "onKeydown"], Ei = { class: "tw-flex tw-items-center" }, Si = ["id", "checked", "value", "aria-labelledby", "aria-description"], Pi = { class: "tw-text-[14px] xs:tw-text-[16px] tw-ml-3 tw-block tw-truncate" };
function Ii(e, r, t, a, n, i) {
  const o = T("caret-down-icon"), s = T("question");
  return w(), Q(s, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    required: e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => {
      var u, l;
      return [
        m("div", xi, [
          m("button", {
            id: e.id,
            ref: "dropdown-button",
            "aria-labelledby": `label-${e.id}`,
            "aria-controls": "listbox1",
            "aria-expanded": a.dropdownOpen,
            "aria-haspopup": "listbox",
            role: "combobox",
            "aria-invalid": e.showError,
            "aria-describedby": `description-label-${e.id} error-message-label-${e.id}`,
            class: re(["tw-relative tw-w-full tw-bg-white tw-border tw-rounded tw-shadow-sm tw-pl-3 tw-pr-10 tw-py-2.5 tw-text-left tw-cursor-default focus-within:tw-border-primary tw-border-primary/30 sm:tw-text-sm", [
              i.hasValue ? "tw-border-primary" : "tw-border-gray-300",
              e.focusedByKeyboard ? "focus-within:tw-outline-accessible-focus" : "focus-within:tw-border-primary"
            ]]),
            onClick: r[0] || (r[0] = (...d) => a.toggleDropdown && a.toggleDropdown(...d)),
            onKeydown: r[1] || (r[1] = (...d) => i.dropdownButtonAction && i.dropdownButtonAction(...d))
          }, [
            m("span", Ti, [
              m("span", Di, [
                t.multiple && ((u = i.inputVal) != null && u.length) ? (w(), g("div", $i, _((l = i.inputVal) == null ? void 0 : l.length), 1)) : P("", !0),
                se(" " + _(i.label), 1)
              ])
            ]),
            m("span", Oi, [
              O(o, {
                class: re({ "tw-rotate-180": a.dropdownOpen })
              }, null, 8, ["class"])
            ])
          ], 42, _i),
          a.dropdownOpen ? (w(), g("ul", {
            key: 0,
            id: "listbox1",
            ref: "listbox1",
            class: "tw-absolute tw-z-50 tw-mt-1 tw-w-full tw-bg-white tw-shadow-lg tw-max-h-56 tw-rounded tw-py-1 tw-text-base tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-overflow-auto focus:tw-outline-none sm:tw-text-sm tw-p-0 tw-list-none",
            tabindex: "-1",
            role: "listbox",
            "aria-labelledby": `label-${e.id}`,
            "aria-activedescendant": i.inputVal,
            "aria-multiselectable": t.multiple
          }, [
            (w(!0), g(fe, null, he(t.choices, (d, h) => (w(), g("li", {
              ref_for: !0,
              ref: `listbox-option-${h}`,
              key: d.id,
              "aria-selected": i.isChecked(d.id),
              role: "option",
              tabindex: "-1",
              class: "tw-text-gray-900 tw-cursor-default tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9 hover:tw-bg-primary/10",
              onClick: (y) => i.selectChoice(d.id),
              onKeydown: Y((y) => i.keydownAction(y, d.id, h), ["prevent"])
            }, [
              m("div", Ei, [
                t.multiple ? (w(), g("input", {
                  key: 0,
                  id: `choice-${d.id}`,
                  type: "checkbox",
                  checked: i.isChecked(d.id),
                  value: d.id,
                  "aria-labelledby": `group-label-${e.id}`,
                  "aria-description": d.title,
                  class: "tw-accent-primary tw-mr-1.5 tw-m-[3px]",
                  style: { appearance: "auto" }
                }, null, 8, Si)) : P("", !0),
                m("span", Pi, _(d.title), 1)
              ])
            ], 40, Mi))), 128))
          ], 8, ki)) : P("", !0)
        ])
      ];
    }),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "required", "section-child"]);
}
const Gn = /* @__PURE__ */ D(Ci, [["render", Ii]]), Ai = {}, qi = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ri(e, r) {
  return w(), g("svg", qi, r[0] || (r[0] = [
    La('<path fill-rule="evenodd" clip-rule="evenodd" d="M4 4.57141C3.03662 4.57141 2.28571 5.32231 2.28571 6.28569C2.28571 7.24907 3.03662 7.99997 4 7.99997C4.96338 7.99997 5.71429 7.24907 5.71429 6.28569C5.71429 5.32231 4.96338 4.57141 4 4.57141ZM3.42857 6.28569C3.42857 5.95349 3.6678 5.71427 4 5.71427C4.3322 5.71427 4.57143 5.95349 4.57143 6.28569C4.57143 6.61789 4.3322 6.85712 4 6.85712C3.6678 6.85712 3.42857 6.61789 3.42857 6.28569Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.57141C7.03662 4.57141 6.28571 5.32231 6.28571 6.28569C6.28571 7.24907 7.03662 7.99997 8 7.99997C8.96338 7.99997 9.71429 7.24907 9.71429 6.28569C9.71429 5.32231 8.96338 4.57141 8 4.57141ZM7.42857 6.28569C7.42857 5.95349 7.6678 5.71427 8 5.71427C8.3322 5.71427 8.57143 5.95349 8.57143 6.28569C8.57143 6.61789 8.3322 6.85712 8 6.85712C7.6678 6.85712 7.42857 6.61789 7.42857 6.28569Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.57141C11.0366 4.57141 10.2857 5.32231 10.2857 6.28569C10.2857 7.24907 11.0366 7.99997 12 7.99997C12.9634 7.99997 13.7143 7.24907 13.7143 6.28569C13.7143 5.32231 12.9634 4.57141 12 4.57141ZM11.4286 6.28569C11.4286 5.95349 11.6678 5.71427 12 5.71427C12.3322 5.71427 12.5714 5.95349 12.5714 6.28569C12.5714 6.61789 12.3322 6.85712 12 6.85712C11.6678 6.85712 11.4286 6.61789 11.4286 6.28569Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M4 9.14283C3.03662 9.14283 2.28571 9.89372 2.28571 10.8571C2.28571 11.8205 3.03662 12.5714 4 12.5714C4.96338 12.5714 5.71429 11.8205 5.71429 10.8571C5.71429 9.89372 4.96338 9.14283 4 9.14283ZM3.42857 10.8571C3.42857 10.5249 3.6678 10.2857 4 10.2857C4.3322 10.2857 4.57143 10.5249 4.57143 10.8571C4.57143 11.1893 4.3322 11.4285 4 11.4285C3.6678 11.4285 3.42857 11.1893 3.42857 10.8571Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8 9.14283C7.03662 9.14283 6.28571 9.89372 6.28571 10.8571C6.28571 11.8205 7.03662 12.5714 8 12.5714C8.96338 12.5714 9.71429 11.8205 9.71429 10.8571C9.71429 9.89372 8.96338 9.14283 8 9.14283ZM7.42857 10.8571C7.42857 10.5249 7.6678 10.2857 8 10.2857C8.3322 10.2857 8.57143 10.5249 8.57143 10.8571C8.57143 11.1893 8.3322 11.4285 8 11.4285C7.6678 11.4285 7.42857 11.1893 7.42857 10.8571Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.7143 10.8571C13.7143 11.8039 12.9468 12.5714 12 12.5714C11.0532 12.5714 10.2857 11.8039 10.2857 10.8571C10.2857 9.91033 11.0532 9.14283 12 9.14283C12.9468 9.14283 13.7143 9.91033 13.7143 10.8571ZM12.5714 10.8571C12.5714 11.1727 12.3156 11.4285 12 11.4285C11.6844 11.4285 11.4286 11.1727 11.4286 10.8571C11.4286 10.5415 11.6844 10.2857 12 10.2857C12.3156 10.2857 12.5714 10.5415 12.5714 10.8571Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M5.71429 0.571427C5.71429 0.255836 5.45845 0 5.14286 0C4.82727 0 4.57143 0.255836 4.57143 0.571427V1.14285H1.35338C0.60593 1.14285 0 1.74878 0 2.49623V15.0075C0 15.2188 0.0172739 15.6485 0.409611 15.8749C0.566513 15.9654 0.728157 15.9855 0.827121 15.9932C0.917832 16.0002 1.02172 16.0001 1.11081 16H14.8892C14.9783 16.0001 15.0822 16.0002 15.1729 15.9932C15.2718 15.9855 15.4335 15.9654 15.5904 15.8749C15.9827 15.6485 16 15.2188 16 15.0075V2.49623C16 1.74878 15.3941 1.14285 14.6466 1.14285H11.4286V0.571427C11.4286 0.255836 11.1727 0 10.8571 0C10.5416 0 10.2857 0.255836 10.2857 0.571427V1.14285H5.71429V0.571427ZM1.35338 2.28571H4.57143V2.85713C4.57143 3.17272 4.82727 3.42856 5.14286 3.42856C5.45845 3.42856 5.71429 3.17272 5.71429 2.85713V2.28571H10.2857V2.85713C10.2857 3.17272 10.5416 3.42856 10.8571 3.42856C11.1727 3.42856 11.4286 3.17272 11.4286 2.85713V2.28571H14.6466C14.7629 2.28571 14.8571 2.37996 14.8571 2.49623V14.8571H1.14286V2.49623C1.14286 2.37996 1.23711 2.28571 1.35338 2.28571Z" fill="currentColor"></path>', 7)
  ]));
}
const Qn = /* @__PURE__ */ D(Ai, [["render", Ri]]), Vi = {}, Li = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ui(e, r) {
  return w(), g("svg", Li, r[0] || (r[0] = [
    m("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L9.30884 10.0159ZM6.5 10.1C8.48822 10.1 10.1 8.48822 10.1 6.5C10.1 4.51178 8.48822 2.9 6.5 2.9C4.51178 2.9 2.9 4.51178 2.9 6.5C2.9 8.48822 4.51178 10.1 6.5 10.1Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const Ni = /* @__PURE__ */ D(Vi, [["render", Ui]]), Fi = {
  name: "TimeIcon"
}, Wi = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ji(e, r, t, a, n, i) {
  return w(), g("svg", Wi, r[0] || (r[0] = [
    m("path", {
      d: "M8.15625 8.38095C8.15625 8.52691 8.22003 8.66559 8.33085 8.76058L10.9975 11.0463C11.2072 11.226 11.5228 11.2017 11.7025 10.9921C11.8823 10.7824 11.858 10.4668 11.6483 10.287L9.15625 8.15098V4.66667C9.15625 4.39052 8.93239 4.16667 8.65625 4.16667C8.38011 4.16667 8.15625 4.39052 8.15625 4.66667V8.38095ZM16.1562 8C16.1562 12.1421 12.7984 15.5 8.65625 15.5C4.51411 15.5 1.15625 12.1421 1.15625 8C1.15625 3.85786 4.51411 0.5 8.65625 0.5C12.7984 0.5 16.1562 3.85786 16.1562 8Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const dr = /* @__PURE__ */ D(Fi, [["render", ji]]), rt = {
  props: {
    id: String,
    name: String,
    form: String,
    required: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      inputValue: this.modelValue || ""
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$attrs,
        input: this.updateValue
      };
    }
  },
  watch: {
    value(e) {
      this.inputValue = e;
    }
  },
  methods: {
    updateValue(e) {
      var t;
      const r = e != null && e.target ? (t = e == null ? void 0 : e.target) == null ? void 0 : t.value : e;
      this.$emit("update:modelValue", r);
    }
  }
}, nt = {
  props: {
    modelValue: [String, Number],
    readonly: Boolean,
    placeholder: String,
    maxLength: Number
  }
}, Hi = {
  name: "FcInput",
  components: {
    Calendar: Qn,
    Question: ke,
    Search: Ni,
    [dr.name]: dr
  },
  mixins: [rt, nt, _e],
  props: {
    /**
     * For number type, hides the controls on the right of the input.
     */
    hideNumberControls: Boolean,
    disabled: Boolean,
    iconRight: {
      type: String,
      default: ""
    },
    iconLeft: {
      type: String,
      default: ""
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: "dnn"
    },
    type: {
      type: String,
      default: "dnn"
    },
    /**
     * Defines the name of the component for automation testing usage
     */
    name: {
      type: String,
      default: "dnn"
    },
    showCharCounter: Boolean,
    maxLength: Number
  },
  computed: {
    _input: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    widthStyles() {
      return this.width ? {
        width: this.width
      } : {};
    },
    charCounter() {
      return this.showCharCounter ? `${this.modelValue && this.modelValue.length || 0} / ${this.maxLength}` : "";
    }
  }
}, Bi = { class: "tw-mt-[24px]" }, Yi = {
  key: 0,
  class: "tw-absolute tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-left-0"
}, zi = ["id", "name", "type", "aria-labelledby", "aria-invalid", "aria-describedby", "placeholder", "maxlength", "min", "max", "step"], Gi = {
  key: 1,
  class: "tw-absolute tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-top-0 tw-right-0"
};
function Qi(e, r, t, a, n, i) {
  const o = T("Question");
  return w(), Q(o, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    "char-counter": i.charCounter,
    required: e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => [
      m("div", Bi, [
        t.iconLeft ? (w(), g("div", Yi, [
          (w(), Q(tt(t.iconLeft)))
        ])) : P("", !0),
        $e(m("input", ze({
          id: e.id || t.name
        }, e.$attrs, {
          "onUpdate:modelValue": r[0] || (r[0] = (s) => i._input = s),
          class: ["tw-w-full tw-border-b tw-border-b-primary/[0.4] tw-h-9 tw-pl-1 focus:tw-border-b-primary focus:tw-border-2", {
            "tw-pl-9": t.iconLeft,
            "tw-pr-9": t.iconRight,
            "tw-a-input--hide-number-controls": t.hideNumberControls,
            "focus:tw-outline-accessible-focus": e.focusedByKeyboard
          }],
          name: t.name,
          type: t.type,
          "aria-labelledby": `label-${e.id}`,
          "aria-invalid": e.showError,
          "aria-describedby": `error-message-label-${e.id} description-label-${e.id}`,
          placeholder: e.placeholder,
          maxlength: t.maxLength,
          min: t.min,
          max: t.max,
          step: t.step
        }, Ge(e.$attrs, !0)), null, 16, zi), [
          [mr, i._input]
        ]),
        t.iconRight || t.type === "search" ? (w(), g("div", Gi, [
          (w(), Q(tt(t.iconRight || "search")))
        ])) : P("", !0)
      ])
    ]),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "char-counter", "required", "section-child"]);
}
const Kn = /* @__PURE__ */ D(Hi, [["render", Qi], ["__scopeId", "data-v-d5d530fd"]]), Ki = {
  props: {
    choices: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  data: () => ({
    range: "1"
  }),
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  watch: {
    range(e) {
      var r;
      this.inputVal = (r = this.choices.find((t) => t.title === e)) == null ? void 0 : r.id;
    }
  }
}, Zi = { class: "tw-flex tw-flex-col tw-space-y-2 tw-relative" }, Xi = ["max"], Ji = { class: "tw-flex tw-justify-between tw-p-0 tw-list-none" };
function eo(e, r, t, a, n, i) {
  return w(), g("div", Zi, [
    $e(m("input", {
      type: "range",
      class: "tw-w-full tw-accent-primary tw-appearance-none tw-h-[6px] tw-rounded tw-bg-primary/10",
      min: "1",
      max: t.choices.length,
      step: "1",
      "onUpdate:modelValue": r[0] || (r[0] = (o) => e.range = o),
      "data-testid": "range"
    }, null, 8, Xi), [
      [pt, e.range]
    ]),
    m("ul", Ji, [
      (w(!0), g(fe, null, he(t.choices, (o) => (w(), g("li", {
        key: o.title,
        class: "tw-text-[14px] tw-w-[14px] tw-text-center"
      }, _(o.title), 1))), 128))
    ])
  ]);
}
const to = /* @__PURE__ */ D(Ki, [["render", eo]]), ro = {
  props: {
    id: {
      type: Number,
      default: 0
    },
    choices: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    selected() {
      var e;
      return (e = this.choices.find((r) => this.inputVal === r.id)) == null ? void 0 : e.title;
    },
    highestValue() {
      return this.choices[this.choices.length - 1].title;
    },
    lowestValue() {
      return this.choices[0].title;
    }
  },
  methods: {
    handleKeyPress(e, r, t) {
      switch (e.code) {
        case "Escape": {
          this.$emit("close-modal");
          break;
        }
        case "Space": {
          this.inputVal = t, e.preventDefault();
          break;
        }
        case "ArrowLeft": {
          r > 0 && this.$refs[`choice-${r - 1}`][0].focus();
          break;
        }
        case "ArrowRight":
          r < this.choices.length - 1 && this.$refs[`choice-${r + 1}`][0].focus();
          break;
      }
    }
  }
}, no = { class: "tw-w-full tw-flex tw-h-[50px]" }, ao = ["id", "aria-labelledby", "aria-valuemin", "aria-valuemax", "aria-valuetext", "aria-describedby", "tabindex", "onClick", "onKeydown"], io = {
  "aria-live": "polite",
  class: "sr-only"
};
function oo(e, r, t, a, n, i) {
  return w(), g("div", no, [
    (w(!0), g(fe, null, he(t.choices, (o, s) => (w(), g("button", {
      key: s,
      id: `choice-${o.id}`,
      ref_for: !0,
      ref: `choice-${s}`,
      "aria-labelledby": `label-${t.id}`,
      "aria-valuemin": i.lowestValue,
      "aria-valuemax": i.highestValue,
      "aria-valuetext": `${s + 1}. Choose a rating from ${i.lowestValue} to ${i.highestValue}`,
      "aria-describedby": `error-message-label-${t.id} description-label-${t.id}`,
      role: "slider",
      class: re(["scale-choice tw-flex tw-align-center tw-justify-center tw-items-center tw-border-2 tw-border-solid tw-border-l-0 tw-w-full tw-h-full last:tw-rounded-r first:tw-rounded-l first:tw-border-l-2 focus:tw-border-primary", {
        "tw-bg-primary/10 tw-border-primary": Number(i.selected) >= Number(o.title)
      }]),
      tabindex: Number(o.title) === Number(i.selected) || Number(o.title) === 1 && !i.selected ? 0 : -1,
      onClick: (u) => i.inputVal = o.id,
      onKeydown: (u) => i.handleKeyPress(u, s, o.id)
    }, _(o.title), 43, ao))), 128)),
    m("div", io, _(i.selected), 1)
  ]);
}
const so = /* @__PURE__ */ D(ro, [["render", oo], ["__scopeId", "data-v-c42da023"]]), lo = {
  name: "FcScale",
  components: {
    Question: ke,
    Mobile: to,
    Web: so
  },
  mixins: [_e],
  props: {
    choices: {
      type: Array,
      default: () => []
    },
    leftLabel: {
      type: String,
      default: ""
    },
    rightLabel: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, uo = { class: "tw-mt-[24px]" }, co = { class: "tw-block xs:tw-hidden" }, fo = { class: "xs:tw-block" }, ho = { class: "tw-flex tw-justify-between tw-mt-3" }, mo = { class: "tw-text-[14px] xs:tw-text-[16px] tw-text-gray-regular tw-tracking-[0.4px]" }, po = { class: "tw-text-[14px] xs:tw-text-[16px] tw-text-gray-regular tw-tracking-[0.4px]" };
function wo(e, r, t, a, n, i) {
  const o = T("mobile"), s = T("web"), u = T("question");
  return w(), Q(u, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    required: e.required,
    "aria-required": e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => [
      m("div", uo, [
        m("div", co, [
          O(o, {
            modelValue: i.inputVal,
            "onUpdate:modelValue": r[0] || (r[0] = (l) => i.inputVal = l),
            choices: t.choices
          }, null, 8, ["modelValue", "choices"])
        ]),
        m("div", fo, [
          O(s, {
            id: e.id,
            modelValue: i.inputVal,
            "onUpdate:modelValue": r[1] || (r[1] = (l) => i.inputVal = l),
            choices: t.choices,
            onCloseModal: r[2] || (r[2] = (l) => e.$emit("close-modal"))
          }, null, 8, ["id", "modelValue", "choices"])
        ]),
        m("div", ho, [
          m("span", mo, _(t.leftLabel), 1),
          m("span", po, _(t.rightLabel), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "required", "aria-required", "section-child"]);
}
const Zn = /* @__PURE__ */ D(lo, [["render", wo]]), go = {
  name: "FcTextArea",
  components: {
    Question: ke
  },
  mixins: [rt, nt, _e],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    showCharCounter: Boolean
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    charCounter() {
      if (this.showCharCounter) {
        const e = this.maxLength ? `/ ${this.maxLength}` : "";
        return `${this.modelValue && this.modelValue.length || 0} ${e}`;
      }
      return "";
    }
  }
}, vo = ["id", "name", "required", "readonly", "disabled", "placeholder", "form", "maxlength", "aria-labelledby", "aria-invalid", "aria-describedby"];
function yo(e, r, t, a, n, i) {
  const o = T("question");
  return w(), Q(o, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    "char-counter": i.charCounter,
    required: e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => [
      $e(m("textarea", ze({
        id: e.id,
        "onUpdate:modelValue": r[0] || (r[0] = (s) => i.inputVal = s),
        class: ["tw-w-full tw-border-b tw-border-b-primary/[0.4] tw-pl-1 tw-outline-none focus:tw-border-b-primary focus:tw-border-b-2 tw-mt-[24px]", {
          "focus:tw-outline-accessible-focus": e.focusedByKeyboard
        }],
        name: e.name,
        required: e.required,
        readonly: e.readonly,
        disabled: e.disabled,
        placeholder: e.placeholder,
        form: e.form,
        maxlength: e.maxLength,
        "aria-labelledby": `label-${e.id}`,
        "aria-invalid": e.showError,
        "aria-describedby": `error-message-label-${e.id} description-label-${e.id}`
      }, Ge(e.listeners, !0)), null, 16, vo), [
        [pt, i.inputVal]
      ])
    ]),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "char-counter", "required", "section-child"]);
}
const Xn = /* @__PURE__ */ D(go, [["render", yo]]);
function Oe(e) {
  "@babel/helpers - typeof";
  return Oe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Oe(e);
}
function te(e, r) {
  if (r.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + r.length + " present");
}
function bo(e) {
  return te(1, arguments), e instanceof Date || Oe(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function le(e) {
  te(1, arguments);
  var r = Object.prototype.toString.call(e);
  return e instanceof Date || Oe(e) === "object" && r === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || r === "[object Number]" ? new Date(e) : ((typeof e == "string" || r === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Jn(e) {
  if (te(1, arguments), !bo(e) && typeof e != "number")
    return !1;
  var r = le(e);
  return !isNaN(Number(r));
}
function me(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var r = Number(e);
  return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
}
function Co(e, r) {
  te(2, arguments);
  var t = le(e).getTime(), a = me(r);
  return new Date(t + a);
}
function ea(e, r) {
  te(2, arguments);
  var t = me(r);
  return Co(e, -t);
}
var xo = 864e5;
function _o(e) {
  te(1, arguments);
  var r = le(e), t = r.getTime();
  r.setUTCMonth(0, 1), r.setUTCHours(0, 0, 0, 0);
  var a = r.getTime(), n = t - a;
  return Math.floor(n / xo) + 1;
}
function Ye(e) {
  te(1, arguments);
  var r = 1, t = le(e), a = t.getUTCDay(), n = (a < r ? 7 : 0) + a - r;
  return t.setUTCDate(t.getUTCDate() - n), t.setUTCHours(0, 0, 0, 0), t;
}
function ta(e) {
  te(1, arguments);
  var r = le(e), t = r.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var n = Ye(a), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(t, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Ye(i);
  return r.getTime() >= n.getTime() ? t + 1 : r.getTime() >= o.getTime() ? t : t - 1;
}
function To(e) {
  te(1, arguments);
  var r = ta(e), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(r, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var a = Ye(t);
  return a;
}
var Do = 6048e5;
function ra(e) {
  te(1, arguments);
  var r = le(e), t = Ye(r).getTime() - To(r).getTime();
  return Math.round(t / Do) + 1;
}
var $o = {};
function Qe() {
  return $o;
}
function Re(e, r) {
  var t, a, n, i, o, s, u, l;
  te(1, arguments);
  var d = Qe(), h = me((t = (a = (n = (i = r == null ? void 0 : r.weekStartsOn) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : d.weekStartsOn) !== null && a !== void 0 ? a : (u = d.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var y = le(e), v = y.getUTCDay(), c = (v < h ? 7 : 0) + v - h;
  return y.setUTCDate(y.getUTCDate() - c), y.setUTCHours(0, 0, 0, 0), y;
}
function vr(e, r) {
  var t, a, n, i, o, s, u, l;
  te(1, arguments);
  var d = le(e), h = d.getUTCFullYear(), y = Qe(), v = me((t = (a = (n = (i = r == null ? void 0 : r.firstWeekContainsDate) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : y.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = y.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && t !== void 0 ? t : 1);
  if (!(v >= 1 && v <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c = /* @__PURE__ */ new Date(0);
  c.setUTCFullYear(h + 1, 0, v), c.setUTCHours(0, 0, 0, 0);
  var f = Re(c, r), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(h, 0, v), p.setUTCHours(0, 0, 0, 0);
  var b = Re(p, r);
  return d.getTime() >= f.getTime() ? h + 1 : d.getTime() >= b.getTime() ? h : h - 1;
}
function Oo(e, r) {
  var t, a, n, i, o, s, u, l;
  te(1, arguments);
  var d = Qe(), h = me((t = (a = (n = (i = r == null ? void 0 : r.firstWeekContainsDate) !== null && i !== void 0 ? i : r == null || (o = r.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : d.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = d.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && t !== void 0 ? t : 1), y = vr(e, r), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(y, 0, h), v.setUTCHours(0, 0, 0, 0);
  var c = Re(v, r);
  return c;
}
var ko = 6048e5;
function na(e, r) {
  te(1, arguments);
  var t = le(e), a = Re(t, r).getTime() - Oo(t, r).getTime();
  return Math.round(a / ko) + 1;
}
function L(e, r) {
  for (var t = e < 0 ? "-" : "", a = Math.abs(e).toString(); a.length < r; )
    a = "0" + a;
  return t + a;
}
var Ee = {
  // Year
  y: function(r, t) {
    var a = r.getUTCFullYear(), n = a > 0 ? a : 1 - a;
    return L(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M: function(r, t) {
    var a = r.getUTCMonth();
    return t === "M" ? String(a + 1) : L(a + 1, 2);
  },
  // Day of the month
  d: function(r, t) {
    return L(r.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(r, t) {
    var a = r.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(r, t) {
    return L(r.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(r, t) {
    return L(r.getUTCHours(), t.length);
  },
  // Minute
  m: function(r, t) {
    return L(r.getUTCMinutes(), t.length);
  },
  // Second
  s: function(r, t) {
    return L(r.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(r, t) {
    var a = t.length, n = r.getUTCMilliseconds(), i = Math.floor(n * Math.pow(10, a - 3));
    return L(i, t.length);
  }
}, Ne = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Mo = {
  // Era
  G: function(r, t, a) {
    var n = r.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return a.era(n, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return a.era(n, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return a.era(n, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(r, t, a) {
    if (t === "yo") {
      var n = r.getUTCFullYear(), i = n > 0 ? n : 1 - n;
      return a.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Ee.y(r, t);
  },
  // Local week-numbering year
  Y: function(r, t, a, n) {
    var i = vr(r, n), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      var s = o % 100;
      return L(s, 2);
    }
    return t === "Yo" ? a.ordinalNumber(o, {
      unit: "year"
    }) : L(o, t.length);
  },
  // ISO week-numbering year
  R: function(r, t) {
    var a = ta(r);
    return L(a, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, t) {
    var a = r.getUTCFullYear();
    return L(a, t.length);
  },
  // Quarter
  Q: function(r, t, a) {
    var n = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return L(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return a.ordinalNumber(n, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return a.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return a.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return a.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, t, a) {
    var n = Math.ceil((r.getUTCMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return L(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return a.ordinalNumber(n, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return a.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return a.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return a.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, t, a) {
    var n = r.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ee.M(r, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return a.ordinalNumber(n + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return a.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return a.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return a.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(r, t, a) {
    var n = r.getUTCMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return L(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return a.ordinalNumber(n + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return a.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return a.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return a.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(r, t, a, n) {
    var i = na(r, n);
    return t === "wo" ? a.ordinalNumber(i, {
      unit: "week"
    }) : L(i, t.length);
  },
  // ISO week of year
  I: function(r, t, a) {
    var n = ra(r);
    return t === "Io" ? a.ordinalNumber(n, {
      unit: "week"
    }) : L(n, t.length);
  },
  // Day of the month
  d: function(r, t, a) {
    return t === "do" ? a.ordinalNumber(r.getUTCDate(), {
      unit: "date"
    }) : Ee.d(r, t);
  },
  // Day of year
  D: function(r, t, a) {
    var n = _o(r);
    return t === "Do" ? a.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : L(n, t.length);
  },
  // Day of week
  E: function(r, t, a) {
    var n = r.getUTCDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return a.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return a.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return a.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return a.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, t, a, n) {
    var i = r.getUTCDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return L(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return a.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, t, a, n) {
    var i = r.getUTCDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return L(o, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return a.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return a.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return a.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return a.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return a.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, t, a) {
    var n = r.getUTCDay(), i = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return L(i, t.length);
      // 2nd
      case "io":
        return a.ordinalNumber(i, {
          unit: "day"
        });
      // Tue
      case "iii":
        return a.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return a.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return a.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return a.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, t, a) {
    var n = r.getUTCHours(), i = n / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, t, a) {
    var n = r.getUTCHours(), i;
    switch (n === 12 ? i = Ne.noon : n === 0 ? i = Ne.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, t, a) {
    var n = r.getUTCHours(), i;
    switch (n >= 17 ? i = Ne.evening : n >= 12 ? i = Ne.afternoon : n >= 4 ? i = Ne.morning : i = Ne.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, t, a) {
    if (t === "ho") {
      var n = r.getUTCHours() % 12;
      return n === 0 && (n = 12), a.ordinalNumber(n, {
        unit: "hour"
      });
    }
    return Ee.h(r, t);
  },
  // Hour [0-23]
  H: function(r, t, a) {
    return t === "Ho" ? a.ordinalNumber(r.getUTCHours(), {
      unit: "hour"
    }) : Ee.H(r, t);
  },
  // Hour [0-11]
  K: function(r, t, a) {
    var n = r.getUTCHours() % 12;
    return t === "Ko" ? a.ordinalNumber(n, {
      unit: "hour"
    }) : L(n, t.length);
  },
  // Hour [1-24]
  k: function(r, t, a) {
    var n = r.getUTCHours();
    return n === 0 && (n = 24), t === "ko" ? a.ordinalNumber(n, {
      unit: "hour"
    }) : L(n, t.length);
  },
  // Minute
  m: function(r, t, a) {
    return t === "mo" ? a.ordinalNumber(r.getUTCMinutes(), {
      unit: "minute"
    }) : Ee.m(r, t);
  },
  // Second
  s: function(r, t, a) {
    return t === "so" ? a.ordinalNumber(r.getUTCSeconds(), {
      unit: "second"
    }) : Ee.s(r, t);
  },
  // Fraction of second
  S: function(r, t) {
    return Ee.S(r, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, t, a, n) {
    var i = n._originalDate || r, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Nr(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ae(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Ae(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, t, a, n) {
    var i = n._originalDate || r, o = i.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Nr(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ae(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Ae(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, t, a, n) {
    var i = n._originalDate || r, o = i.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ur(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Ae(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, t, a, n) {
    var i = n._originalDate || r, o = i.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ur(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Ae(o, ":");
    }
  },
  // Seconds timestamp
  t: function(r, t, a, n) {
    var i = n._originalDate || r, o = Math.floor(i.getTime() / 1e3);
    return L(o, t.length);
  },
  // Milliseconds timestamp
  T: function(r, t, a, n) {
    var i = n._originalDate || r, o = i.getTime();
    return L(o, t.length);
  }
};
function Ur(e, r) {
  var t = e > 0 ? "-" : "+", a = Math.abs(e), n = Math.floor(a / 60), i = a % 60;
  if (i === 0)
    return t + String(n);
  var o = r;
  return t + String(n) + o + L(i, 2);
}
function Nr(e, r) {
  if (e % 60 === 0) {
    var t = e > 0 ? "-" : "+";
    return t + L(Math.abs(e) / 60, 2);
  }
  return Ae(e, r);
}
function Ae(e, r) {
  var t = r || "", a = e > 0 ? "-" : "+", n = Math.abs(e), i = L(Math.floor(n / 60), 2), o = L(n % 60, 2);
  return a + i + t + o;
}
var Fr = function(r, t) {
  switch (r) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, aa = function(r, t) {
  switch (r) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, Eo = function(r, t) {
  var a = r.match(/(P+)(p+)?/) || [], n = a[1], i = a[2];
  if (!i)
    return Fr(r, t);
  var o;
  switch (n) {
    case "P":
      o = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = t.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Fr(n, t)).replace("{{time}}", aa(i, t));
}, cr = {
  p: aa,
  P: Eo
};
function ia(e) {
  var r = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return r.setUTCFullYear(e.getFullYear()), e.getTime() - r.getTime();
}
var So = ["D", "DD"], Po = ["YY", "YYYY"];
function oa(e) {
  return So.indexOf(e) !== -1;
}
function sa(e) {
  return Po.indexOf(e) !== -1;
}
function dt(e, r, t) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(r, "`) for formatting years to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(r, "`) for formatting years to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(r, "`) for formatting days of the month to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(r, "`) for formatting days of the month to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Io = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ao = function(r, t, a) {
  var n, i = Io[r];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + n : n + " ago" : n;
};
function vt(e) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = r.width ? String(r.width) : e.defaultWidth, a = e.formats[t] || e.formats[e.defaultWidth];
    return a;
  };
}
var qo = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ro = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Vo = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Lo = {
  date: vt({
    formats: qo,
    defaultWidth: "full"
  }),
  time: vt({
    formats: Ro,
    defaultWidth: "full"
  }),
  dateTime: vt({
    formats: Vo,
    defaultWidth: "full"
  })
}, Uo = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, No = function(r, t, a, n) {
  return Uo[r];
};
function Ze(e) {
  return function(r, t) {
    var a = t != null && t.context ? String(t.context) : "standalone", n;
    if (a === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = t != null && t.width ? String(t.width) : i;
      n = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, u = t != null && t.width ? String(t.width) : e.defaultWidth;
      n = e.values[u] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(r) : r;
    return n[l];
  };
}
var Fo = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Wo = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, jo = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Ho = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Bo = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Yo = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, zo = function(r, t) {
  var a = Number(r), n = a % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, Go = {
  ordinalNumber: zo,
  era: Ze({
    values: Fo,
    defaultWidth: "wide"
  }),
  quarter: Ze({
    values: Wo,
    defaultWidth: "wide",
    argumentCallback: function(r) {
      return r - 1;
    }
  }),
  month: Ze({
    values: jo,
    defaultWidth: "wide"
  }),
  day: Ze({
    values: Ho,
    defaultWidth: "wide"
  }),
  dayPeriod: Ze({
    values: Bo,
    defaultWidth: "wide",
    formattingValues: Yo,
    defaultFormattingWidth: "wide"
  })
};
function Xe(e) {
  return function(r) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = t.width, n = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], i = r.match(n);
    if (!i)
      return null;
    var o = i[0], s = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? Ko(s, function(h) {
      return h.test(o);
    }) : Qo(s, function(h) {
      return h.test(o);
    }), l;
    l = e.valueCallback ? e.valueCallback(u) : u, l = t.valueCallback ? t.valueCallback(l) : l;
    var d = r.slice(o.length);
    return {
      value: l,
      rest: d
    };
  };
}
function Qo(e, r) {
  for (var t in e)
    if (e.hasOwnProperty(t) && r(e[t]))
      return t;
}
function Ko(e, r) {
  for (var t = 0; t < e.length; t++)
    if (r(e[t]))
      return t;
}
function Zo(e) {
  return function(r) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.match(e.matchPattern);
    if (!a) return null;
    var n = a[0], i = r.match(e.parsePattern);
    if (!i) return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    var s = r.slice(n.length);
    return {
      value: o,
      rest: s
    };
  };
}
var Xo = /^(\d+)(th|st|nd|rd)?/i, Jo = /\d+/i, es = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ts = {
  any: [/^b/i, /^(a|c)/i]
}, rs = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ns = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, as = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, is = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, os = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ss = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ls = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, us = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ds = {
  ordinalNumber: Zo({
    matchPattern: Xo,
    parsePattern: Jo,
    valueCallback: function(r) {
      return parseInt(r, 10);
    }
  }),
  era: Xe({
    matchPatterns: es,
    defaultMatchWidth: "wide",
    parsePatterns: ts,
    defaultParseWidth: "any"
  }),
  quarter: Xe({
    matchPatterns: rs,
    defaultMatchWidth: "wide",
    parsePatterns: ns,
    defaultParseWidth: "any",
    valueCallback: function(r) {
      return r + 1;
    }
  }),
  month: Xe({
    matchPatterns: as,
    defaultMatchWidth: "wide",
    parsePatterns: is,
    defaultParseWidth: "any"
  }),
  day: Xe({
    matchPatterns: os,
    defaultMatchWidth: "wide",
    parsePatterns: ss,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xe({
    matchPatterns: ls,
    defaultMatchWidth: "any",
    parsePatterns: us,
    defaultParseWidth: "any"
  })
}, la = {
  code: "en-US",
  formatDistance: Ao,
  formatLong: Lo,
  formatRelative: No,
  localize: Go,
  match: ds,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, cs = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fs = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hs = /^'([^]*?)'?$/, ms = /''/g, ps = /[a-zA-Z]/;
function it(e, r, t) {
  var a, n, i, o, s, u, l, d, h, y, v, c, f, p;
  te(2, arguments);
  var b = String(r), $ = Qe(), q = (a = (n = void 0) !== null && n !== void 0 ? n : $.locale) !== null && a !== void 0 ? a : la, j = me((i = (o = (s = (u = void 0) !== null && u !== void 0 ? u : void 0) !== null && s !== void 0 ? s : $.firstWeekContainsDate) !== null && o !== void 0 ? o : (l = $.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(j >= 1 && j <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ne = me((h = (y = (v = (c = void 0) !== null && c !== void 0 ? c : void 0) !== null && v !== void 0 ? v : $.weekStartsOn) !== null && y !== void 0 ? y : (f = $.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(ne >= 0 && ne <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!q.localize)
    throw new RangeError("locale must contain localize property");
  if (!q.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var oe = le(e);
  if (!Jn(oe))
    throw new RangeError("Invalid time value");
  var ge = ia(oe), ae = ea(oe, ge), pe = {
    firstWeekContainsDate: j,
    weekStartsOn: ne,
    locale: q,
    _originalDate: oe
  }, de = b.match(fs).map(function(H) {
    var B = H[0];
    if (B === "p" || B === "P") {
      var R = cr[B];
      return R(H, q.formatLong);
    }
    return H;
  }).join("").match(cs).map(function(H) {
    if (H === "''")
      return "'";
    var B = H[0];
    if (B === "'")
      return ws(H);
    var R = Mo[B];
    if (R)
      return sa(H) && dt(H, r, String(e)), oa(H) && dt(H, r, String(e)), R(ae, H, q.localize, pe);
    if (B.match(ps))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + B + "`");
    return H;
  }).join("");
  return de;
}
function ws(e) {
  var r = e.match(hs);
  return r ? r[1].replace(ms, "'") : e;
}
var ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yt, Wr;
function ua() {
  if (Wr) return yt;
  Wr = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return yt = e, yt;
}
var bt, jr;
function gs() {
  if (jr) return bt;
  jr = 1;
  var e = typeof ot == "object" && ot && ot.Object === Object && ot;
  return bt = e, bt;
}
var Ct, Hr;
function da() {
  if (Hr) return Ct;
  Hr = 1;
  var e = gs(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return Ct = t, Ct;
}
var xt, Br;
function vs() {
  if (Br) return xt;
  Br = 1;
  var e = da(), r = function() {
    return e.Date.now();
  };
  return xt = r, xt;
}
var _t, Yr;
function ys() {
  if (Yr) return _t;
  Yr = 1;
  var e = /\s/;
  function r(t) {
    for (var a = t.length; a-- && e.test(t.charAt(a)); )
      ;
    return a;
  }
  return _t = r, _t;
}
var Tt, zr;
function bs() {
  if (zr) return Tt;
  zr = 1;
  var e = ys(), r = /^\s+/;
  function t(a) {
    return a && a.slice(0, e(a) + 1).replace(r, "");
  }
  return Tt = t, Tt;
}
var Dt, Gr;
function br() {
  if (Gr) return Dt;
  Gr = 1;
  var e = da(), r = e.Symbol;
  return Dt = r, Dt;
}
var $t, Qr;
function Cs() {
  if (Qr) return $t;
  Qr = 1;
  var e = br(), r = Object.prototype, t = r.hasOwnProperty, a = r.toString, n = e ? e.toStringTag : void 0;
  function i(o) {
    var s = t.call(o, n), u = o[n];
    try {
      o[n] = void 0;
      var l = !0;
    } catch {
    }
    var d = a.call(o);
    return l && (s ? o[n] = u : delete o[n]), d;
  }
  return $t = i, $t;
}
var Ot, Kr;
function xs() {
  if (Kr) return Ot;
  Kr = 1;
  var e = Object.prototype, r = e.toString;
  function t(a) {
    return r.call(a);
  }
  return Ot = t, Ot;
}
var kt, Zr;
function ca() {
  if (Zr) return kt;
  Zr = 1;
  var e = br(), r = Cs(), t = xs(), a = "[object Null]", n = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? n : a : i && i in Object(s) ? r(s) : t(s);
  }
  return kt = o, kt;
}
var Mt, Xr;
function fa() {
  if (Xr) return Mt;
  Xr = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return Mt = e, Mt;
}
var Et, Jr;
function ha() {
  if (Jr) return Et;
  Jr = 1;
  var e = ca(), r = fa(), t = "[object Symbol]";
  function a(n) {
    return typeof n == "symbol" || r(n) && e(n) == t;
  }
  return Et = a, Et;
}
var St, en;
function _s() {
  if (en) return St;
  en = 1;
  var e = bs(), r = ua(), t = ha(), a = NaN, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function u(l) {
    if (typeof l == "number")
      return l;
    if (t(l))
      return a;
    if (r(l)) {
      var d = typeof l.valueOf == "function" ? l.valueOf() : l;
      l = r(d) ? d + "" : d;
    }
    if (typeof l != "string")
      return l === 0 ? l : +l;
    l = e(l);
    var h = i.test(l);
    return h || o.test(l) ? s(l.slice(2), h ? 2 : 8) : n.test(l) ? a : +l;
  }
  return St = u, St;
}
var Pt, tn;
function Ts() {
  if (tn) return Pt;
  tn = 1;
  var e = ua(), r = vs(), t = _s(), a = "Expected a function", n = Math.max, i = Math.min;
  function o(s, u, l) {
    var d, h, y, v, c, f, p = 0, b = !1, $ = !1, q = !0;
    if (typeof s != "function")
      throw new TypeError(a);
    u = t(u) || 0, e(l) && (b = !!l.leading, $ = "maxWait" in l, y = $ ? n(t(l.maxWait) || 0, u) : y, q = "trailing" in l ? !!l.trailing : q);
    function j(R) {
      var ue = d, ce = h;
      return d = h = void 0, p = R, v = s.apply(ce, ue), v;
    }
    function ne(R) {
      return p = R, c = setTimeout(ae, u), b ? j(R) : v;
    }
    function oe(R) {
      var ue = R - f, ce = R - p, Te = u - ue;
      return $ ? i(Te, y - ce) : Te;
    }
    function ge(R) {
      var ue = R - f, ce = R - p;
      return f === void 0 || ue >= u || ue < 0 || $ && ce >= y;
    }
    function ae() {
      var R = r();
      if (ge(R))
        return pe(R);
      c = setTimeout(ae, oe(R));
    }
    function pe(R) {
      return c = void 0, q && d ? j(R) : (d = h = void 0, v);
    }
    function de() {
      c !== void 0 && clearTimeout(c), p = 0, d = f = h = c = void 0;
    }
    function H() {
      return c === void 0 ? v : pe(r());
    }
    function B() {
      var R = r(), ue = ge(R);
      if (d = arguments, h = this, f = R, ue) {
        if (c === void 0)
          return ne(f);
        if ($)
          return clearTimeout(c), c = setTimeout(ae, u), j(f);
      }
      return c === void 0 && (c = setTimeout(ae, u)), v;
    }
    return B.cancel = de, B.flush = H, B;
  }
  return Pt = o, Pt;
}
var Ds = Ts();
const $s = /* @__PURE__ */ yr(Ds);
function rn(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, a = Array(r); t < r; t++) a[t] = e[t];
  return a;
}
function Os(e, r) {
  if (e) {
    if (typeof e == "string") return rn(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? rn(e, r) : void 0;
  }
}
function nn(e, r) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!t) {
    if (Array.isArray(e) || (t = Os(e)) || r) {
      t && (e = t);
      var a = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return a >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[a++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      t = t.call(e);
    },
    n: function() {
      var l = t.next();
      return o = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        o || t.return == null || t.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function ks(e, r) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var t in r)
    Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
  return e;
}
function x(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fr(e, r) {
  return fr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, a) {
    return t.__proto__ = a, t;
  }, fr(e, r);
}
function I(e, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), r && fr(e, r);
}
function ct(e) {
  return ct = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ct(e);
}
function ma() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ma = function() {
    return !!e;
  })();
}
function Ms(e, r) {
  if (r && (Oe(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return x(e);
}
function A(e) {
  var r = ma();
  return function() {
    var t, a = ct(e);
    if (r) {
      var n = ct(this).constructor;
      t = Reflect.construct(a, arguments, n);
    } else t = a.apply(this, arguments);
    return Ms(this, t);
  };
}
function M(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function Es(e, r) {
  if (Oe(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r || "default");
    if (Oe(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function pa(e) {
  var r = Es(e, "string");
  return Oe(r) == "symbol" ? r : r + "";
}
function Ss(e, r) {
  for (var t = 0; t < r.length; t++) {
    var a = r[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, pa(a.key), a);
  }
}
function E(e, r, t) {
  return r && Ss(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function C(e, r, t) {
  return (r = pa(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var Ps = 10, wa = /* @__PURE__ */ function() {
  function e() {
    M(this, e), C(this, "priority", void 0), C(this, "subPriority", 0);
  }
  return E(e, [{
    key: "validate",
    value: function(t, a) {
      return !0;
    }
  }]), e;
}(), Is = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t(a, n, i, o, s) {
    var u;
    return M(this, t), u = r.call(this), u.value = a, u.validateValue = n, u.setValue = i, u.priority = o, s && (u.subPriority = s), u;
  }
  return E(t, [{
    key: "validate",
    value: function(n, i) {
      return this.validateValue(n, this.value, i);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return this.setValue(n, i, this.value, o);
    }
  }]), t;
}(wa), As = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", Ps), C(x(a), "subPriority", -1), a;
  }
  return E(t, [{
    key: "set",
    value: function(n, i) {
      if (i.timestampIsSet)
        return n;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), o.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), o;
    }
  }]), t;
}(wa), V = /* @__PURE__ */ function() {
  function e() {
    M(this, e), C(this, "incompatibleTokens", void 0), C(this, "priority", void 0), C(this, "subPriority", void 0);
  }
  return E(e, [{
    key: "run",
    value: function(t, a, n, i) {
      var o = this.parse(t, a, n, i);
      return o ? {
        setter: new Is(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(t, a, n) {
      return !0;
    }
  }]), e;
}(), qs = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 140), C(x(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return o.era(n, {
            width: "abbreviated"
          }) || o.era(n, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return o.era(n, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return o.era(n, {
            width: "wide"
          }) || o.era(n, {
            width: "abbreviated"
          }) || o.era(n, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return i.era = o, n.setUTCFullYear(o, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), Rs = 6e4, Vs = 36e5, Ls = 1e3, Z = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ce = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function X(e, r) {
  return e && {
    value: r(e.value),
    rest: e.rest
  };
}
function G(e, r) {
  var t = r.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: r.slice(t[0].length)
  } : null;
}
function xe(e, r) {
  var t = r.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  var a = t[1] === "+" ? 1 : -1, n = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, o = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (n * Vs + i * Rs + o * Ls),
    rest: r.slice(t[0].length)
  };
}
function ga(e) {
  return G(Z.anyDigitsSigned, e);
}
function K(e, r) {
  switch (e) {
    case 1:
      return G(Z.singleDigit, r);
    case 2:
      return G(Z.twoDigits, r);
    case 3:
      return G(Z.threeDigits, r);
    case 4:
      return G(Z.fourDigits, r);
    default:
      return G(new RegExp("^\\d{1," + e + "}"), r);
  }
}
function ft(e, r) {
  switch (e) {
    case 1:
      return G(Z.singleDigitSigned, r);
    case 2:
      return G(Z.twoDigitsSigned, r);
    case 3:
      return G(Z.threeDigitsSigned, r);
    case 4:
      return G(Z.fourDigitsSigned, r);
    default:
      return G(new RegExp("^-?\\d{1," + e + "}"), r);
  }
}
function Cr(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function va(e, r) {
  var t = r > 0, a = t ? r : 1 - r, n;
  if (a <= 50)
    n = e || 100;
  else {
    var i = a + 50, o = Math.floor(i / 100) * 100, s = e >= i % 100;
    n = e + o - (s ? 100 : 0);
  }
  return t ? n : 1 - n;
}
function ya(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var Us = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 130), C(x(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return X(K(4, n), s);
        case "yo":
          return X(o.ordinalNumber(n, {
            unit: "year"
          }), s);
        default:
          return X(K(i.length, n), s);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = n.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var u = va(o.year, s);
        return n.setUTCFullYear(u, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
      }
      var l = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return n.setUTCFullYear(l, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), Ns = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 130), C(x(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return X(K(4, n), s);
        case "Yo":
          return X(o.ordinalNumber(n, {
            unit: "year"
          }), s);
        default:
          return X(K(i.length, n), s);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      var u = vr(n, s);
      if (o.isTwoDigitYear) {
        var l = va(o.year, u);
        return n.setUTCFullYear(l, 0, s.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), Re(n, s);
      }
      var d = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return n.setUTCFullYear(d, 0, s.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), Re(n, s);
    }
  }]), t;
}(V), Fs = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 130), C(x(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i) {
      return ft(i === "R" ? 4 : i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), Ye(s);
    }
  }]), t;
}(V), Ws = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 130), C(x(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i) {
      return ft(i === "u" ? 4 : i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCFullYear(o, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), js = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 120), C(x(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return K(i.length, n);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return o.ordinalNumber(n, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return o.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return o.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return o.quarter(n, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth((o - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), Hs = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 120), C(x(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return K(i.length, n);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return o.ordinalNumber(n, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return o.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return o.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return o.quarter(n, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth((o - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), Bs = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), C(x(a), "priority", 110), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(l) {
        return l - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "M":
          return X(G(Z.month, n), s);
        // 01, 02, ..., 12
        case "MM":
          return X(K(2, n), s);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return X(o.ordinalNumber(n, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "MMM":
          return o.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(n, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return o.month(n, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return o.month(n, {
            width: "wide",
            context: "formatting"
          }) || o.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth(o, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), Ys = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 110), C(x(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(l) {
        return l - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "L":
          return X(G(Z.month, n), s);
        // 01, 02, ..., 12
        case "LL":
          return X(K(2, n), s);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return X(o.ordinalNumber(n, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "LLL":
          return o.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(n, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return o.month(n, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return o.month(n, {
            width: "wide",
            context: "standalone"
          }) || o.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth(o, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V);
function zs(e, r, t) {
  te(2, arguments);
  var a = le(e), n = me(r), i = na(a, t) - n;
  return a.setUTCDate(a.getUTCDate() - i * 7), a;
}
var Gs = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 100), C(x(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "w":
          return G(Z.week, n);
        case "wo":
          return o.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return Re(zs(n, o, s), s);
    }
  }]), t;
}(V);
function Qs(e, r) {
  te(2, arguments);
  var t = le(e), a = me(r), n = ra(t) - a;
  return t.setUTCDate(t.getUTCDate() - n * 7), t;
}
var Ks = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 100), C(x(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "I":
          return G(Z.week, n);
        case "Io":
          return o.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return Ye(Qs(n, o));
    }
  }]), t;
}(V), Zs = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Xs = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Js = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 90), C(x(a), "subPriority", 1), C(x(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "d":
          return G(Z.date, n);
        case "do":
          return o.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var o = n.getUTCFullYear(), s = ya(o), u = n.getUTCMonth();
      return s ? i >= 1 && i <= Xs[u] : i >= 1 && i <= Zs[u];
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCDate(o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), el = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 90), C(x(a), "subpriority", 1), C(x(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return G(Z.dayOfYear, n);
        case "Do":
          return o.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var o = n.getUTCFullYear(), s = ya(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth(0, o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V);
function xr(e, r, t) {
  var a, n, i, o, s, u, l, d;
  te(2, arguments);
  var h = Qe(), y = me((a = (n = (i = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && i !== void 0 ? i : h.weekStartsOn) !== null && n !== void 0 ? n : (l = h.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = le(e), c = me(r), f = v.getUTCDay(), p = c % 7, b = (p + 7) % 7, $ = (b < y ? 7 : 0) + c - f;
  return v.setUTCDate(v.getUTCDate() + $), v;
}
var tl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 90), C(x(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return n = xr(n, o, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), rl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 90), C(x(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o, s) {
      var u = function(d) {
        var h = Math.floor((d - 1) / 7) * 7;
        return (d + s.weekStartsOn + 6) % 7 + h;
      };
      switch (i) {
        // 3
        case "e":
        case "ee":
          return X(K(i.length, n), u);
        // 3rd
        case "eo":
          return X(o.ordinalNumber(n, {
            unit: "day"
          }), u);
        // Tue
        case "eee":
          return o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return n = xr(n, o, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), nl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 90), C(x(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o, s) {
      var u = function(d) {
        var h = Math.floor((d - 1) / 7) * 7;
        return (d + s.weekStartsOn + 6) % 7 + h;
      };
      switch (i) {
        // 3
        case "c":
        case "cc":
          return X(K(i.length, n), u);
        // 3rd
        case "co":
          return X(o.ordinalNumber(n, {
            unit: "day"
          }), u);
        // Tue
        case "ccc":
          return o.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(n, {
            width: "short",
            context: "standalone"
          }) || o.day(n, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return o.day(n, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return o.day(n, {
            width: "short",
            context: "standalone"
          }) || o.day(n, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return o.day(n, {
            width: "wide",
            context: "standalone"
          }) || o.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(n, {
            width: "short",
            context: "standalone"
          }) || o.day(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return n = xr(n, o, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V);
function al(e, r) {
  te(2, arguments);
  var t = me(r);
  t % 7 === 0 && (t = t - 7);
  var a = 1, n = le(e), i = n.getUTCDay(), o = t % 7, s = (o + 7) % 7, u = (s < a ? 7 : 0) + t - i;
  return n.setUTCDate(n.getUTCDate() + u), n;
}
var il = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 90), C(x(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(l) {
        return l === 0 ? 7 : l;
      };
      switch (i) {
        // 2
        case "i":
        case "ii":
          return K(i.length, n);
        // 2nd
        case "io":
          return o.ordinalNumber(n, {
            unit: "day"
          });
        // Tue
        case "iii":
          return X(o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
        // T
        case "iiiii":
          return X(o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tu
        case "iiiiii":
          return X(o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tuesday
        case "iiii":
        default:
          return X(o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n = al(n, o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), t;
}(V), ol = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 80), C(x(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(Cr(o), 0, 0, 0), n;
    }
  }]), t;
}(V), sl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 80), C(x(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(Cr(o), 0, 0, 0), n;
    }
  }]), t;
}(V), ll = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 80), C(x(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(Cr(o), 0, 0, 0), n;
    }
  }]), t;
}(V), ul = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 70), C(x(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "h":
          return G(Z.hour12h, n);
        case "ho":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = n.getUTCHours() >= 12;
      return s && o < 12 ? n.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? n.setUTCHours(0, 0, 0, 0) : n.setUTCHours(o, 0, 0, 0), n;
    }
  }]), t;
}(V), dl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 70), C(x(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "H":
          return G(Z.hour23h, n);
        case "Ho":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(o, 0, 0, 0), n;
    }
  }]), t;
}(V), cl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 70), C(x(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "K":
          return G(Z.hour11h, n);
        case "Ko":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = n.getUTCHours() >= 12;
      return s && o < 12 ? n.setUTCHours(o + 12, 0, 0, 0) : n.setUTCHours(o, 0, 0, 0), n;
    }
  }]), t;
}(V), fl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 70), C(x(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "k":
          return G(Z.hour24h, n);
        case "ko":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return n.setUTCHours(s, 0, 0, 0), n;
    }
  }]), t;
}(V), hl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 60), C(x(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "m":
          return G(Z.minute, n);
        case "mo":
          return o.ordinalNumber(n, {
            unit: "minute"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMinutes(o, 0, 0), n;
    }
  }]), t;
}(V), ml = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 50), C(x(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "s":
          return G(Z.second, n);
        case "so":
          return o.ordinalNumber(n, {
            unit: "second"
          });
        default:
          return K(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCSeconds(o, 0), n;
    }
  }]), t;
}(V), pl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 30), C(x(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i) {
      var o = function(u) {
        return Math.floor(u * Math.pow(10, -i.length + 3));
      };
      return X(K(i.length, n), o);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMilliseconds(o), n;
    }
  }]), t;
}(V), wl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 10), C(x(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "X":
          return xe(Ce.basicOptionalMinutes, n);
        case "XX":
          return xe(Ce.basic, n);
        case "XXXX":
          return xe(Ce.basicOptionalSeconds, n);
        case "XXXXX":
          return xe(Ce.extendedOptionalSeconds, n);
        case "XXX":
        default:
          return xe(Ce.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return i.timestampIsSet ? n : new Date(n.getTime() - o);
    }
  }]), t;
}(V), gl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 10), C(x(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "x":
          return xe(Ce.basicOptionalMinutes, n);
        case "xx":
          return xe(Ce.basic, n);
        case "xxxx":
          return xe(Ce.basicOptionalSeconds, n);
        case "xxxxx":
          return xe(Ce.extendedOptionalSeconds, n);
        case "xxx":
        default:
          return xe(Ce.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return i.timestampIsSet ? n : new Date(n.getTime() - o);
    }
  }]), t;
}(V), vl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 40), C(x(a), "incompatibleTokens", "*"), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n) {
      return ga(n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), t;
}(V), yl = /* @__PURE__ */ function(e) {
  I(t, e);
  var r = A(t);
  function t() {
    var a;
    M(this, t);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = r.call.apply(r, [this].concat(i)), C(x(a), "priority", 20), C(x(a), "incompatibleTokens", "*"), a;
  }
  return E(t, [{
    key: "parse",
    value: function(n) {
      return ga(n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), t;
}(V), bl = {
  G: new qs(),
  y: new Us(),
  Y: new Ns(),
  R: new Fs(),
  u: new Ws(),
  Q: new js(),
  q: new Hs(),
  M: new Bs(),
  L: new Ys(),
  w: new Gs(),
  I: new Ks(),
  d: new Js(),
  D: new el(),
  E: new tl(),
  e: new rl(),
  c: new nl(),
  i: new il(),
  a: new ol(),
  b: new sl(),
  B: new ll(),
  h: new ul(),
  H: new dl(),
  K: new cl(),
  k: new fl(),
  m: new hl(),
  s: new ml(),
  S: new pl(),
  X: new wl(),
  x: new gl(),
  t: new vl(),
  T: new yl()
}, Cl = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, xl = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _l = /^'([^]*?)'?$/, Tl = /''/g, Dl = /\S/, $l = /[a-zA-Z]/;
function Ol(e, r, t, a) {
  var n, i, o, s, u, l, d, h, y, v, c, f, p, b;
  te(3, arguments);
  var $ = String(e), q = String(r), j = Qe(), ne = (n = (i = void 0) !== null && i !== void 0 ? i : j.locale) !== null && n !== void 0 ? n : la;
  if (!ne.match)
    throw new RangeError("locale must contain match property");
  var oe = me((o = (s = (u = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && u !== void 0 ? u : j.firstWeekContainsDate) !== null && s !== void 0 ? s : (d = j.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(oe >= 1 && oe <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ge = me((y = (v = (c = (f = void 0) !== null && f !== void 0 ? f : void 0) !== null && c !== void 0 ? c : j.weekStartsOn) !== null && v !== void 0 ? v : (p = j.locale) === null || p === void 0 || (b = p.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && y !== void 0 ? y : 0);
  if (!(ge >= 0 && ge <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (q === "")
    return $ === "" ? le(t) : /* @__PURE__ */ new Date(NaN);
  var ae = {
    firstWeekContainsDate: oe,
    weekStartsOn: ge,
    locale: ne
  }, pe = [new As()], de = q.match(xl).map(function(J) {
    var N = J[0];
    if (N in cr) {
      var ye = cr[N];
      return ye(J, ne.formatLong);
    }
    return J;
  }).join("").match(Cl), H = [], B = nn(de), R;
  try {
    var ue = function() {
      var N = R.value;
      !(a != null && a.useAdditionalWeekYearTokens) && sa(N) && dt(N, q, e), !(a != null && a.useAdditionalDayOfYearTokens) && oa(N) && dt(N, q, e);
      var ye = N[0], at = bl[ye];
      if (at) {
        var Sr = at.incompatibleTokens;
        if (Array.isArray(Sr)) {
          var Pr = H.find(function(Ir) {
            return Sr.includes(Ir.token) || Ir.token === ye;
          });
          if (Pr)
            throw new RangeError("The format string mustn't contain `".concat(Pr.fullToken, "` and `").concat(N, "` at the same time"));
        } else if (at.incompatibleTokens === "*" && H.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(N, "` and any other token at the same time"));
        H.push({
          token: ye,
          fullToken: N
        });
        var gt = at.run($, N, ne.match, ae);
        if (!gt)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        pe.push(gt.setter), $ = gt.rest;
      } else {
        if (ye.match($l))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + ye + "`");
        if (N === "''" ? N = "'" : ye === "'" && (N = kl(N)), $.indexOf(N) === 0)
          $ = $.slice(N.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (B.s(); !(R = B.n()).done; ) {
      var ce = ue();
      if (Oe(ce) === "object") return ce.v;
    }
  } catch (J) {
    B.e(J);
  } finally {
    B.f();
  }
  if ($.length > 0 && Dl.test($))
    return /* @__PURE__ */ new Date(NaN);
  var Te = pe.map(function(J) {
    return J.priority;
  }).sort(function(J, N) {
    return N - J;
  }).filter(function(J, N, ye) {
    return ye.indexOf(J) === N;
  }).map(function(J) {
    return pe.filter(function(N) {
      return N.priority === J;
    }).sort(function(N, ye) {
      return ye.subPriority - N.subPriority;
    });
  }).map(function(J) {
    return J[0];
  }), Me = le(t);
  if (isNaN(Me.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var De = ea(Me, ia(Me)), Le = {}, U = nn(Te), ve;
  try {
    for (U.s(); !(ve = U.n()).done; ) {
      var we = ve.value;
      if (!we.validate(De, ae))
        return /* @__PURE__ */ new Date(NaN);
      var Ue = we.set(De, Le, ae);
      Array.isArray(Ue) ? (De = Ue[0], ks(Le, Ue[1])) : De = Ue;
    }
  } catch (J) {
    U.e(J);
  } finally {
    U.f();
  }
  return De;
}
function kl(e) {
  return e.match(_l)[1].replace(Tl, "'");
}
var It, an;
function Ml() {
  if (an) return It;
  an = 1;
  function e(r, t) {
    for (var a = -1, n = r == null ? 0 : r.length, i = Array(n); ++a < n; )
      i[a] = t(r[a], a, r);
    return i;
  }
  return It = e, It;
}
var At, on;
function El() {
  if (on) return At;
  on = 1;
  var e = Array.isArray;
  return At = e, At;
}
var qt, sn;
function Sl() {
  if (sn) return qt;
  sn = 1;
  var e = br(), r = Ml(), t = El(), a = ha(), n = e ? e.prototype : void 0, i = n ? n.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (t(s))
      return r(s, o) + "";
    if (a(s))
      return i ? i.call(s) : "";
    var u = s + "";
    return u == "0" && 1 / s == -1 / 0 ? "-0" : u;
  }
  return qt = o, qt;
}
var Rt, ln;
function wt() {
  if (ln) return Rt;
  ln = 1;
  var e = Sl();
  function r(t) {
    return t == null ? "" : e(t);
  }
  return Rt = r, Rt;
}
var Vt, un;
function Pl() {
  if (un) return Vt;
  un = 1;
  function e(r, t, a) {
    var n = -1, i = r.length;
    t < 0 && (t = -t > i ? 0 : i + t), a = a > i ? i : a, a < 0 && (a += i), i = t > a ? 0 : a - t >>> 0, t >>>= 0;
    for (var o = Array(i); ++n < i; )
      o[n] = r[n + t];
    return o;
  }
  return Vt = e, Vt;
}
var Lt, dn;
function Il() {
  if (dn) return Lt;
  dn = 1;
  var e = Pl();
  function r(t, a, n) {
    var i = t.length;
    return n = n === void 0 ? i : n, !a && n >= i ? t : e(t, a, n);
  }
  return Lt = r, Lt;
}
var Ut, cn;
function ba() {
  if (cn) return Ut;
  cn = 1;
  var e = "\\ud800-\\udfff", r = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", a = "\\u20d0-\\u20ff", n = r + t + a, i = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + n + i + "]");
  function u(l) {
    return s.test(l);
  }
  return Ut = u, Ut;
}
var Nt, fn;
function Al() {
  if (fn) return Nt;
  fn = 1;
  function e(r) {
    return r.split("");
  }
  return Nt = e, Nt;
}
var Ft, hn;
function ql() {
  if (hn) return Ft;
  hn = 1;
  var e = "\\ud800-\\udfff", r = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", a = "\\u20d0-\\u20ff", n = r + t + a, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + n + "]", u = "\\ud83c[\\udffb-\\udfff]", l = "(?:" + s + "|" + u + ")", d = "[^" + e + "]", h = "(?:\\ud83c[\\udde6-\\uddff]){2}", y = "[\\ud800-\\udbff][\\udc00-\\udfff]", v = "\\u200d", c = l + "?", f = "[" + i + "]?", p = "(?:" + v + "(?:" + [d, h, y].join("|") + ")" + f + c + ")*", b = f + c + p, $ = "(?:" + [d + s + "?", s, h, y, o].join("|") + ")", q = RegExp(u + "(?=" + u + ")|" + $ + b, "g");
  function j(ne) {
    return ne.match(q) || [];
  }
  return Ft = j, Ft;
}
var Wt, mn;
function Rl() {
  if (mn) return Wt;
  mn = 1;
  var e = Al(), r = ba(), t = ql();
  function a(n) {
    return r(n) ? t(n) : e(n);
  }
  return Wt = a, Wt;
}
var jt, pn;
function Vl() {
  if (pn) return jt;
  pn = 1;
  var e = Il(), r = ba(), t = Rl(), a = wt();
  function n(i) {
    return function(o) {
      o = a(o);
      var s = r(o) ? t(o) : void 0, u = s ? s[0] : o.charAt(0), l = s ? e(s, 1).join("") : o.slice(1);
      return u[i]() + l;
    };
  }
  return jt = n, jt;
}
var Ht, wn;
function Ll() {
  if (wn) return Ht;
  wn = 1;
  var e = Vl(), r = e("toUpperCase");
  return Ht = r, Ht;
}
var Bt, gn;
function Ul() {
  if (gn) return Bt;
  gn = 1;
  var e = wt(), r = Ll();
  function t(a) {
    return r(e(a).toLowerCase());
  }
  return Bt = t, Bt;
}
var Yt, vn;
function Nl() {
  if (vn) return Yt;
  vn = 1;
  function e(r, t, a, n) {
    var i = -1, o = r == null ? 0 : r.length;
    for (n && o && (a = r[++i]); ++i < o; )
      a = t(a, r[i], i, r);
    return a;
  }
  return Yt = e, Yt;
}
var zt, yn;
function Fl() {
  if (yn) return zt;
  yn = 1;
  function e(r) {
    return function(t) {
      return r == null ? void 0 : r[t];
    };
  }
  return zt = e, zt;
}
var Gt, bn;
function Wl() {
  if (bn) return Gt;
  bn = 1;
  var e = Fl(), r = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, t = e(r);
  return Gt = t, Gt;
}
var Qt, Cn;
function jl() {
  if (Cn) return Qt;
  Cn = 1;
  var e = Wl(), r = wt(), t = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, a = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", i = "\\u20d0-\\u20ff", o = a + n + i, s = "[" + o + "]", u = RegExp(s, "g");
  function l(d) {
    return d = r(d), d && d.replace(t, e).replace(u, "");
  }
  return Qt = l, Qt;
}
var Kt, xn;
function Hl() {
  if (xn) return Kt;
  xn = 1;
  var e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function r(t) {
    return t.match(e) || [];
  }
  return Kt = r, Kt;
}
var Zt, _n;
function Bl() {
  if (_n) return Zt;
  _n = 1;
  var e = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function r(t) {
    return e.test(t);
  }
  return Zt = r, Zt;
}
var Xt, Tn;
function Yl() {
  if (Tn) return Xt;
  Tn = 1;
  var e = "\\ud800-\\udfff", r = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", a = "\\u20d0-\\u20ff", n = r + t + a, i = "\\u2700-\\u27bf", o = "a-z\\xdf-\\xf6\\xf8-\\xff", s = "\\xac\\xb1\\xd7\\xf7", u = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", l = "\\u2000-\\u206f", d = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", h = "A-Z\\xc0-\\xd6\\xd8-\\xde", y = "\\ufe0e\\ufe0f", v = s + u + l + d, c = "['’]", f = "[" + v + "]", p = "[" + n + "]", b = "\\d+", $ = "[" + i + "]", q = "[" + o + "]", j = "[^" + e + v + b + i + o + h + "]", ne = "\\ud83c[\\udffb-\\udfff]", oe = "(?:" + p + "|" + ne + ")", ge = "[^" + e + "]", ae = "(?:\\ud83c[\\udde6-\\uddff]){2}", pe = "[\\ud800-\\udbff][\\udc00-\\udfff]", de = "[" + h + "]", H = "\\u200d", B = "(?:" + q + "|" + j + ")", R = "(?:" + de + "|" + j + ")", ue = "(?:" + c + "(?:d|ll|m|re|s|t|ve))?", ce = "(?:" + c + "(?:D|LL|M|RE|S|T|VE))?", Te = oe + "?", Me = "[" + y + "]?", De = "(?:" + H + "(?:" + [ge, ae, pe].join("|") + ")" + Me + Te + ")*", Le = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", U = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ve = Me + Te + De, we = "(?:" + [$, ae, pe].join("|") + ")" + ve, Ue = RegExp([
    de + "?" + q + "+" + ue + "(?=" + [f, de, "$"].join("|") + ")",
    R + "+" + ce + "(?=" + [f, de + B, "$"].join("|") + ")",
    de + "?" + B + "+" + ue,
    de + "+" + ce,
    U,
    Le,
    b,
    we
  ].join("|"), "g");
  function J(N) {
    return N.match(Ue) || [];
  }
  return Xt = J, Xt;
}
var Jt, Dn;
function zl() {
  if (Dn) return Jt;
  Dn = 1;
  var e = Hl(), r = Bl(), t = wt(), a = Yl();
  function n(i, o, s) {
    return i = t(i), o = s ? void 0 : o, o === void 0 ? r(i) ? a(i) : e(i) : i.match(o) || [];
  }
  return Jt = n, Jt;
}
var er, $n;
function Gl() {
  if ($n) return er;
  $n = 1;
  var e = Nl(), r = jl(), t = zl(), a = "['’]", n = RegExp(a, "g");
  function i(o) {
    return function(s) {
      return e(t(r(s).replace(n, "")), o, "");
    };
  }
  return er = i, er;
}
var tr, On;
function Ql() {
  if (On) return tr;
  On = 1;
  var e = Ul(), r = Gl(), t = r(function(a, n, i) {
    return n = n.toLowerCase(), a + (i ? e(n) : n);
  });
  return tr = t, tr;
}
var Kl = Ql();
const Zl = /* @__PURE__ */ yr(Kl);
var rr, kn;
function Xl() {
  if (kn) return rr;
  kn = 1;
  function e(r, t) {
    return function(a) {
      return r(t(a));
    };
  }
  return rr = e, rr;
}
var nr, Mn;
function Jl() {
  if (Mn) return nr;
  Mn = 1;
  var e = Xl(), r = e(Object.getPrototypeOf, Object);
  return nr = r, nr;
}
var ar, En;
function eu() {
  if (En) return ar;
  En = 1;
  var e = ca(), r = Jl(), t = fa(), a = "[object Object]", n = Function.prototype, i = Object.prototype, o = n.toString, s = i.hasOwnProperty, u = o.call(Object);
  function l(d) {
    if (!t(d) || e(d) != a)
      return !1;
    var h = r(d);
    if (h === null)
      return !0;
    var y = s.call(h, "constructor") && h.constructor;
    return typeof y == "function" && y instanceof y && o.call(y) == u;
  }
  return ar = l, ar;
}
var tu = eu();
const ru = /* @__PURE__ */ yr(tu), nu = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "long",
  day: "numeric"
}), au = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}), iu = new Intl.DateTimeFormat("fr-ca"), Be = {
  getDay: (e = /* @__PURE__ */ new Date()) => ({
    date: e,
    day: e == null ? void 0 : e.getDate(),
    month: e == null ? void 0 : e.getMonth(),
    year: e == null ? void 0 : e.getFullYear()
  }),
  getMonth: (e = (/* @__PURE__ */ new Date()).getMonth(), r = (/* @__PURE__ */ new Date()).getFullYear()) => {
    const t = new Date(r, e, 1).getDay(), n = new Date(r, e + 1, 0).getDate() + t, i = (v, c) => {
      const f = [], p = new Date(c, v, -t + 1);
      for (let b = 0; b < t; b++)
        f.push(
          Be.getDay(
            new Date(
              p.getFullYear(),
              p.getMonth(),
              p.getDate() + b
            )
          )
        );
      return f;
    }, o = (v, c) => {
      let f = 1;
      const p = [];
      for (let b = 1; b <= n; b += 1)
        b > t && (p.push(Be.getDay(new Date(c, v, f))), f += 1);
      return p;
    }, s = (v, c, f) => {
      const p = [...f], b = u(p).slice(-1)[0].length, $ = [];
      for (let q = 1; q <= 7 - b; q++)
        $.push(Be.getDay(new Date(c, v + 1, q)));
      return $;
    }, u = (v) => {
      const c = [...v], f = [];
      for (; c.length; )
        f.push(c.splice(0, 7));
      return f;
    }, l = i(e, r), d = o(e, r), h = s(e, r, [
      ...l,
      ...d
    ]), y = [...l, ...d, ...h];
    return u(y);
  }
}, z = {
  weekDays: [
    {
      name: "Sunday",
      shortName: "SUN"
    },
    {
      name: "Monday",
      shortName: "MON"
    },
    {
      name: "Tuesday",
      shortName: "TUE"
    },
    {
      name: "Wednesday",
      shortName: "WED"
    },
    {
      name: "Thursday",
      shortName: "THU"
    },
    {
      name: "Friday",
      shortName: "FRI"
    },
    {
      name: "Saturday",
      shortName: "SAT"
    }
  ],
  months: [
    {
      name: "January",
      shortName: "JAN"
    },
    {
      name: "February",
      shortName: "FEB"
    },
    {
      name: "March",
      shortName: "MAR"
    },
    {
      name: "April",
      shortName: "APR"
    },
    {
      name: "May",
      shortName: "MAY"
    },
    {
      name: "June",
      shortName: "JUN"
    },
    {
      name: "July",
      shortName: "JUL"
    },
    {
      name: "August",
      shortName: "AUG"
    },
    {
      name: "September",
      shortName: "SEP"
    },
    {
      name: "October",
      shortName: "OCT"
    },
    {
      name: "November",
      shortName: "NOV"
    },
    {
      name: "December",
      shortName: "DEC"
    }
  ],
  formatLong: (e) => nu.format(e),
  formatShort: (e) => au.format(e),
  formatCanada: (e) => iu.format(e),
  getNextMonth: (e, r) => ({
    month: e === 11 ? 0 : e + 1,
    year: e === 11 ? r + 1 : r
  }),
  getPreviousMonth: (e, r) => ({
    month: e === 0 ? 11 : e - 1,
    year: e === 0 ? r - 1 : r
  }),
  isSameDate: (e, r) => e instanceof Date && r instanceof Date ? (e.setHours(0, 0, 0, 0), r.setHours(0, 0, 0, 0), e.getTime() === r.getTime()) : !1,
  getRange(e, r) {
    const t = [];
    e == null || e.setHours(0, 0, 0, 0), r == null || r.setHours(0, 0, 0, 0);
    const a = e;
    for (; e.getTime() <= r.getTime(); )
      t.push(new Date(a)), a.setDate(a.getDate() + 1), a.setHours(0, 0, 0, 0);
    return t;
  },
  getNumberOfDays(e, r) {
    return (r.getTime() - e.getTime()) / (1e3 * 3600 * 24) + 1;
  },
  isDateInRange: (e, r = []) => {
    const [t, a] = r;
    if (t == null || t.setHours(0, 0, 0, 0), a == null || a.setHours(0, 0, 0, 0), t && a)
      return e.getTime() >= t.getTime() && e.getTime() <= a.getTime();
    if (t && !a)
      return e.getTime() >= t.getTime();
    if (a && !t)
      return e.getTime() <= a.getTime();
    if (!t && !a)
      return !0;
  },
  resetTime(e) {
    const r = new Date(e);
    return r.setHours(0, 0, 0, 0), r;
  }
}, Ca = (e) => Object.entries(e).reduce((r, [t, a]) => (ru(a) && (a = Ca(a)), r[Zl(t)] = a, r), {}), xa = gr ? window : void 0;
function et(e) {
  var r;
  const t = ie(e);
  return (r = t == null ? void 0 : t.$el) != null ? r : t;
}
function We(...e) {
  const r = [], t = () => {
    r.forEach((s) => s()), r.length = 0;
  }, a = (s, u, l, d) => (s.addEventListener(u, l, d), () => s.removeEventListener(u, l, d)), n = W(() => {
    const s = He(ie(e[0])).filter((u) => u != null);
    return s.every((u) => typeof u != "string") ? s : void 0;
  }), i = Bn(
    () => {
      var s, u;
      return [
        (u = (s = n.value) == null ? void 0 : s.map((l) => et(l))) != null ? u : [xa].filter((l) => l != null),
        He(ie(n.value ? e[1] : e[0])),
        He(S(n.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ie(n.value ? e[3] : e[2])
      ];
    },
    ([s, u, l, d]) => {
      if (t(), !(s != null && s.length) || !(u != null && u.length) || !(l != null && l.length))
        return;
      const h = Hn(d) ? { ...d } : d;
      r.push(
        ...s.flatMap(
          (y) => u.flatMap(
            (v) => l.map((c) => a(y, v, c, h))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    i(), t();
  };
  return wr(t), o;
}
let Sn = !1;
function Pn(e, r, t = {}) {
  const { window: a = xa, ignore: n = [], capture: i = !0, detectIframe: o = !1 } = t;
  if (!a)
    return qe;
  if (ut && !Sn) {
    Sn = !0;
    const f = { passive: !0 };
    Array.from(a.document.body.children).forEach((p) => We(p, "click", qe, f)), We(a.document.documentElement, "click", qe, f);
  }
  let s = !0;
  const u = (f) => ie(n).some((p) => {
    if (typeof p == "string")
      return Array.from(a.document.querySelectorAll(p)).some((b) => b === f.target || f.composedPath().includes(b));
    {
      const b = et(p);
      return b && (f.target === b || f.composedPath().includes(b));
    }
  });
  function l(f) {
    const p = ie(f);
    return p && p.$.subTree.shapeFlag === 16;
  }
  function d(f, p) {
    const b = ie(f), $ = b.$.subTree && b.$.subTree.children;
    return $ == null || !Array.isArray($) ? !1 : $.some((q) => q.el === p.target || p.composedPath().includes(q.el));
  }
  const h = (f) => {
    const p = et(e);
    if (f.target != null && !(!(p instanceof Element) && l(e) && d(e, f)) && !(!p || p === f.target || f.composedPath().includes(p))) {
      if (f.detail === 0 && (s = !u(f)), !s) {
        s = !0;
        return;
      }
      r(f);
    }
  };
  let y = !1;
  const v = [
    We(a, "click", (f) => {
      y || (y = !0, setTimeout(() => {
        y = !1;
      }, 0), h(f));
    }, { passive: !0, capture: i }),
    We(a, "pointerdown", (f) => {
      const p = et(e);
      s = !u(f) && !!(p && !f.composedPath().includes(p));
    }, { passive: !0 }),
    o && We(a, "blur", (f) => {
      setTimeout(() => {
        var p;
        const b = et(e);
        ((p = a.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(b != null && b.contains(a.document.activeElement)) && r(f);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean);
  return () => v.forEach((f) => f());
}
const ou = {
  mounted(e, r) {
    const t = !r.modifiers.bubble;
    if (typeof r.value == "function")
      e.__onClickOutside_stop = Pn(e, r.value, { capture: t });
    else {
      const [a, n] = r.value;
      e.__onClickOutside_stop = Pn(e, a, Object.assign({ capture: t }, n));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function ir(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function _a(e) {
  const r = window.getComputedStyle(e);
  if (r.overflowX === "scroll" || r.overflowY === "scroll" || r.overflowX === "auto" && e.clientWidth < e.scrollWidth || r.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const t = e.parentNode;
    return !t || t.tagName === "BODY" ? !1 : _a(t);
  }
}
function su(e) {
  const r = e || window.event, t = r.target;
  return _a(t) ? !1 : r.touches.length > 1 ? !0 : (r.preventDefault && r.preventDefault(), !1);
}
const or = /* @__PURE__ */ new WeakMap();
function lu(e, r = !1) {
  const t = ee(r);
  let a = null, n = "";
  Pe(bi(e), (s) => {
    const u = ir(ie(s));
    if (u) {
      const l = u;
      if (or.get(l) || or.set(l, l.style.overflow), l.style.overflow !== "hidden" && (n = l.style.overflow), l.style.overflow === "hidden")
        return t.value = !0;
      if (t.value)
        return l.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const i = () => {
    const s = ir(ie(e));
    !s || t.value || (ut && (a = We(
      s,
      "touchmove",
      (u) => {
        su(u);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", t.value = !0);
  }, o = () => {
    const s = ir(ie(e));
    !s || !t.value || (ut && (a == null || a()), s.style.overflow = n, or.delete(s), t.value = !1);
  };
  return wr(o), W({
    get() {
      return t.value;
    },
    set(s) {
      s ? i() : o();
    }
  });
}
function uu() {
  let e = !1;
  const r = ee(!1);
  return (t, a) => {
    if (r.value = a.value, e)
      return;
    e = !0;
    const n = lu(t, a.value);
    Pe(r, (i) => n.value = i);
  };
}
uu();
const In = (e) => ["visible", "hidden", "scroll", "auto", "initial", "inherit"].includes(e), du = {
  name: "DropdownMenu",
  directives: { "on-click-outside": ou },
  /* eslint-disable vue/require-default-prop */
  props: {
    isOpen: Boolean,
    padding: String,
    maxWidth: String,
    maxHeight: String,
    notClose: Boolean,
    disabled: Boolean,
    direction: {
      type: String,
      default: "bottom",
      validator: (e) => ["top", "bottom"].includes(e)
    },
    align: {
      type: String,
      default: "left",
      validator: (e) => ["left", "right"].includes(e)
    },
    overflowX: {
      type: String,
      default: "auto",
      validator: (e) => In(e)
    },
    overflowY: {
      type: String,
      default: "auto",
      validator: (e) => In(e)
    },
    height: String,
    width: String
  },
  data() {
    return {
      isOpenInternal: !1
    };
  },
  computed: {
    paddingStyles() {
      return this.padding ? { padding: this.padding } : {};
    },
    maxWidthStyles() {
      return this.maxWidth ? { maxWidth: this.maxWidth } : {};
    },
    maxHeightStyles() {
      return this.maxHeight ? { maxHeight: this.maxHeight } : {};
    },
    overflowStyles() {
      return this.overflowX === "visible" || this.overflowY === "visible" ? { overflow: "visible" } : {
        overflowX: this.overflowX,
        overflowY: this.overflowY
      };
    },
    heightStyles() {
      return this.height ? { height: this.height } : {};
    },
    widthStyles() {
      return this.width ? { width: this.width } : {};
    }
  },
  watch: {
    isOpen(e) {
      this.isOpenInternal = e;
    }
  },
  methods: {
    openDropdown() {
      this.isOpenInternal = !0, this.$emit("open");
    },
    closeDropdown() {
      this.isOpenInternal = !1, this.$emit("close");
    },
    toggleDropdown() {
      this.disabled || (this.isOpenInternal ? this.closeDropdown() : this.openDropdown());
    }
  }
}, cu = { class: "tw-relative" };
function fu(e, r, t, a, n, i) {
  const o = Ua("on-click-outside");
  return w(), g("div", cu, [
    m("div", {
      onClick: r[0] || (r[0] = (...s) => i.toggleDropdown && i.toggleDropdown(...s))
    }, [
      be(e.$slots, "dropdownTrigger", {}, () => [
        r[1] || (r[1] = se("Dropdown Trigger"))
      ])
    ]),
    n.isOpenInternal ? $e((w(), g("div", {
      key: 0,
      class: "tw-absolute tw-z-50 tw-mt-1 tw-bg-white tw-shadow-lg tw-top-full tw-max-h-56 tw-rounded tw-text-base tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-overflow-auto focus:tw-outline-none sm:tw-text-sm",
      tabindex: "-1",
      style: je([
        i.widthStyles,
        i.maxWidthStyles,
        i.heightStyles,
        i.maxHeightStyles,
        i.paddingStyles,
        i.overflowStyles
      ])
    }, [
      be(e.$slots, "default")
    ], 4)), [
      [o, !t.notClose && i.closeDropdown]
    ]) : P("", !0)
  ]);
}
const _r = /* @__PURE__ */ D(du, [["render", fu]]), Ie = Be.getDay(), ht = (e, r) => {
  const t = (n) => {
    const [i, ...o] = n;
    return [...o, i];
  }, a = Number(e);
  if (a === 0) return r;
  if (a > 0) return ht(a - 1, t(r));
  if (a < 0) return ht(a + 1, t(r.reverse()).reverse());
}, An = (e) => e - 3.5 > 0 ? e - 7 : e, hu = {
  name: "CalendarComponent",
  components: {
    DropdownMenu: _r
  },
  props: {
    /**
     * An array of JavaScript Date objects. Visually marks each date on the calendar
     */
    markDates: {
      type: Array,
      default: () => []
    },
    /**
     * A JavaScript Date object. Initializes the calendar with the specified date selected.
     */
    value: {
      type: Date,
      default: () => /* @__PURE__ */ new Date()
    },
    /**
     * Display the "Today" button
     */
    todayButton: {
      type: Boolean,
      default: !1
    },
    /**
     * A JavaScript Date object. Used as the start for range of valid dates.
     */
    startDate: {
      type: Date,
      default: null
    },
    /**
     * A JavaScript Date object. Used as the end for range of valid dates.
     */
    endDate: {
      type: Date,
      default: null
    },
    /**
     * Shift the start of the week as offset from Sunday. Eg. start on monday `firstWeekDayOffset="1"`, start on Saturday `firstOfWeekOffest="-1"`
     */
    firstWeekDayOffset: {
      type: [String, Number],
      default: 0
    }
  },
  emits: ["change"],
  data() {
    return {
      today: Ie,
      isMonthDropdownOpen: !1,
      isYearDropdownOpen: !1
    };
  },
  computed: {
    weeks() {
      return Be.getMonth(this.selected.month, this.selected.year, this.dayOffset) || [];
    },
    months() {
      return Array.from({ length: 12 }, (e, r) => new Date(0, r + 1, 0)).map(
        (e) => this.localizeDate(e, { month: "short" }).toUpperCase()
      );
    },
    years() {
      const e = (/* @__PURE__ */ new Date()).getFullYear(), r = e - 100, t = e + 100, a = [];
      for (let n = r; n <= t; n++)
        this.isYearOutOfRange(n) || a.push(n);
      return a;
    },
    // Return array of weekdays (['Sun', 'Mon', 'Tue', ...])
    // Can be offset if calendar should start on monday or saturday (Sunday = 0)
    daysInWeek() {
      const e = Array.from(
        { length: 7 },
        (r, t) => new Date(0, 0, t)
      ).map(
        (r) => this.localizeDate(r, { weekday: "short" }).toUpperCase()
      );
      return this.firstWeekDayOffset ? ht(this.firstWeekDayOffset, e) : this.$i18n ? ht(
        An(
          new Intl.Locale(this.$i18n.locale).weekInfo.firstDay
        ),
        e
      ) : e;
    },
    // Return an offset so caledar can calculate propper reflow (Sunday = 0)
    dayOffset() {
      return this.firstWeekDayOffset ? Number(this.firstWeekDayOffset) : this.$i18n ? An(
        new Intl.Locale(this.$i18n.locale).weekInfo.firstDay
      ) : 0;
    },
    selected() {
      return Be.getDay(this.value);
    },
    formattedDate() {
      return z.formatLong(this.selected.date);
    }
  },
  created() {
    this.$emit("change", {
      date: new Date(Ie.year, Ie.month, Ie.day),
      displayFormats: [
        z.formatShort(Ie.date),
        z.formatCanada(Ie.date),
        z.formatLong(Ie.date)
      ],
      closeCalendar: !0
    });
  },
  methods: {
    focusDate() {
      this.$refs[this.selected.date][0].focus();
    },
    setDay(e) {
      this.$refs["aria-live-section"].innerText = "", !this.isDayOutOfRange(e) && (this.$emit("change", {
        date: new Date(e.year, e.month, e.day),
        displayFormats: [
          z.formatShort(e.date),
          z.formatCanada(e.date),
          z.formatLong(e.date)
        ],
        closeCalendar: !0
      }), this.$nextTick(() => {
        this.$refs["aria-live-section"].innerText = this.formattedDate;
      }));
    },
    setMonth(e) {
      this.isMonthOutOfRange(e) || this.changeMonth(e, this.selected.year);
    },
    setYear(e) {
      var t, a, n, i;
      this.$refs["aria-live-section"].innerText = "";
      let r = this.selected.month;
      if (!this.isYearOutOfRange(e)) {
        if (this.isMonthOutOfRange(this.selected.month)) {
          const o = new Date(
            this.selected.year,
            this.selected.month,
            (t = this.startDate) == null ? void 0 : t.getDate()
          ), s = new Date(this.selected.year, this.selected.month, (a = this.endDate) == null ? void 0 : a.getDate());
          o < this.startDate ? r = (n = this.startDate) == null ? void 0 : n.getMonth() : s > this.endDate && (r = (i = this.endDate) == null ? void 0 : i.getMonth());
        }
        this.$emit("change", { date: new Date(e, r, this.selected.day) }), this.$nextTick(() => {
          this.$refs["aria-live-section"].innerText = this.formattedDate;
        }), this.isYearDropdownOpen = !1;
      }
    },
    selectToday(e) {
      z.isDateInRange(e.date, [this.startDate, this.endDate]) && this.$emit("change", { date: new Date(this.today.year, this.today.month, this.today.day) });
    },
    changeMonthFromArrows(e) {
      if (this.isMonthOutOfRange(this.selected.month + e))
        return;
      const { month: r, year: t } = e > 0 ? z.getNextMonth(this.selected.month, this.selected.year) : z.getPreviousMonth(this.selected.month, this.selected.year);
      this.changeMonth(r, t);
    },
    changeMonth(e, r) {
      this.$refs["aria-live-section"].innerText = "", this.$emit("change", { date: new Date(r, e, this.selected.day) }), this.$nextTick(() => {
        this.$refs["aria-live-section"].innerText = this.formattedDate;
      }), this.isMonthDropdownOpen = !1;
    },
    isSelected(e) {
      return z.isSameDate(e.date, this.selected.date);
    },
    isToday(e) {
      return z.isSameDate(e.date, this.today.date);
    },
    isSameDay(e, r) {
      return z.isSameDate(e.date, r.date);
    },
    findMarkDate(e) {
      var r;
      return (r = this.markDates) == null ? void 0 : r.find((t) => z.isSameDate(t, e.date));
    },
    dropdownToggle(e, r) {
      if (e === "month") {
        this.isMonthDropdownOpen = r;
        return;
      }
      this.isYearDropdownOpen = r, r && this.$nextTick(() => {
        this.scrollToYear();
      });
    },
    scrollToYear() {
      try {
        const e = this.$refs[`year-option-${this.selected.year}`][0], r = this.$refs["years-dropdown-container"], a = e.offsetTop - 75;
        r.scrollTo({
          top: a,
          behavior: "instant"
        });
      } catch {
        console.warn("DSCL: cannot scroll to year in calendar input.");
      }
    },
    isDayOutOfRange(e) {
      return !z.isDateInRange(e.date, [this.startDate, this.endDate]);
    },
    isMonthOutOfRange(e) {
      var a, n;
      const r = new Date(this.selected.year, e, (a = this.startDate) == null ? void 0 : a.getDate()), t = new Date(this.selected.year, e, (n = this.endDate) == null ? void 0 : n.getDate());
      return !(z.isDateInRange(r, [this.startDate, this.endDate]) || z.isDateInRange(t, [this.startDate, this.endDate]));
    },
    isYearOutOfRange(e) {
      var a, n, i, o;
      const r = new Date(
        e,
        (a = this.startDate) == null ? void 0 : a.getMonth(),
        (n = this.startDate) == null ? void 0 : n.getDate()
      ), t = new Date(
        e,
        (i = this.endDate) == null ? void 0 : i.getMonth(),
        (o = this.endDate) == null ? void 0 : o.getDate()
      );
      return !(z.isDateInRange(r, [this.startDate, this.endDate]) || z.isDateInRange(t, [this.startDate, this.endDate]));
    },
    localizeDate(e, r) {
      var t;
      return new Intl.DateTimeFormat(
        ((t = this.$i18n) == null ? void 0 : t.locale) || "default",
        r
      ).format(e);
    },
    focusOnSelectedMonth(e) {
      this.$refs[`month-option-${e}`][0].focus();
    },
    focusOnSelectedYear(e) {
      this.$refs[`year-option-${e}`][0].focus();
    }
  }
}, mu = { class: "tw-select-none tw-text-sm" }, pu = {
  ref: "aria-live-section",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only"
}, wu = { class: "tw-z-10 tw-w-full sm:tw-w-[400px] tw-bg-white tw-flex tw-flex-col tw-rounded tw-shadow-sm" }, gu = { class: "tw-flex tw-justify-center tw-items-center tw-px-4 sm:tw-px-8 tw-pt-8 tw-pb-4 tw-text-base" }, vu = ["aria-label"], yu = { class: "tw-flex tw-justify-center tw-items-center" }, bu = ["aria-expanded", "aria-label"], Cu = ["aria-activedescendant"], xu = ["tabindex", "aria-selected", "onClick", "onKeydown"], _u = ["aria-expanded", "aria-label"], Tu = ["aria-activedescendant"], Du = ["tabindex", "aria-selected", "onClick", "onKeydown"], $u = ["aria-label"], Ou = { class: "tw-flex sm:tw-px-6 tw-px-4 tw-pb-4" }, ku = ["onClick"], Mu = {
  key: 0,
  width: "4",
  height: "4",
  viewBox: "0 0 4 4",
  class: "marked",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Eu = {
  key: 0,
  class: "tw-flex tw-justify-center tw-mt-4 tw-mb-6"
}, Su = ["disabled"];
function Pu(e, r, t, a, n, i) {
  const o = T("dropdown-menu");
  return w(), g("div", mu, [
    m("div", pu, null, 512),
    m("div", wu, [
      m("div", gu, [
        m("button", {
          class: re({
            "tw-text-gray-40": i.isMonthOutOfRange(i.selected.month - 1)
          }),
          "aria-label": e.$t("formComponents.dialog.previousMonth"),
          onClick: r[0] || (r[0] = (s) => i.changeMonthFromArrows(-1))
        }, r[11] || (r[11] = [
          m("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            stroke: "currentColor"
          }, [
            m("path", {
              d: "M9.5 7.5L5.5 12L9.5 16.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            m("path", {
              d: "M5.5 12H18.5",
              "stroke-linecap": "round"
            })
          ], -1)
        ]), 10, vu),
        m("div", yu, [
          O(o, {
            "is-open": n.isMonthDropdownOpen,
            onOpen: r[3] || (r[3] = (s) => i.dropdownToggle("month", !0)),
            onClose: r[4] || (r[4] = (s) => i.dropdownToggle("month", !1))
          }, {
            dropdownTrigger: k(() => [
              m("button", {
                id: "forms-calendar-month-dropdown",
                class: "tw-py-1.5 tw-px-2 tw-rounded tw-text-sm tw-w-[60px] tw-text-center tw-border tw-border-solid tw-border-white",
                "aria-controls": "listbox",
                "aria-haspopup": "true",
                "aria-expanded": n.isMonthDropdownOpen,
                role: "combobox",
                "aria-label": e.$t("formComponents.dialog.monthDropdown")
              }, _(i.months[i.selected.month]), 9, bu)
            ]),
            default: k(() => [
              m("ul", {
                id: "listbox",
                class: "tw-flex tw-flex-wrap tw-flex-col tw-gap-y-1 tw-justify-center tw-items-center",
                role: "listbox",
                "aria-labelledby": "forms-calendar-month-dropdown",
                "aria-activedescendant": `forms-calendar-month-dropdown-${i.selected.month}`,
                tabindex: "0",
                onKeydown: r[2] || (r[2] = F((s) => i.focusOnSelectedMonth(i.selected.month), ["down"]))
              }, [
                (w(!0), g(fe, null, he(i.months, (s, u) => (w(), g("li", {
                  ref_for: !0,
                  ref: `month-option-${u}`,
                  key: u,
                  class: re(["tw-py-1 tw-px-2 tw-rounded tw-text-center tw-border-white tw-border tw-w-full hover:tw-bg-primary/25 hover:tw-text-primary", {
                    "tw-border-primary tw-text-primary": i.selected.month === u,
                    "tw-text-gray-40 tw-bg-white": i.isMonthOutOfRange(u)
                  }]),
                  role: "option",
                  tabindex: u === i.selected.month ? "0" : "-1",
                  "aria-selected": u === i.selected.month,
                  onClick: (l) => !i.isMonthOutOfRange(u) && i.setMonth(u),
                  onKeydown: [
                    F(Y((l) => !i.isMonthOutOfRange(u) && i.setMonth(u), ["stop"]), ["enter"]),
                    F(Y((l) => !i.isMonthOutOfRange(u) && i.setMonth(u), ["stop"]), ["space"]),
                    F(Y((l) => i.focusOnSelectedMonth(u + 1), ["stop"]), ["down"]),
                    F(Y((l) => i.focusOnSelectedMonth(u - 1), ["stop"]), ["up"]),
                    r[1] || (r[1] = F(Y((l) => n.isMonthDropdownOpen = !1, ["stop"]), ["tab"]))
                  ]
                }, _(s), 43, xu))), 128))
              ], 40, Cu)
            ]),
            _: 1
          }, 8, ["is-open"]),
          O(o, {
            "is-open": n.isYearDropdownOpen,
            height: "185px",
            onOpen: r[7] || (r[7] = (s) => i.dropdownToggle("year", !0)),
            onClose: r[8] || (r[8] = (s) => i.dropdownToggle("year", !1))
          }, {
            dropdownTrigger: k(() => [
              m("button", {
                id: "forms-calendar-year-dropdown",
                class: "tw-py-1.5 tw-px-2 tw-rounded tw-text-sm tw-w-[60px] tw-text-center tw-border tw-border-solid tw-border-white",
                "aria-controls": "listbox",
                "aria-haspopup": "true",
                "aria-expanded": n.isYearDropdownOpen,
                role: "combobox",
                "aria-label": e.$t("formComponents.dialog.yearDropdown")
              }, _(i.localizeDate(new Date(i.selected.year, 1, 1), { year: "numeric" })), 9, _u)
            ]),
            default: k(() => [
              m("ul", {
                ref: "years-dropdown-container",
                class: "tw-flex tw-flex-wrap tw-gap-y-1 tw-justify-center tw-items-center tw-overflow-y-auto tw-max-h-[165px]",
                role: "listbox",
                "aria-labelledby": "forms-calendar-year-dropdown",
                "aria-activedescendant": `forms-calendar-year-dropdown-${i.selected.year}`,
                tabindex: "0",
                onKeydown: r[6] || (r[6] = F((s) => i.focusOnSelectedYear(i.selected.year), ["down"]))
              }, [
                (w(!0), g(fe, null, he(i.years, (s, u) => (w(), g("li", {
                  key: u,
                  ref_for: !0,
                  ref: `year-option-${s}`,
                  class: re(["tw-py-1 tw-px-2 tw-rounded tw-text-center tw-border-white tw-border tw-w-full hover:tw-bg-primary/25 hover:tw-text-primary", {
                    "tw-border-primary tw-text-primary": i.selected.year === s,
                    "tw-text-gray-40 tw-bg-white": i.isYearOutOfRange(s)
                  }]),
                  role: "option",
                  tabindex: s === i.selected.year ? "0" : "-1",
                  "aria-selected": s === i.selected.year,
                  onClick: (l) => i.setYear(s),
                  onKeydown: [
                    F(Y((l) => i.setYear(s), ["stop"]), ["enter"]),
                    F(Y((l) => i.setYear(s), ["stop"]), ["space"]),
                    F(Y((l) => i.focusOnSelectedYear(s + 1), ["stop"]), ["down"]),
                    F(Y((l) => i.focusOnSelectedYear(s - 1), ["stop"]), ["up"]),
                    r[5] || (r[5] = F(Y((l) => n.isYearDropdownOpen = !1, ["stop"]), ["tab"]))
                  ]
                }, _(i.localizeDate(new Date(s, 1, 1), { year: "numeric" })), 43, Du))), 128))
              ], 40, Tu)
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        m("button", {
          class: re({
            "tw-text-gray-40": i.isMonthOutOfRange(i.selected.month + 1)
          }),
          "aria-label": e.$t("formComponents.dialog.nextMonth"),
          onClick: r[9] || (r[9] = (s) => i.changeMonthFromArrows(1))
        }, r[12] || (r[12] = [
          m("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            stroke: "currentColor"
          }, [
            m("path", {
              d: "M14.5 16.5L18.5 12L14.5 7.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            m("path", {
              d: "M18.5 12L5.50001 12",
              "stroke-linecap": "round"
            })
          ], -1)
        ]), 10, $u)
      ]),
      m("div", Ou, [
        (w(!0), g(fe, null, he(i.daysInWeek, (s) => (w(), g("div", {
          key: s,
          class: "tw-w-8 tw-my-1 sm:tw-mx-[9px] tw-mx-2 tw-text-center tw-text-sm"
        }, _(s), 1))), 128))
      ]),
      (w(!0), g(fe, null, he(i.weeks, (s, u) => (w(), g("div", {
        key: `week-${u}`,
        class: "tw-flex tw-px-4 sm:tw-px-6"
      }, [
        (w(!0), g(fe, null, he(s, (l, d) => (w(), g("div", {
          key: `day-${d}`,
          class: "tw-w-8 tw-mx-2 sm:tw-mx-[9px]"
        }, [
          m("button", {
            ref_for: !0,
            ref: `${new Date(l.year, l.month, l.day)}`,
            class: re([{
              "hover:tw-bg-primary/40 hover:tw-text-white tw-cursor-pointer": l.month === i.selected.month && !i.isDayOutOfRange(l),
              "tw-text-gray-40": l.month !== i.selected.month || i.isDayOutOfRange(l),
              "tw-bg-primary tw-text-white": i.isSameDay(l, i.selected),
              "tw-border-solid tw-border-primary tw-border": i.isSameDay(
                l,
                n.today
              )
            }, "tw-py-2 tw-my-0.5 tw-h-8 tw-w-8 tw-text-center tw-rounded-[50%] tw-relative tw-flex itw-tems-center tw-justify-center tw-text-xs"]),
            onClick: (h) => i.setDay(l)
          }, [
            se(_(i.localizeDate(new Date(l.year, l.month, l.day), {
              day: "numeric"
            })) + " ", 1),
            i.findMarkDate(l) && !i.isSameDay(l, i.selected) ? (w(), g("svg", Mu, r[13] || (r[13] = [
              m("circle", {
                cx: "2",
                cy: "2",
                r: "2"
              }, null, -1)
            ]))) : P("", !0)
          ], 10, ku)
        ]))), 128))
      ]))), 128)),
      t.todayButton ? (w(), g("div", Eu, [
        m("button", {
          class: "tw-bg-primary/10 tw-py-1.5 tw-px-4 tw-rounded",
          disabled: i.isDayOutOfRange(n.today),
          onClick: r[10] || (r[10] = (s) => i.selectToday(n.today))
        }, " Today ", 8, Su)
      ])) : P("", !0)
    ])
  ]);
}
const Iu = /* @__PURE__ */ D(hu, [["render", Pu]]), Au = {
  name: "FcCalendarInput",
  components: { Calendar: Iu, CalendarIcon: Qn },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    id: {
      type: [Number, String],
      default: ""
    },
    value: {
      type: Date,
      default: () => /* @__PURE__ */ new Date()
    },
    validRange: {
      type: Array,
      default: () => [null, null]
    },
    required: Boolean,
    disabled: Boolean,
    todayButton: Boolean,
    focusedByKeyboard: Boolean
  },
  emits: ["change", "close-modal", "validate-date"],
  setup() {
    const e = ee(null);
    let r = ee(!1);
    ee(null);
    let t = ee(!1);
    function a() {
      r.value = !1;
    }
    function n() {
      r.value = !r.value, r.value === !0 && (t.value = !0);
    }
    return zn(e, a), {
      showCalendar: r,
      toggleCalendarDialog: n,
      closeCalendarDialog: a,
      calendarDialog: e,
      calendarUpdated: t
    };
  },
  data() {
    return {
      calendarDate: this.value || /* @__PURE__ */ new Date(),
      formattedDate: this.placeholder,
      debouncedDateInput() {
        return 0;
      }
    };
  },
  computed: {
    isValidDate() {
      const e = Ol(this.formattedDate, "MMMM d, yyyy", /* @__PURE__ */ new Date());
      return Jn(e);
    },
    isWithinDateRange() {
      const e = new Date(this.formattedDate);
      return z.isDateInRange(e, this.validRange);
    },
    hasError() {
      return !this.isValidDate || !this.isWithinDateRange;
    },
    getErrorMessage() {
      return this.isValidDate ? this.isWithinDateRange ? "" : this.formatRangeErrorMessage : "Invalid date (ex. January 1, 1970)";
    },
    formatRangeErrorMessage() {
      const e = this.validRange[0], r = this.validRange[1], t = z.formatLong(e), a = z.formatLong(r);
      return e && !r ? `Date must be after ${t}` : !e && r ? `Date must be before ${a}` : `Date must be between ${t} and ${a}`;
    }
  },
  watch: {
    value(e) {
      this.calendarDate = e;
    }
  },
  created() {
    this.debouncedDateInput = $s(this.handleInputDateChange, 500);
  },
  methods: {
    handleCalendarChange({ date: e, closeCalendar: r }) {
      if (!this.calendarUpdated) {
        this.required ? this.$emit("validate-date", !1) : this.$emit("validate-date", !0);
        return;
      }
      this.formattedDate = z.formatLong(e), this.$emit("change", e), this.$emit("validate-date", !0), r && this.$nextTick(() => {
        this.$refs["calendar-input"].focus(), this.closeCalendarDialog();
      });
    },
    handleInputDateChange() {
      !this.isValidDate || !this.calendarUpdated || (this.calendarDate = new Date(this.formattedDate));
    },
    openAndFocusCalendar() {
      this.showCalendar = !0, this.$nextTick(() => {
        this.calendarUpdated = !0, this.$refs.calendar.focusDate();
      });
    }
  }
}, qu = {
  ref: "calendarDialog",
  class: "tw-relative"
}, Ru = { class: "tw-w-full" }, Vu = ["id", "name", "disabled", "placeholder", "aria-expanded", "aria-labelledby", "aria-describedby"], Lu = ["id"], Uu = { class: "tw-absolute tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-top-0 tw-right-0" }, Nu = {
  id: "calendar-dialog",
  class: "tw-absolute tw-top-full -tw-left-8 sm:tw-left-0 tw-z-10",
  role: "dialog",
  "aria-modal": "true"
};
function Fu(e, r, t, a, n, i) {
  const o = T("calendar-icon"), s = T("calendar");
  return w(), g("div", qu, [
    m("div", Ru, [
      $e(m("input", {
        id: t.id || t.name,
        ref: "calendar-input",
        "onUpdate:modelValue": r[0] || (r[0] = (u) => n.formattedDate = u),
        class: re(["tw-w-full tw-border-b tw-border-b-primary/[0.4] tw-h-9 tw-pl-1 tw-outline-none tw-pr-9 focus:tw-border-b-primary focus:tw-border-b-2", [
          t.focusedByKeyboard ? "focus:tw-outline-accessible-focus" : "focus:tw-outline-none",
          a.calendarUpdated ? "tw-text-black" : "tw-text-gray-400"
        ]]),
        name: t.name,
        type: "button",
        disabled: t.disabled,
        placeholder: t.placeholder,
        "aria-autocomplete": "none",
        "aria-expanded": a.showCalendar,
        "aria-haspopup": "dialog",
        "aria-controls": "calendar-dialog",
        "aria-labelledby": `label-${t.id}`,
        "aria-describedby": `error-message-label-${t.id || t.name} description-label-${t.id}`,
        onClick: r[1] || (r[1] = (...u) => a.toggleCalendarDialog && a.toggleCalendarDialog(...u)),
        onKeydown: [
          r[2] || (r[2] = F(Y((...u) => a.toggleCalendarDialog && a.toggleCalendarDialog(...u), ["exact", "prevent"]), ["enter"])),
          r[3] || (r[3] = F((...u) => i.openAndFocusCalendar && i.openAndFocusCalendar(...u), ["arrow", "down"])),
          r[4] || (r[4] = F(Y((...u) => a.closeCalendarDialog && a.closeCalendarDialog(...u), ["stop", "prevent"]), ["esc"]))
        ],
        onInput: r[5] || (r[5] = (...u) => n.debouncedDateInput && n.debouncedDateInput(...u))
      }, null, 42, Vu), [
        [pt, n.formattedDate]
      ]),
      m("span", {
        class: "sr-only",
        id: `description-label-${t.id}`
      }, "Choose Date", 8, Lu),
      m("div", Uu, [
        O(o)
      ])
    ]),
    $e(m("div", Nu, [
      O(s, {
        ref: "calendar",
        "start-date": t.validRange[0],
        "end-date": t.validRange[1],
        "today-button": t.todayButton,
        value: n.calendarDate,
        onChange: i.handleCalendarChange,
        onKeydown: F(Y(a.closeCalendarDialog, ["stop", "prevent"]), ["esc"])
      }, null, 8, ["start-date", "end-date", "today-button", "value", "onChange", "onKeydown"])
    ], 512), [
      [Na, a.showCalendar]
    ])
  ], 512);
}
const Wu = /* @__PURE__ */ D(Au, [["render", Fu], ["__scopeId", "data-v-04054630"]]), ju = (e) => {
  const r = [], t = /* @__PURE__ */ new Date(), a = {
    hour: "numeric",
    minute: "numeric"
  };
  for (let n = 0; n < 24 * 60; n += e)
    t.setHours(0), t.setMinutes(n), r.push(t.toLocaleTimeString("en", a));
  return r;
}, Hu = (e) => {
  const t = e.replace(/([AaPp][Mm])/, "").split(":"), a = t[0], n = t[1].split(" ")[0];
  return a >= 0 && a < 25 && n >= 0 && n <= 59;
}, Bu = {
  name: "FcTimePicker",
  components: {
    DropdownMenu: _r,
    TimeIcon: dr
  },
  mixins: [rt, nt, _e],
  props: {
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["change", "validate-time"],
  data() {
    return {
      isDropdownOpen: !1,
      internalValue: "",
      timeChoices: [],
      filteredChoices: [],
      selectedIndex: null,
      time: ""
    };
  },
  created() {
    this.is12hrFormat(), this.internalValue = this.value, this.filteredChoices = this.timeChoices, this.required ? this.$emit("validate-time", !1) : this.$emit("validate-time", !0);
  },
  methods: {
    inputChange(e) {
      this.internalValue = e.target.value, this.filteredChoices = this.timeChoices.filter(
        (r) => r.startsWith(this.internalValue)
      );
    },
    inputFocus() {
      this.internalValue = "", this.filteredChoices = [...this.timeChoices];
    },
    toggleTimeDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    openTimeDopdown() {
      this.isDropdownOpen = !0, this.$nextTick(() => {
        this.$refs[`time-option-${this.selectedIndex || 0}`][0].focus();
      });
    },
    closeTimeDropdown() {
      this.isDropdownOpen = !1, this.handleTimeChange(this.internalValue);
    },
    handleTimeChange(e) {
      const r = /* @__PURE__ */ new Date(), t = /((1[0-2]|0?[1-9]):([0-5][0-9])?([AaPp][Mm]))/, n = r.getHours() > 11 ? "PM" : "AM";
      if (!e) return;
      const i = this.isValidTime(e);
      if (this.$emit("validate-time", i), i) {
        const o = e.match(/([AaPp][Mm])/);
        if (e.match(t)) {
          const s = e.substring(0, e.length - 2), u = e.slice(-2).toUpperCase();
          e = `${s} ${u}`;
        }
        o || (e = `${e} ${n}`);
      }
      this.time = e, this.internalValue = e, this.$refs["time-input"].focus(), this.isDropdownOpen = !1, this.$emit("change", this.time);
    },
    is12hrFormat() {
      this.timeChoices = ju(15);
      const e = this.timeChoices.indexOf(this.selectedTime), r = this.timeChoices.slice(0, e), t = this.timeChoices.slice(
        e,
        this.timeChoices.length
      );
      this.timeChoices = t.concat(r);
    },
    isValidTime(e) {
      const r = /^(0?[1-9]|1[0-2]):[0-5][0-9]$/, t = /^((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))$/;
      return e && e !== null ? !!e.match(r) || !!e.match(t) && Hu(e) : !1;
    },
    focusOnInitialTime() {
      const e = this.filteredChoices.findIndex(
        (t) => t === this.value
      );
      this.$refs[`time-option-${e}`][0].focus();
    },
    focusOnSelectedTime(e) {
      const r = this.$refs[`time-option-${e}`][0];
      this.selectedIndex = e, r.focus();
    }
  }
}, Yu = ["id", "value", "name", "disabled", "placeholder", "aria-expanded", "aria-labelledby", "aria-describedby"], zu = { class: "tw-absolute tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-top-0 tw-right-0" }, Gu = ["aria-activedescendant"], Qu = { class: "sr-only" }, Ku = ["tabindex", "aria-selected", "onClick", "onKeydown"];
function Zu(e, r, t, a, n, i) {
  const o = T("time-icon"), s = T("dropdown-menu");
  return w(), Q(s, {
    "is-open": n.isDropdownOpen,
    disabled: e.disabled,
    onOpen: r[6] || (r[6] = (u) => n.isDropdownOpen = !0),
    onClose: i.closeTimeDropdown
  }, {
    dropdownTrigger: k(() => [
      m("div", null, [
        m("input", {
          id: e.id || e.name,
          ref: "time-input",
          value: n.internalValue,
          class: re([
            "tw-w-full tw-flex tw-items-center tw-border-b tw-border-b-primary/[0.4] tw-h-9 tw-pl-1 tw-pr-9 focus:tw-border-b-primary focus:tw-border-b-2",
            e.focusedByKeyboard ? "focus:tw-outline-accessible-focus" : "focus:tw-outline-none"
          ]),
          name: e.name,
          type: "text",
          disabled: e.disabled,
          placeholder: t.placeholder,
          "aria-autocomplete": "none",
          role: "combobox",
          "aria-expanded": n.isDropdownOpen,
          "aria-controls": "forms-timepicker-listbox",
          "aria-labelledby": `label-${e.id}`,
          "aria-describedby": `error-message-label-${e.id} description-label-${e.id}`,
          onInput: r[0] || (r[0] = (...u) => i.inputChange && i.inputChange(...u)),
          onKeydown: [
            r[1] || (r[1] = F((...u) => i.openTimeDopdown && i.openTimeDopdown(...u), ["arrow", "down"])),
            r[2] || (r[2] = F(Y((...u) => i.toggleTimeDropdown && i.toggleTimeDropdown(...u), ["prevent"]), ["enter"]))
          ]
        }, null, 42, Yu),
        m("div", zu, [
          O(o)
        ])
      ])
    ]),
    default: k(() => [
      m("div", null, [
        n.internalValue ? (w(), g("ul", {
          key: 0,
          id: "forms-timepicker-listbox",
          role: "listbox",
          "aria-labelledby": "time-dropdown",
          "aria-activedescendant": `time-dropdown-${n.time}`,
          tabindex: "0",
          onKeydown: r[3] || (r[3] = F((...u) => i.focusOnInitialTime && i.focusOnInitialTime(...u), ["down"])),
          onClick: r[4] || (r[4] = (u) => i.handleTimeChange(e.timeChoice))
        }, [
          m("span", Qu, _(n.internalValue), 1)
        ], 40, Gu)) : P("", !0),
        (w(!0), g(fe, null, he(n.filteredChoices, (u, l) => (w(), g("li", {
          ref_for: !0,
          ref: `time-option-${l}`,
          key: u,
          class: "tw-px-4 tw-py-4 tw-h-10 hover:tw-bg-primary/5 tw-flex tw-items-center",
          role: "option",
          tabindex: l === n.selectedIndex ? "0" : "-1",
          "aria-selected": l === n.selectedIndex,
          onClick: (d) => i.handleTimeChange(u),
          onKeydown: [
            F(Y((d) => i.handleTimeChange(u), ["stop"]), ["enter"]),
            F(Y((d) => i.focusOnSelectedTime(l + 1), ["stop"]), ["down"]),
            F(Y((d) => i.focusOnSelectedTime(l - 1), ["stop"]), ["up"]),
            r[5] || (r[5] = F(Y((...d) => i.closeTimeDropdown && i.closeTimeDropdown(...d), ["stop"]), ["tab"]))
          ]
        }, _(u), 41, Ku))), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-open", "disabled", "onClose"]);
}
const Xu = /* @__PURE__ */ D(Bu, [["render", Zu]]), Ju = {
  name: "FcDateTimePicker",
  components: {
    Question: ke,
    CalendarInput: Wu,
    TimePicker: Xu
  },
  mixins: [rt, nt, _e],
  emits: ["validate-date", "validate-time", "update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    dateTimeType: {
      type: String,
      default: ""
    },
    todayButton: Boolean
  },
  data() {
    return {
      time: "8:00 AM",
      date: /* @__PURE__ */ new Date()
    };
  },
  watch: {
    date() {
      this.formatValue();
    },
    time() {
      this.formatValue();
    }
  },
  methods: {
    formatValue() {
      let e = "";
      this.dateTimeType === "date_time" && (e = `${it(this.date, "yyyy-MM-dd")} ${this.time} ${it(
        this.date,
        "xx"
      )}`), this.dateTimeType === "date" && (e = `${it(this.date, "yyyy-MM-dd")}`), this.dateTimeType === "time" && (e = `${this.time} ${it(this.date, "xx")}`), this.$emit("update:modelValue", e);
    }
  }
}, ed = { class: "tw-flex tw-gap-x-3 tw-mt-[24px]" };
function td(e, r, t, a, n, i) {
  const o = T("CalendarInput"), s = T("TimePicker"), u = T("Question");
  return w(), Q(u, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    required: e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => [
      m("div", ed, [
        t.dateTimeType === "date_time" || t.dateTimeType === "date" ? (w(), Q(o, {
          key: 0,
          id: e.id,
          value: n.date,
          disabled: e.disabled,
          "today-button": t.todayButton,
          required: e.required,
          "aria-required": e.required,
          "aria-invalid": e.showError,
          placeholder: e.$t("formComponents.openCalendarDialog"),
          "focused-by-keyboard": e.focusedByKeyboard,
          onChange: r[0] || (r[0] = (l) => n.date = l),
          onValidateDate: r[1] || (r[1] = (l) => e.$emit("validate-date", l)),
          onCloseModal: r[2] || (r[2] = (l) => e.$emit("close-modal"))
        }, null, 8, ["id", "value", "disabled", "today-button", "required", "aria-required", "aria-invalid", "placeholder", "focused-by-keyboard"])) : P("", !0),
        t.dateTimeType === "date_time" || t.dateTimeType === "time" ? (w(), Q(s, {
          key: 1,
          id: e.id,
          value: n.time,
          disabled: e.disabled,
          required: e.required,
          "aria-required": e.required,
          "aria-invalid": e.showError,
          placeholder: e.$t("formComponents.openTimeDropdown"),
          "focused-by-keyboard": e.focusedByKeyboard,
          onChange: r[3] || (r[3] = (l) => n.time = l),
          onValidateTime: r[4] || (r[4] = (l) => e.$emit("validate-time", l)),
          onCloseModal: r[5] || (r[5] = (l) => e.$emit("close-modal"))
        }, null, 8, ["id", "value", "disabled", "required", "aria-required", "aria-invalid", "placeholder", "focused-by-keyboard"])) : P("", !0)
      ])
    ]),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "required", "section-child"]);
}
const Ta = /* @__PURE__ */ D(Ju, [["render", td]]), rd = [
  "text",
  "password",
  "email",
  "number",
  "url",
  "tel",
  "search"
], nd = (e) => ["password", "search", "tel", "text", "url"].includes(e), ad = {
  name: "fc-input-field",
  props: {
    id: String,
    name: String,
    form: String,
    required: Boolean,
    disabled: Boolean,
    value: [String, Number],
    readonly: Boolean,
    placeholder: String,
    maxLength: Number,
    type: {
      type: String,
      default: "text",
      validator: (e) => rd.includes(e)
    },
    name: {
      type: String,
      default: ""
    },
    hideNumberControls: Boolean,
    disabled: Boolean,
    iconRight: String,
    iconLeft: String,
    min: Number,
    max: Number,
    step: Number,
    width: String,
    ariaLabel: {
      default: "",
      type: String
    },
    showCharCounter: Boolean
  },
  data() {
    return {
      inputValue: this.value || ""
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit("input", e);
      }
    },
    charCounter() {
      if (this.showCharCounter) {
        const e = this.localMaxLength ? `/ ${this.localMaxLength}` : "";
        return `${this.value && this.value.length || 0} ${e}`;
      }
      return "";
    },
    localMaxLength() {
      return nd(this.type) ? this.maxLength : null;
    },
    listeners() {
      return {
        ...this.$attrs,
        input: this.updateValue
      };
    }
  },
  methods: {
    updateValue(e) {
      var t;
      let r = e != null && e.target ? (t = e == null ? void 0 : e.target) == null ? void 0 : t.value : e;
      this.$emit("input", r);
    }
  }
}, id = {
  key: 0,
  class: "absolute flex items-center justify-center w-9 h-9 left-0"
}, od = ["id", "name", "aria-labelledby", "type", "disabled", "readonly", "value", "placeholder", "aria-label", "maxlength", "min", "max", "step"], sd = {
  key: 1,
  class: "absolute flex items-center justify-center w-9 h-9 top-0 right-0"
};
function ld(e, r, t, a, n, i) {
  return w(), g("div", null, [
    t.iconLeft ? (w(), g("div", id, [
      (w(), Q(tt(t.iconLeft)))
    ])) : P("", !0),
    $e(m("input", ze({
      "onUpdate:modelValue": r[0] || (r[0] = (o) => i.internalValue = o),
      id: t.id || t.name,
      class: ["w-full border-b border-b-primary/[0.4] h-9 pl-1 outline-none focus:border-b-primary", {
        "pl-9": t.iconLeft,
        "pr-9": t.iconRight,
        "a-input--hide-number-controls": t.hideNumberControls
      }],
      name: t.name,
      "aria-labelledby": `label-${t.id}`,
      type: t.type,
      disabled: t.disabled,
      readonly: t.readonly,
      value: t.value,
      placeholder: t.placeholder,
      "aria-label": `${t.ariaLabel || t.type + " input"}`,
      maxlength: i.localMaxLength,
      min: t.min,
      max: t.max,
      step: t.step
    }, Ge(e.$attrs, !0)), null, 16, od), [
      [mr, i.internalValue]
    ]),
    se(" " + _(n.inputValue) + " ", 1),
    t.iconRight || t.type === "search" ? (w(), g("div", sd, [
      (w(), Q(tt(t.iconRight || "search")))
    ])) : P("", !0)
  ]);
}
const ud = /* @__PURE__ */ D(ad, [["render", ld], ["__scopeId", "data-v-be8883bf"]]), dd = {
  components: { "caret-down-icon": jn },
  props: {
    phoneCode: {
      type: Object,
      default: () => {
      },
      required: !0
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasValue() {
      return this.phoneCode !== "";
    },
    label() {
      return this.phoneCode.id ? `${this.phoneCode.icon} ${this.phoneCode.countryCode}` : "Select country code";
    }
  }
}, cd = { class: "flex items-center" }, fd = { class: "ml-1 flex items-center text-[14px] xs:text-[16px] text-gray-40" }, hd = { class: "ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" };
function md(e, r, t, a, n, i) {
  const o = T("caret-down-icon");
  return w(), g("button", {
    type: "button",
    class: re(["relative w-full bg-white border rounded shadow-sm pl-3 pr-14 py-2.5 text-left cursor-default focus:primary focus:border-primary sm:text-sm", {
      "border-primary": i.hasValue,
      "border-gray-300": !i.hasValue
    }]),
    "aria-haspopup": "listbox",
    "aria-expanded": "true",
    "aria-labelledby": "listbox-label"
  }, [
    m("span", cd, [
      m("span", fd, _(i.label), 1)
    ]),
    m("span", hd, [
      O(o, {
        class: re({ "rotate-180": t.isOpen })
      }, null, 8, ["class"])
    ])
  ], 2);
}
const pd = /* @__PURE__ */ D(dd, [["render", md]]), wd = {
  props: {
    countryCodes: {
      type: Array,
      default: () => [],
      required: !0
    }
  },
  data() {
    return { isOpenInternal: !1 };
  },
  methods: {
    onSelect(e) {
      this.selectedItem = { ...this.phoneSelection, ...e }, this.$emit("select", this.selectedItem), this.isOpenInternal = !1;
    }
  }
}, gd = {
  class: "z-50 mt-1 w-full bg-white shadow-lg max-h-56 rounded py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm tw-p-0 tw-list-none",
  tabindex: "-1",
  role: "listbox",
  "aria-labelledby": "listbox-label",
  "aria-activedescendant": "listbox-option-3"
}, vd = ["onClick"], yd = { class: "flex items-center" }, bd = { class: "text-[14px] xs:text-[16px] ml-1" };
function Cd(e, r, t, a, n, i) {
  return w(), g("ul", gd, [
    (w(!0), g(fe, null, he(t.countryCodes, (o) => (w(), g("li", {
      id: "listbox-option-0",
      key: o.id,
      class: "text-gray-900 cursor-default select-none relative py-2 pl-3 pr-8 hover:bg-primary/10",
      role: "option",
      onClick: (s) => i.onSelect(o)
    }, [
      m("div", yd, [
        m("span", bd, _(`${o.icon} ${o.countryCode}`), 1)
      ])
    ], 8, vd))), 128))
  ]);
}
const xd = /* @__PURE__ */ D(wd, [["render", Cd]]), _d = {
  name: "FcPhone",
  components: {
    Question: ke,
    DropdownMenu: _r,
    InputField: ud,
    PhoneCodeSelect: pd,
    PhoneCodeList: xd
  },
  mixins: [_e],
  props: {
    value: {
      type: [Object, String],
      // { id, country, countryCode, icon, number }
      default: null
    },
    countryCodes: {
      type: Array,
      default: () => []
    },
    disabled: Boolean
  },
  data() {
    return {
      tel: "tel",
      placeholder: "000 000 0000",
      isDropdownOpen: !1,
      isOpen: !1
    };
  },
  computed: {
    phoneSelection: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit("input", e);
      }
    },
    hasValue() {
      return this.phoneSelection !== "";
    },
    formattedPhoneNumber() {
      var e;
      return (e = this.phoneSelection.number) == null ? void 0 : e.replace(
        /(\d{3})(\d{3})(\d{4})/,
        "$1 $2 $3"
      );
    },
    fullPhoneNumber() {
      return this.hasValue || this.phoneSelection.set(this.countryCodes[0].countryCode), `${this.phoneSelection.countryCode}  ${this.formattedPhoneNumber}`;
    }
  },
  methods: {
    onInput(e) {
      this.phoneSelection.number = e.replace(/\D/g, "").substring(0, 10);
    },
    onPhoneCodeSelected(e) {
      this.phoneSelection = { ...this.phoneSelection, ...e }, this.closeDropdown();
    },
    closeDropdown() {
      this.isDropdownOpen = !1;
    },
    openDropdown() {
      this.isDropdownOpen = !0;
    }
  }
}, Td = { class: "flex gap-x-3 mt-[24px]" };
function Dd(e, r, t, a, n, i) {
  const o = T("phone-code-select"), s = T("phone-code-list"), u = T("dropdown-menu"), l = T("input-field"), d = T("question");
  return w(), Q(d, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    required: e.required
  }, {
    default: k(() => [
      m("div", Td, [
        be(e.$slots, "customPhoneComponent", {}, () => [
          O(u, {
            "is-open": n.isDropdownOpen,
            disabled: t.disabled,
            onOpen: i.openDropdown,
            onClose: i.closeDropdown
          }, {
            dropdownTrigger: k(() => [
              O(o, {
                "is-open": n.isDropdownOpen,
                "phone-code": i.phoneSelection
              }, null, 8, ["is-open", "phone-code"])
            ]),
            default: k(() => [
              O(s, {
                flags: t.countryCodes,
                onSelect: i.onPhoneCodeSelected
              }, null, 8, ["flags", "onSelect"])
            ]),
            _: 1
          }, 8, ["is-open", "disabled", "onOpen", "onClose"]),
          O(l, {
            class: "mt-[4px]",
            type: n.tel,
            "max-length": 10,
            placeholder: n.placeholder,
            value: i.formattedPhoneNumber,
            "aria-labelledby": `label-${e.id}`,
            onInput: r[0] || (r[0] = (h) => i.onInput(h))
          }, null, 8, ["type", "placeholder", "value", "aria-labelledby"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["id", "title", "description", "show-error", "error-message", "required"]);
}
const $d = /* @__PURE__ */ D(_d, [["render", Dd]]), Od = {
  name: "FcOverlay",
  props: ["overlayZIndexStyles"],
  emits: ["closeOverlay"]
};
function kd(e, r, t, a, n, i) {
  return w(), g("div", {
    class: "tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-overlay",
    style: je(t.overlayZIndexStyles),
    onClick: r[0] || (r[0] = (o) => e.$emit("closeOverlay"))
  }, null, 4);
}
const Md = /* @__PURE__ */ D(Od, [["render", kd]]), Ed = {
  name: "FcIconClose"
}, Sd = ["aria-label"];
function Pd(e, r, t, a, n, i) {
  return w(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    "aria-label": e.$t("formComponents.dialog.iconClose.ariaLabel"),
    viewBox: "0 0 16 16",
    class: "icon-close",
    title: "close modal",
    role: "button"
  }, r[0] || (r[0] = [
    m("path", {
      class: "modal-close-icon__path",
      d: "M4.1 4.1C4.3 4 4.7 4 4.9 4.1L11.9 11.1C12 11.3 12 11.7 11.9 11.9 11.7 12 11.3 12 11.1 11.9L4.1 4.9C4 4.7 4 4.3 4.1 4.1Z"
    }, null, -1),
    m("path", {
      class: "modal-close-icon__path",
      d: "M11.9 4.1C12 4.3 12 4.7 11.9 4.9L4.9 11.9C4.7 12 4.3 12 4.1 11.9 4 11.7 4 11.3 4.1 11.1L11.1 4.1C11.3 4 11.7 4 11.9 4.1Z"
    }, null, -1)
  ]), 8, Sd);
}
const Id = /* @__PURE__ */ D(Ed, [["render", Pd], ["__scopeId", "data-v-48eff0dc"]]), Ad = {
  name: "FcDialog",
  components: {
    Overlay: Md,
    IconClose: Id
  },
  props: {
    show: Boolean,
    animate: Boolean,
    alert: Boolean,
    ignoreFocusTrap: Boolean,
    noCloseOnOverlay: Boolean,
    noCloseOnEsc: Boolean,
    hideClose: Boolean,
    zIndex: {
      type: Number,
      default: 1e3
    },
    hideHeader: Boolean,
    hideFooter: Boolean,
    size: {
      type: String,
      default: "m",
      validator: (e) => ["s", "m", "l", "xl"].includes(e) || !!e.match(/\d*px/g)
    },
    padding: {
      type: String,
      default: "0px"
    }
  },
  computed: {
    overlayZIndexStyles() {
      return this.zIndex ? { "z-index": this.zIndex } : {};
    },
    containerZIndexStyles() {
      return this.zIndex ? { "z-index": this.zIndex + 1 } : {};
    },
    containerTopPositionStyles() {
      return this.topPosition ? { top: this.topPosition } : {};
    },
    animationName() {
      return this.animate ? "a-dialog__transition--fade" : "";
    },
    dialogContainerSize() {
      const e = {
        s: "360px",
        m: "480px",
        l: "720px",
        xl: "960px"
      };
      return {
        "max-width": this.alert ? "600px" : e[this.size] || this.size
      };
    },
    dialogPadding() {
      return {
        padding: {
          default: "24px 40px 40px 40px"
        }[this.padding] || this.padding || "0px"
      };
    }
  },
  mounted() {
    this.noCloseOnEsc || window.addEventListener("keydown", this.onEsc);
  },
  beforeDestroy() {
    this.noCloseOnEsc || window.removeEventListener("keydown", this.onEsc);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    closeOverlay() {
      this.noCloseOnOverlay || this.close();
    },
    onEsc(e) {
      e.keyCode === 27 && !this.noCloseOnEsc && this.close();
    }
  }
}, qd = {
  key: 0,
  "aria-modal": "true",
  role: "dialog",
  class: "a-dialog"
};
function Rd(e, r, t, a, n, i) {
  const o = T("Overlay"), s = T("IconClose");
  return w(), Q(Ar, { name: i.animationName }, {
    default: k(() => [
      t.show ? (w(), g("div", qd, [
        O(o, {
          "overlay-z-index-styles": i.overlayZIndexStyles,
          onCloseOverlay: i.closeOverlay
        }, null, 8, ["overlay-z-index-styles", "onCloseOverlay"]),
        O(Ar, { name: i.animationName }, {
          default: k(() => [
            m("section", {
              class: "a-dialog__container tw-relative tw-flex tw-flex-col tw-flex-nowrap tw-bg-white tw-w-full tw-rounded-[5px] tw-text-gray-regular",
              style: je([
                i.containerZIndexStyles,
                i.containerTopPositionStyles,
                i.dialogContainerSize,
                i.dialogPadding
              ])
            }, [
              t.hideClose ? P("", !0) : (w(), g("span", {
                key: 0,
                class: "tw-absolute tw-top-6 tw-right-10 tw-flex tw-items-center tw-justify-center tw-cursor-pointer",
                onClick: r[0] || (r[0] = (...u) => i.close && i.close(...u))
              }, [
                O(s, {
                  class: "a-dialog__close-icon",
                  color: "primary"
                })
              ])),
              t.hideHeader ? P("", !0) : be(e.$slots, "header", { key: 1 }, void 0, !0),
              be(e.$slots, "default", {}, void 0, !0),
              t.hideFooter ? P("", !0) : be(e.$slots, "footer", { key: 2 }, void 0, !0)
            ], 4)
          ]),
          _: 3
        }, 8, ["name"])
      ])) : P("", !0)
    ]),
    _: 3
  }, 8, ["name"]);
}
const Tr = /* @__PURE__ */ D(Ad, [["render", Rd], ["__scopeId", "data-v-97e7d195"]]), Vd = {
  name: "FcDialogHeader"
}, Ld = { class: "tw-pt-6 tw-px-10 tw-w-full tw-text-xl tw-font-bold tw-text-gray-regular" }, Ud = { class: "tw-min-h-[24px]" };
function Nd(e, r, t, a, n, i) {
  return w(), g("header", Ld, [
    m("div", Ud, [
      m("h4", null, [
        be(e.$slots, "default")
      ])
    ])
  ]);
}
const Dr = /* @__PURE__ */ D(Vd, [["render", Nd]]), Fd = {
  name: "FcDialogContent"
}, Wd = { class: "tw-py-6 tw-px-10 tw-w-full tw-flex tw-min-h-[40px]" };
function jd(e, r, t, a, n, i) {
  return w(), g("div", Wd, [
    be(e.$slots, "default", {}, () => [
      r[0] || (r[0] = se("Use default slot to override this text."))
    ])
  ]);
}
const $r = /* @__PURE__ */ D(Fd, [["render", jd]]), Hd = {
  name: "FcDialogFooter"
}, Bd = { class: "tw-pt-0 tw-px-10 tw-pb-10 tw-flex tw-items-center tw-shrink-0 tw-gap-2 tw-w-full tw-flex-row" };
function Yd(e, r, t, a, n, i) {
  return w(), g("footer", Bd, [
    be(e.$slots, "default")
  ]);
}
const Or = /* @__PURE__ */ D(Hd, [["render", Yd]]), zd = {
  name: "FcESignature",
  components: {
    Question: ke,
    Dialog: Tr,
    DialogHeader: Dr,
    DialogContent: $r,
    DialogFooter: Or
  },
  mixins: [rt, nt, _e],
  props: {
    modelValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      textAreaEnabled: !1,
      showTermsDialog: !1
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    agree() {
      this.$emit("agree", (/* @__PURE__ */ new Date()).toISOString()), this.textAreaEnabled = !0, this.showTermsDialog = !1;
    }
  }
}, Gd = { class: "tw-block tw-text-[14px] xs:tw-text-[16px] text-gray-40 tw-mt-[24px]" }, Qd = ["id", "name", "required", "readonly", "disabled", "placeholder", "form", "maxlength", "aria-labelledby", "aria-required", "aria-invalid", "aria-describedby"], Kd = ["id", "disabled", "aria-labelledby"], Zd = { class: "tw-text-xs tw-text-gray-40" }, Xd = ["innerHTML"];
function Jd(e, r, t, a, n, i) {
  const o = T("DialogHeader"), s = T("DialogContent"), u = T("dialog-footer"), l = T("Dialog"), d = T("question");
  return w(), Q(d, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    required: e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => [
      m("span", Gd, _(e.$t("formComponents.eSignature.signature")), 1),
      m("div", {
        class: "tw-w-full tw-border tw-border-primary/[0.4] tw-pl-1 focus:tw-border-primary tw-flex tw-justify-center tw-items-center tw-h-44",
        onClick: r[2] || (r[2] = (h) => {
          var y;
          return (y = e.$refs.textarea) == null ? void 0 : y.focus();
        })
      }, [
        n.textAreaEnabled || e.value ? $e((w(), g("textarea", ze({
          key: 0,
          id: e.id,
          ref: "textarea",
          "onUpdate:modelValue": r[0] || (r[0] = (h) => i.inputVal = h),
          class: "tw-outline-none tw-resize-none tw-text-center tw-h-[66px] tw-w-full tw-font-dancing tw-font-bold tw-text-6xl",
          name: e.name,
          required: e.required,
          readonly: e.readonly,
          disabled: e.disabled,
          placeholder: e.placeholder,
          form: e.form,
          maxlength: e.maxLength,
          "aria-labelledby": `label-${e.id}`,
          "aria-required": e.required,
          "aria-invalid": e.showError,
          "aria-describedby": `error-message-label-${e.id} description-label-${e.id}`,
          resize: ""
        }, Ge(e.listeners, !0)), "      ", 16, Qd)), [
          [pt, i.inputVal]
        ]) : (w(), g("button", {
          key: 1,
          id: e.id,
          class: "add-signature tw-bg-primary/10 tw-py-1.5 tw-px-4 tw-rounded tw-text-primary disabled:tw-bg-gray-20 disabled:tw-text-gray-40 disabled:tw-cursor-default disabled:tw-outline-none disabled:hover:tw-bg-gray-20",
          disabled: e.disabled,
          "aria-labelledby": `label-${e.id}`,
          onClick: r[1] || (r[1] = (h) => n.showTermsDialog = !0)
        }, _(e.$t("formComponents.addSignature")), 9, Kd))
      ]),
      m("span", Zd, _(e.$t("formComponents.eSignature.iUnderstandText")), 1),
      O(l, {
        size: "xl",
        show: n.showTermsDialog,
        onClose: r[4] || (r[4] = (h) => n.showTermsDialog = !1)
      }, {
        default: k(() => [
          O(o, null, {
            default: k(() => [
              se(_(e.$t("formComponents.eSignature.terms.title")), 1)
            ]),
            _: 1
          }),
          O(s, { class: "tw-overflow-x-auto tw-mb-6" }, {
            default: k(() => [
              m("div", {
                class: "dialog-content",
                innerHTML: e.$t("formComponents.eSignature.terms.content")
              }, null, 8, Xd)
            ]),
            _: 1
          }),
          O(u, null, {
            default: k(() => [
              m("button", {
                class: "tw-w-full tw-bg-primary tw-py-1.5 tw-px-4 tw-rounded tw-text-white disabled:tw-bg-gray-20 disabled:tw-text-gray-40 disabled:tw-cursor-default disabled:tw-outline-none disabled:hover:tw-bg-gray-20 tw-h-12",
                onClick: r[3] || (r[3] = (...h) => i.agree && i.agree(...h))
              }, _(e.$t("formComponents.eSignature.terms.iAgree")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "required", "section-child"]);
}
const Da = /* @__PURE__ */ D(zd, [["render", Jd], ["__scopeId", "data-v-51692bb6"]]), ec = {
  name: "a-avatar",
  props: {
    /**
     * Defines the src property of the image to be rendered.
     */
    src: String,
    /**
     * Defines the name value that will be displayed as initials alongside the avatar.
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Defines the size of the image to be rendered.
     * @values small, medium, medium-plus, large
     */
    size: {
      default: "small",
      type: String
    },
    /**
     * Define an aria label to be attached to img roles for accessibility
     */
    ariaLabel: String
  },
  /* eslint-enable vue/component-definition-name-casing, vue/require-default-prop */
  computed: {
    initials() {
      let e = this.name.match(/\b\w/g) || [];
      return e = ((e.shift() || "") + (e.pop() || "")).toUpperCase(), e;
    },
    aria() {
      return this.ariaLabel ? this.ariaLabel : `Avatar ${this.name}`;
    }
  }
}, tc = ["aria-label"], rc = ["src"];
function nc(e, r, t, a, n, i) {
  return w(), g("div", {
    role: "img",
    class: "a-avatar",
    "aria-label": i.aria
  }, [
    t.src ? (w(), g("img", {
      key: 0,
      src: t.src,
      class: re(["img-avatar", t.size]),
      "aria-hidden": ""
    }, null, 10, rc)) : (w(), g("div", {
      key: 1,
      class: re(["text-avatar", t.size])
    }, _(i.initials), 3))
  ], 8, tc);
}
const ac = /* @__PURE__ */ D(ec, [["render", nc], ["__scopeId", "data-v-67d56029"]]);
function qn(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function Se(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? qn(Object(t), !0).forEach(function(a) {
      ic(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : qn(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function ic(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function Rn(e) {
  let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(e).reduce((t, a) => (r.includes(a) || (t[a] = S(e[a])), t), {});
}
function mt(e) {
  return typeof e == "function";
}
function oc(e) {
  return Ha(e) || Ba(e);
}
function $a(e, r, t) {
  let a = e;
  const n = r.split(".");
  for (let i = 0; i < n.length; i++) {
    if (!a[n[i]]) return t;
    a = a[n[i]];
  }
  return a;
}
function sr(e, r, t) {
  return W(() => e.some((a) => $a(r, a, {
    [t]: !1
  })[t]));
}
function Vn(e, r, t) {
  return W(() => e.reduce((a, n) => {
    const i = $a(r, n, {
      [t]: !1
    })[t] || [];
    return a.concat(i);
  }, []));
}
function Oa(e, r, t, a) {
  return e.call(a, S(r), S(t), a);
}
function ka(e) {
  return e.$valid !== void 0 ? !e.$valid : !e;
}
function sc(e, r, t, a, n, i, o) {
  let {
    $lazy: s,
    $rewardEarly: u
  } = n, l = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], d = arguments.length > 8 ? arguments[8] : void 0, h = arguments.length > 9 ? arguments[9] : void 0, y = arguments.length > 10 ? arguments[10] : void 0;
  const v = ee(!!a.value), c = ee(0);
  t.value = !1;
  const f = Pe([r, a].concat(l, y), () => {
    if (s && !a.value || u && !h.value && !t.value)
      return;
    let p;
    try {
      p = Oa(e, r, d, o);
    } catch (b) {
      p = Promise.reject(b);
    }
    c.value++, t.value = !!c.value, v.value = !1, Promise.resolve(p).then((b) => {
      c.value--, t.value = !!c.value, i.value = b, v.value = ka(b);
    }).catch((b) => {
      c.value--, t.value = !!c.value, i.value = b, v.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof r == "object"
  });
  return {
    $invalid: v,
    $unwatch: f
  };
}
function lc(e, r, t, a, n, i, o, s) {
  let {
    $lazy: u,
    $rewardEarly: l
  } = a;
  const d = () => ({}), h = W(() => {
    if (u && !t.value || l && !s.value)
      return !1;
    let y = !0;
    try {
      const v = Oa(e, r, o, i);
      n.value = v, y = ka(v);
    } catch (v) {
      n.value = v;
    }
    return y;
  });
  return {
    $unwatch: d,
    $invalid: h
  };
}
function uc(e, r, t, a, n, i, o, s, u, l, d) {
  const h = ee(!1), y = e.$params || {}, v = ee(null);
  let c, f;
  e.$async ? {
    $invalid: c,
    $unwatch: f
  } = sc(e.$validator, r, h, t, a, v, n, e.$watchTargets, u, l, d) : {
    $invalid: c,
    $unwatch: f
  } = lc(e.$validator, r, t, a, v, n, u, l);
  const p = e.$message;
  return {
    $message: mt(p) ? W(() => p(Rn({
      $pending: h,
      $invalid: c,
      $params: Rn(y),
      $model: r,
      $response: v,
      $validator: i,
      $propertyPath: s,
      $property: o
    }))) : p || "",
    $params: y,
    $pending: h,
    $invalid: c,
    $response: v,
    $unwatch: f
  };
}
function dc() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const r = S(e), t = Object.keys(r), a = {}, n = {}, i = {};
  let o = null;
  return t.forEach((s) => {
    const u = r[s];
    switch (!0) {
      case mt(u.$validator):
        a[s] = u;
        break;
      case mt(u):
        a[s] = {
          $validator: u
        };
        break;
      case s === "$validationGroups":
        o = u;
        break;
      case s.startsWith("$"):
        i[s] = u;
        break;
      default:
        n[s] = u;
    }
  }), {
    rules: a,
    nestedValidators: n,
    config: i,
    validationGroups: o
  };
}
const cc = "__root";
function fc(e, r, t, a, n, i, o, s, u) {
  const l = Object.keys(e), d = a.get(n, e), h = ee(!1), y = ee(!1), v = ee(0);
  if (d) {
    if (!d.$partial) return d;
    d.$unwatch(), h.value = d.$dirty.value;
  }
  const c = {
    $dirty: h,
    $path: n,
    $touch: () => {
      h.value || (h.value = !0);
    },
    $reset: () => {
      h.value && (h.value = !1);
    },
    $commit: () => {
    }
  };
  return l.length ? (l.forEach((f) => {
    c[f] = uc(e[f], r, c.$dirty, i, o, f, t, n, u, y, v);
  }), c.$externalResults = W(() => s.value ? [].concat(s.value).map((f, p) => ({
    $propertyPath: n,
    $property: t,
    $validator: "$externalResults",
    $uid: `${n}-externalResult-${p}`,
    $message: f,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), c.$invalid = W(() => {
    const f = l.some((p) => S(c[p].$invalid));
    return y.value = f, !!c.$externalResults.value.length || f;
  }), c.$pending = W(() => l.some((f) => S(c[f].$pending))), c.$error = W(() => c.$dirty.value ? c.$pending.value || c.$invalid.value : !1), c.$silentErrors = W(() => l.filter((f) => S(c[f].$invalid)).map((f) => {
    const p = c[f];
    return pr({
      $propertyPath: n,
      $property: t,
      $validator: f,
      $uid: `${n}-${f}`,
      $message: p.$message,
      $params: p.$params,
      $response: p.$response,
      $pending: p.$pending
    });
  }).concat(c.$externalResults.value)), c.$errors = W(() => c.$dirty.value ? c.$silentErrors.value : []), c.$unwatch = () => l.forEach((f) => {
    c[f].$unwatch();
  }), c.$commit = () => {
    y.value = !0, v.value = Date.now();
  }, a.set(n, e, c), c) : (d && a.set(n, e, c), c);
}
function hc(e, r, t, a, n, i, o) {
  const s = Object.keys(e);
  return s.length ? s.reduce((u, l) => (u[l] = hr({
    validations: e[l],
    state: r,
    key: l,
    parentKey: t,
    resultsCache: a,
    globalConfig: n,
    instance: i,
    externalResults: o
  }), u), {}) : {};
}
function mc(e, r, t) {
  const a = W(() => [r, t].filter((c) => c).reduce((c, f) => c.concat(Object.values(S(f))), [])), n = W({
    get() {
      return e.$dirty.value || (a.value.length ? a.value.every((c) => c.$dirty) : !1);
    },
    set(c) {
      e.$dirty.value = c;
    }
  }), i = W(() => {
    const c = S(e.$silentErrors) || [], f = a.value.filter((p) => (S(p).$silentErrors || []).length).reduce((p, b) => p.concat(...b.$silentErrors), []);
    return c.concat(f);
  }), o = W(() => {
    const c = S(e.$errors) || [], f = a.value.filter((p) => (S(p).$errors || []).length).reduce((p, b) => p.concat(...b.$errors), []);
    return c.concat(f);
  }), s = W(() => a.value.some((c) => c.$invalid) || S(e.$invalid) || !1), u = W(() => a.value.some((c) => S(c.$pending)) || S(e.$pending) || !1), l = W(() => a.value.some((c) => c.$dirty) || a.value.some((c) => c.$anyDirty) || n.value), d = W(() => n.value ? u.value || s.value : !1), h = () => {
    e.$touch(), a.value.forEach((c) => {
      c.$touch();
    });
  }, y = () => {
    e.$commit(), a.value.forEach((c) => {
      c.$commit();
    });
  }, v = () => {
    e.$reset(), a.value.forEach((c) => {
      c.$reset();
    });
  };
  return a.value.length && a.value.every((c) => c.$dirty) && h(), {
    $dirty: n,
    $errors: o,
    $invalid: s,
    $anyDirty: l,
    $error: d,
    $pending: u,
    $touch: h,
    $reset: v,
    $silentErrors: i,
    $commit: y
  };
}
function hr(e) {
  let {
    validations: r,
    state: t,
    key: a,
    parentKey: n,
    childResults: i,
    resultsCache: o,
    globalConfig: s = {},
    instance: u,
    externalResults: l
  } = e;
  const d = n ? `${n}.${a}` : a, {
    rules: h,
    nestedValidators: y,
    config: v,
    validationGroups: c
  } = dc(r), f = Se(Se({}, s), v), p = a ? W(() => {
    const U = S(t);
    return U ? S(U[a]) : void 0;
  }) : t, b = Se({}, S(l) || {}), $ = W(() => {
    const U = S(l);
    return a ? U ? S(U[a]) : void 0 : U;
  }), q = fc(h, p, a, o, d, f, u, $, t), j = hc(y, p, d, o, f, u, $), ne = {};
  c && Object.entries(c).forEach((U) => {
    let [ve, we] = U;
    ne[ve] = {
      $invalid: sr(we, j, "$invalid"),
      $error: sr(we, j, "$error"),
      $pending: sr(we, j, "$pending"),
      $errors: Vn(we, j, "$errors"),
      $silentErrors: Vn(we, j, "$silentErrors")
    };
  });
  const {
    $dirty: oe,
    $errors: ge,
    $invalid: ae,
    $anyDirty: pe,
    $error: de,
    $pending: H,
    $touch: B,
    $reset: R,
    $silentErrors: ue,
    $commit: ce
  } = mc(q, j, i), Te = a ? W({
    get: () => S(p),
    set: (U) => {
      oe.value = !0;
      const ve = S(t), we = S(l);
      we && (we[a] = b[a]), ur(ve[a]) ? ve[a].value = U : ve[a] = U;
    }
  }) : null;
  a && f.$autoDirty && Pe(p, () => {
    oe.value || B();
    const U = S(l);
    U && (U[a] = b[a]);
  }, {
    flush: "sync"
  });
  async function Me() {
    return B(), f.$rewardEarly && (ce(), await Vr()), await Vr(), new Promise((U) => {
      if (!H.value) return U(!ae.value);
      const ve = Pe(H, () => {
        U(!ae.value), ve();
      });
    });
  }
  function De(U) {
    return (i.value || {})[U];
  }
  function Le() {
    ur(l) ? l.value = b : Object.keys(b).length === 0 ? Object.keys(l).forEach((U) => {
      delete l[U];
    }) : Object.assign(l, b);
  }
  return pr(Se(Se(Se({}, q), {}, {
    $model: Te,
    $dirty: oe,
    $error: de,
    $errors: ge,
    $invalid: ae,
    $anyDirty: pe,
    $pending: H,
    $touch: B,
    $reset: R,
    $path: d || cc,
    $silentErrors: ue,
    $validate: Me,
    $commit: ce
  }, i && {
    $getResultsForChild: De,
    $clearExternalResults: Le,
    $validationGroups: ne
  }), j));
}
class pc {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(r, t, a) {
    this.storage.set(r, {
      rules: t,
      result: a
    });
  }
  checkRulesValidity(r, t, a) {
    const n = Object.keys(a), i = Object.keys(t);
    return i.length !== n.length || !i.every((s) => n.includes(s)) ? !1 : i.every((s) => t[s].$params ? Object.keys(t[s].$params).every((u) => S(a[s].$params[u]) === S(t[s].$params[u])) : !0);
  }
  get(r, t) {
    const a = this.storage.get(r);
    if (!a) return;
    const {
      rules: n,
      result: i
    } = a, o = this.checkRulesValidity(r, t, n), s = i.$unwatch ? i.$unwatch : () => ({});
    return o ? i : {
      $dirty: i.$dirty,
      $partial: !0,
      $unwatch: s
    };
  }
}
const lt = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, Ln = Symbol("vuelidate#injectChildResults"), Un = Symbol("vuelidate#removeChildResults");
function wc(e) {
  let {
    $scope: r,
    instance: t
  } = e;
  const a = {}, n = ee([]), i = W(() => n.value.reduce((d, h) => (d[h] = S(a[h]), d), {}));
  function o(d, h) {
    let {
      $registerAs: y,
      $scope: v,
      $stopPropagation: c
    } = h;
    c || r === lt.COLLECT_NONE || v === lt.COLLECT_NONE || r !== lt.COLLECT_ALL && r !== v || (a[y] = d, n.value.push(y));
  }
  t.__vuelidateInjectInstances = [].concat(t.__vuelidateInjectInstances || [], o);
  function s(d) {
    n.value = n.value.filter((h) => h !== d), delete a[d];
  }
  t.__vuelidateRemoveInstances = [].concat(t.__vuelidateRemoveInstances || [], s);
  const u = qr(Ln, []);
  Rr(Ln, t.__vuelidateInjectInstances);
  const l = qr(Un, []);
  return Rr(Un, t.__vuelidateRemoveInstances), {
    childResults: i,
    sendValidationResultsToParent: u,
    removeValidationResultsFromParent: l
  };
}
function Ma(e) {
  return new Proxy(e, {
    get(r, t) {
      return typeof r[t] == "object" ? Ma(r[t]) : W(() => r[t]);
    }
  });
}
let Nn = 0;
function kr(e, r) {
  var t;
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (a = e, e = void 0, r = void 0);
  let {
    $registerAs: n,
    $scope: i = lt.COLLECT_ALL,
    $stopPropagation: o,
    $externalResults: s,
    currentVueInstance: u
  } = a;
  const l = u || ((t = Fa()) === null || t === void 0 ? void 0 : t.proxy), d = l ? l.$options : {};
  n || (Nn += 1, n = `_vuelidate_${Nn}`);
  const h = ee({}), y = new pc(), {
    childResults: v,
    sendValidationResultsToParent: c,
    removeValidationResultsFromParent: f
  } = l ? wc({
    $scope: i,
    instance: l
  }) : {
    childResults: ee({})
  };
  if (!e && d.validations) {
    const p = d.validations;
    r = ee({}), Wa(() => {
      r.value = l, Pe(() => mt(p) ? p.call(r.value, new Ma(r.value)) : p, (b) => {
        h.value = hr({
          validations: b,
          state: r,
          childResults: v,
          resultsCache: y,
          globalConfig: a,
          instance: l,
          externalResults: s || l.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), a = d.validationsConfig || a;
  } else {
    const p = ur(e) || oc(e) ? e : pr(e || {});
    Pe(p, (b) => {
      h.value = hr({
        validations: b,
        state: r,
        childResults: v,
        resultsCache: y,
        globalConfig: a,
        instance: l ?? {},
        externalResults: s
      });
    }, {
      immediate: !0
    });
  }
  return l && (c.forEach((p) => p(h, {
    $registerAs: n,
    $scope: i,
    $stopPropagation: o
  })), ja(() => f.forEach((p) => p(n)))), W(() => Se(Se({}, S(h.value)), v.value));
}
const Mr = (e) => {
  if (e = S(e), Array.isArray(e)) return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let r in e) return !0;
    return !1;
  }
  return !!String(e).length;
}, gc = (e) => (e = S(e), Array.isArray(e) ? e.length : typeof e == "object" ? Object.keys(e).length : String(e).length);
function Ve() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return (a) => (a = S(a), !Mr(a) || r.every((n) => (n.lastIndex = 0, n.test(a))));
}
Ve(/^[a-zA-Z]*$/);
Ve(/^[a-zA-Z0-9]*$/);
Ve(/^\d*(\.\d+)?$/);
const vc = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var yc = Ve(vc), Ea = {
  $validator: yc,
  $message: "Value is not a valid email address",
  $params: {
    type: "email"
  }
};
function bc(e) {
  return (r) => !Mr(r) || gc(r) >= S(e);
}
function Cc(e) {
  return {
    $validator: bc(e),
    $message: (r) => {
      let {
        $params: t
      } = r;
      return `This field should be at least ${t.min} characters long`;
    },
    $params: {
      min: e,
      type: "minLength"
    }
  };
}
function xc(e) {
  return typeof e == "string" && (e = e.trim()), Mr(e);
}
var Sa = {
  $validator: xc,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
const _c = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
Ve(_c);
Ve(/(^[0-9]*$)|(^-[0-9]+$)/);
Ve(/^[-]?\d*(\.\d+)?$/);
const Tc = {
  name: "FcInputField",
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: "text"
    },
    name: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    showError: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: "text"
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, Dc = { class: "tw-flex tw-flex-col" }, $c = ["for"], Oc = {
  key: 0,
  class: "tw-text-error"
}, kc = ["id", "name", "type", "placeholder", "required", "disabled"], Mc = {
  key: 1,
  class: "tw-flex tw-align-middle tw-items-center"
}, Ec = { class: "tw-text-[14px] tw-tracking-[0.4px] tw-text-error" };
function Sc(e, r, t, a, n, i) {
  return w(), g("div", Dc, [
    t.label ? (w(), g("label", {
      key: 0,
      class: "tw-font-medium tw-leading-5 tw-mb-1",
      for: t.name
    }, [
      se(_(t.label) + " ", 1),
      t.required ? (w(), g("span", Oc, "*")) : P("", !0)
    ], 8, $c)) : P("", !0),
    $e(m("input", {
      id: t.name,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => i.internalValue = o),
      class: re(["tw-w-full tw-border-b tw-outline-none tw-bg-neutral-50 tw-rounded-t tw-p-3 tw-text-sm tw-font-sans", {
        "tw-border-b-primary/[0.4] tw-outline-none focus:tw-border-b-primary": !t.showError,
        "tw-border-b-error/[0.4]  focus:tw-border-b-error": t.showError
      }]),
      name: t.name,
      type: t.type,
      placeholder: t.placeholder,
      required: t.required,
      disabled: t.disabled
    }, null, 10, kc), [
      [mr, i.internalValue]
    ]),
    t.showError ? (w(), g("div", Mc, [
      m("span", Ec, _(t.errorMessage), 1)
    ])) : P("", !0)
  ]);
}
const Pc = /* @__PURE__ */ D(Tc, [["render", Sc]]), Ic = ["primary", "secondary", "tertiary", "transparent"], Ac = {
  name: "a-button",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: (e) => Ic.includes(e)
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    backgroundColor: {
      type: String,
      // Expect a hex value
      default: void 0
    },
    textColor: {
      type: String,
      // Expect a hex value
      default: void 0
    }
  }
}, qc = ["disabled"];
function Rc(e, r, t, a, n, i) {
  return w(), g("button", ze({
    class: ["tw-flex tw-rounded tw-text-sm tw-font-sans tw-py-1.5 tw-px-4 tw-justify-center tw-items-center", [`a-button--${t.variant}`]],
    disabled: t.disabled,
    style: {
      "--background-color": t.backgroundColor,
      "--text-color": t.textColor
    }
  }, Ge(e.$attrs, !0)), [
    be(e.$slots, "default", {}, void 0, !0)
  ], 16, qc);
}
const Er = /* @__PURE__ */ D(Ac, [["render", Rc], ["__scopeId", "data-v-cd8ff2a6"]]), Vc = {
  components: {
    Input: Pc,
    Button: Er,
    Dialog: Tr,
    DialogHeader: Dr,
    DialogContent: $r,
    DialogFooter: Or
  },
  props: {
    brandColor: {
      type: String,
      default: null,
      required: !0
    }
  },
  setup() {
    return { v$: kr() };
  },
  data() {
    return {
      email: null
    };
  },
  validations() {
    return {
      email: { email: Ea, required: Sa }
    };
  },
  computed: {
    emailErrorMessage() {
      return this.v$.email.email ? this.$t("formComponents.thisFieldIsRequired") : this.$t("formComponents.invalidEmail");
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onSendCode() {
      this.v$.$touch(), this.v$.$error || this.$emit("send", this.email);
    },
    onCancel() {
      this.$emit("close");
    }
  }
}, Lc = { class: "tw-flex tw-flex-col tw-gap-y-6" }, Uc = { class: "tw-flex tw-gap-x-2" };
function Nc(e, r, t, a, n, i) {
  const o = T("dialog-header"), s = T("Input"), u = T("dialog-content"), l = T("Button"), d = T("dialog-footer"), h = T("Dialog");
  return w(), Q(h, {
    size: "xl",
    show: !0,
    onClose: i.onClose
  }, {
    default: k(() => [
      O(o, null, {
        default: k(() => [
          se(_(e.$t("formComponents.emailVerificationModal.validationRequired")), 1)
        ]),
        _: 1
      }),
      O(u, { class: "tw-overflow-x-auto tw-mb-6" }, {
        default: k(() => [
          m("div", Lc, [
            m("div", null, _(e.$t("formComponents.emailVerificationModal.modalDescription")), 1),
            O(s, {
              modelValue: n.email,
              "onUpdate:modelValue": r[0] || (r[0] = (y) => n.email = y),
              label: e.$t("formComponents.emailVerificationModal.emailAddress"),
              placeholder: e.$t("formComponents.emailVerificationModal.enterEmailAddress"),
              type: "email",
              required: "",
              "show-error": a.v$.$error,
              "error-message": i.emailErrorMessage
            }, null, 8, ["modelValue", "label", "placeholder", "show-error", "error-message"])
          ])
        ]),
        _: 1
      }),
      O(d, null, {
        default: k(() => [
          m("div", Uc, [
            O(l, {
              variant: "primary",
              "background-color": t.brandColor,
              "text-color": "white",
              onClick: i.onSendCode
            }, {
              default: k(() => [
                se(_(e.$t("formComponents.emailVerificationModal.sendCode")), 1)
              ]),
              _: 1
            }, 8, ["background-color", "onClick"]),
            O(l, {
              variant: "secondary",
              "background-color": `${t.brandColor}0F`,
              "text-color": t.brandColor,
              onClick: i.onCancel
            }, {
              default: k(() => [
                se(_(e.$t("formComponents.emailVerificationModal.cancel")), 1)
              ]),
              _: 1
            }, 8, ["background-color", "text-color", "onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClose"]);
}
const Fc = /* @__PURE__ */ D(Vc, [["render", Nc]]), Wc = {
  name: "LockIcon",
  props: {
    brandColor: {
      type: String,
      default: null,
      required: !0
    }
  }
}, jc = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hc = ["fill"], Bc = ["fill"];
function Yc(e, r, t, a, n, i) {
  return w(), g("svg", jc, [
    m("circle", {
      cx: "36",
      cy: "36",
      r: "36",
      fill: t.brandColor,
      class: "opacity"
    }, null, 8, Hc),
    m("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M44.3333 48H27.6667C26.7478 48 26 47.2653 26 46.3631V34.3631C26 33.4609 26.7478 32.7273 27.6667 32.7273H29.3333V30.5449C29.3333 26.9356 32.3239 24 36 24C39.6761 24 42.6667 26.9356 42.6667 30.5449V32.7273H44.3333C45.2522 32.7273 46 33.4609 46 34.3631V46.3631C46 47.2653 45.2522 48 44.3333 48ZM36 25.0909C32.9367 25.0909 30.4444 27.5373 30.4444 30.5449V32.7273H41.5556V30.5449C41.5556 27.5373 39.0633 25.0909 36 25.0909ZM44.8889 34.3631C44.8889 34.062 44.6394 33.8176 44.3333 33.8176H27.6667C27.3606 33.8176 27.1111 34.062 27.1111 34.3631V46.3631C27.1111 46.6642 27.3606 46.9091 27.6667 46.9091H44.3333C44.6394 46.9091 44.8889 46.6642 44.8889 46.3631V34.3631ZM36.5556 40.2627V43.0904C36.5556 43.392 36.3067 43.6358 36 43.6358C35.6933 43.6358 35.4444 43.392 35.4444 43.0904V40.2627C34.7989 40.0369 34.3333 39.4369 34.3333 38.7267C34.3333 37.824 35.0811 37.0904 36 37.0904C36.9189 37.0904 37.6667 37.824 37.6667 38.7267C37.6667 39.4369 37.2006 40.0369 36.5556 40.2627ZM36 38.1813C35.6939 38.1813 35.4444 38.4262 35.4444 38.7267C35.4444 39.0273 35.6939 39.2727 36 39.2727C36.3061 39.2727 36.5556 39.0273 36.5556 38.7267C36.5556 38.4262 36.3061 38.1813 36 38.1813Z",
      fill: t.brandColor
    }, null, 8, Bc)
  ]);
}
const zc = /* @__PURE__ */ D(Wc, [["render", Yc], ["__scopeId", "data-v-2a2e23b1"]]), Gc = {
  name: "FcAuthInput",
  components: {
    Button: Er,
    LockIcon: zc,
    FcDialog: Tr,
    FcDialogHeader: Dr,
    FcDialogContent: $r,
    FcDialogFooter: Or
  },
  props: {
    brandColor: {
      type: String,
      default: null,
      required: !0
    },
    showError: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    return { v$: kr() };
  },
  data() {
    return {
      inputRefs: [0, 1, 2, 3, 4, 5],
      inputCodeValue: "",
      forwardKeys: [38, 39],
      backwardKeys: [8, 37, 40],
      resend: !1
    };
  },
  validations() {
    return {
      inputCodeValue: {
        required: Sa,
        minLength: Cc(6)
      }
    };
  },
  computed: {
    invalidCode() {
      return this.v$.$error || this.showError;
    }
  },
  mounted() {
    this.$refs.codeInputs[0].focus();
  },
  methods: {
    resendCode() {
      this.$emit("resend-otp-code"), this.resend = !0;
    },
    onValueChange(e) {
      const r = parseInt(e.target.dataset.id);
      e.target.value.match(/\d/) || (this.$refs.codeInputs[r].value = "");
    },
    onKeyUp(e) {
      const r = parseInt(e.target.dataset.id), t = e.key.match(/\d/);
      (t || this.forwardKeys.includes(e.keyCode)) && (t && (this.$refs.codeInputs[r].value = t), r < this.inputRefs.length - 1 && this.$refs.codeInputs[r + 1].focus()), this.backwardKeys.includes(e.keyCode) && r > 0 && this.$refs.codeInputs[r - 1].focus(), this.inputCodeValue = this.$refs.codeInputs.reduce(
        (a, n) => a + n.value,
        ""
      );
    },
    onConfirm() {
      this.v$.$touch(), this.v$.$error || this.$emit("confirm-code", this.inputCodeValue);
    },
    onPaste(e) {
      const t = e.clipboardData.getData("text").replace(/[^0-9]/g, ""), a = [...t];
      this.$refs.codeInputs.forEach((n, i) => n.value = a[i] ?? ""), this.$refs.codeInputs[t.length - 1].focus();
    }
  }
}, Qc = { class: "top-icon" }, Kc = { class: "content-description" }, Zc = { class: "inputs-container" }, Xc = ["data-id"], Jc = { class: "footer" }, ef = {
  key: 0,
  for: "",
  class: "error-message"
}, tf = {
  key: 1,
  class: "details-footer"
}, rf = { for: "" }, nf = { key: 2 };
function af(e, r, t, a, n, i) {
  const o = T("lock-icon"), s = T("fc-dialog-header"), u = T("fc-dialog-content"), l = T("Button"), d = T("fc-dialog-footer"), h = T("fc-dialog");
  return w(), g("div", null, [
    O(h, {
      show: !0,
      size: "430px",
      onClose: r[3] || (r[3] = (y) => e.$emit("close"))
    }, {
      default: k(() => [
        m("div", Qc, [
          O(o, { "brand-color": t.brandColor }, null, 8, ["brand-color"])
        ]),
        O(s, { class: "header-title" }, {
          default: k(() => [
            se(_(e.$t("formComponents.authenticationCodeModal.title")), 1)
          ]),
          _: 1
        }),
        O(u, null, {
          default: k(() => [
            m("p", Kc, _(e.$t("formComponents.authenticationCodeModal.description")), 1)
          ]),
          _: 1
        }),
        O(u, null, {
          default: k(() => [
            m("div", Zc, [
              (w(!0), g(fe, null, he(n.inputRefs, (y, v) => (w(), g("div", { key: v }, [
                m("input", {
                  ref_for: !0,
                  ref: "codeInputs",
                  "data-id": v,
                  class: re(["single-input", { "error-border": i.invalidCode }]),
                  type: "text",
                  maxlength: "1",
                  onPaste: r[0] || (r[0] = (...c) => i.onPaste && i.onPaste(...c)),
                  onInput: r[1] || (r[1] = (...c) => i.onValueChange && i.onValueChange(...c)),
                  onKeyup: r[2] || (r[2] = (...c) => i.onKeyUp && i.onKeyUp(...c))
                }, null, 42, Xc)
              ]))), 128))
            ])
          ]),
          _: 1
        }),
        O(d, null, {
          default: k(() => [
            m("div", Jc, [
              i.invalidCode ? (w(), g("label", ef, _(e.$t("formComponents.authenticationCodeModal.incorrectCode")), 1)) : P("", !0),
              O(l, {
                class: "confirm-button",
                variant: "primary",
                "background-color": t.brandColor,
                "text-color": "white",
                onClick: i.onConfirm
              }, {
                default: k(() => [
                  se(_(e.$t("formComponents.authenticationCodeModal.confirm")), 1)
                ]),
                _: 1
              }, 8, ["background-color", "onClick"]),
              n.resend ? (w(), g("label", nf, _(e.$t("formComponents.authenticationCodeModal.replacementCodeSent")), 1)) : (w(), g("div", tf, [
                m("label", rf, _(e.$t("formComponents.authenticationCodeModal.footerDetails")), 1),
                O(l, {
                  variant: "transparent",
                  "text-color": t.brandColor,
                  onClick: i.resendCode
                }, {
                  default: k(() => [
                    se(_(e.$t("formComponents.authenticationCodeModal.resend")), 1)
                  ]),
                  _: 1
                }, 8, ["text-color", "onClick"])
              ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const Pa = /* @__PURE__ */ D(Gc, [["render", af], ["__scopeId", "data-v-97adac87"]]), of = {}, sf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function lf(e, r) {
  return w(), g("svg", sf, r[0] || (r[0] = [
    m("circle", {
      cx: "12",
      cy: "12",
      r: "7.5",
      stroke: "#662E80"
    }, null, -1),
    m("path", {
      d: "M9 12H15",
      stroke: "#662E80",
      "stroke-linecap": "round"
    }, null, -1),
    m("path", {
      d: "M12 15V9",
      stroke: "#662E80",
      "stroke-linecap": "round"
    }, null, -1)
  ]));
}
const uf = /* @__PURE__ */ D(of, [["render", lf]]), df = {};
function cf(e, r) {
  return w(), g("svg", ze({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "tw-cursor-pointer"
  }, Ge(e.$attrs, !0)), r[0] || (r[0] = [
    m("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.14645 4.14645C4.34171 3.95118 4.65829 3.95118 4.85355 4.14645L11.8536 11.1464C12.0488 11.3417 12.0488 11.6583 11.8536 11.8536C11.6583 12.0488 11.3417 12.0488 11.1464 11.8536L4.14645 4.85355C3.95118 4.65829 3.95118 4.34171 4.14645 4.14645Z",
      fill: "#333333"
    }, null, -1),
    m("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.8536 4.14645C12.0488 4.34171 12.0488 4.65829 11.8536 4.85355L4.85355 11.8536C4.65829 12.0488 4.34171 12.0488 4.14645 11.8536C3.95118 11.6583 3.95118 11.3417 4.14645 11.1464L11.1464 4.14645C11.3417 3.95118 11.6583 3.95118 11.8536 4.14645Z",
      fill: "#333333"
    }, null, -1)
  ]), 16);
}
const ff = /* @__PURE__ */ D(df, [["render", cf]]), hf = {
  name: "FcFilePreview",
  components: {
    CloseIcon: ff
  },
  props: ["file"],
  methods: {
    getFileIcon(e) {
      return e != null && e.includes("image") ? "image" : "file";
    }
  },
  computed: {
    url() {
      return this.getFileIcon(this.file.type) === "image" ? URL.createObjectURL(this.file) : new URL("data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3crect%20x='0.5'%20y='0.5'%20width='39'%20height='39'%20rx='1.5'%20stroke='%23EEE9F8'%20/%3e%3cpath%20d='M12.875%2027.625V12.375C12.875%2011.8227%2013.3227%2011.375%2013.875%2011.375H22.2108C22.476%2011.375%2022.7304%2011.4804%2022.9179%2011.6679L26.8321%2015.5821C27.0196%2015.7696%2027.125%2016.024%2027.125%2016.2892V27.625C27.125%2028.1773%2026.6773%2028.625%2026.125%2028.625H13.875C13.3227%2028.625%2012.875%2028.1773%2012.875%2027.625Z'%20stroke='%23333333'%20stroke-linejoin='round'%20/%3e%3c/svg%3e", import.meta.url);
    }
  }
}, mf = { class: "tw-flex tw-items-center tw-justify-between tw-border-y tw-border-gray tw-p-[8px]" }, pf = { class: "tw-flex tw-items-center tw-gap-x-[8px]" }, wf = ["src"], gf = { class: "tw-text-[14px] tw-text-gray-regular" };
function vf(e, r, t, a, n, i) {
  const o = T("CloseIcon");
  return w(), g("div", mf, [
    m("div", pf, [
      m("img", {
        src: i.url,
        class: "tw-h-[40px] tw-w-[40px]"
      }, null, 8, wf),
      m("span", gf, _(t.file.name), 1)
    ]),
    O(o, {
      onClick: r[0] || (r[0] = (s) => e.$emit("remove"))
    })
  ]);
}
const yf = /* @__PURE__ */ D(hf, [["render", vf]]), bf = {
  name: "FcFileUpload",
  components: {
    Question: ke,
    Button: Er,
    AddIcon: uf,
    FilePreview: yf
  },
  mixins: [_e],
  props: {
    modelValue: {
      type: [Array, String, Number],
      default: ""
    }
  },
  computed: {
    files: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    browseFiles() {
      this.$refs.inputFiles.blur(), this.$refs.inputFiles.click();
    },
    onInputChange(e) {
      const r = Array.from(e.target.files);
      this.files = [...this.files, ...r];
    },
    removeFile(e) {
      this.files.splice(e, 1);
    }
  }
}, Cf = { class: "tw-mt-[24px] tw-flex tw-justify-center tw-flex-col tw-gap-y-[16px]" }, xf = { class: "tw-flex tw-items-center tw-gap-x-[8px]" }, _f = { class: "tw-flex tw-justify-center tw-items-center tw-gap-x-[8px]" }, Tf = { class: "tw-text-gray-40" };
function Df(e, r, t, a, n, i) {
  const o = T("file-preview"), s = T("add-icon"), u = T("Button"), l = T("question");
  return w(), Q(l, {
    id: `label-${e.id}`,
    title: e.title,
    description: e.description,
    "show-error": e.showError,
    "error-message": e.errorMessage,
    required: e.required,
    "section-child": e.sectionChild
  }, {
    default: k(() => [
      m("div", Cf, [
        (w(!0), g(fe, null, he(i.files, (d, h) => (w(), Q(o, {
          key: h,
          file: d,
          index: h,
          onRemove: (y) => i.removeFile(h)
        }, null, 8, ["file", "index", "onRemove"]))), 128)),
        m("div", xf, [
          O(u, {
            class: "file-upload",
            "aria-labelledby": `label-${e.id}`,
            variant: "tertiary",
            onClick: i.browseFiles
          }, {
            default: k(() => [
              m("div", _f, [
                O(s),
                se(" " + _(e.$t("formComponents.attachFiles")), 1)
              ])
            ]),
            _: 1
          }, 8, ["aria-labelledby", "onClick"]),
          m("span", Tf, _(e.$t("formComponents.maxNFiles", { n: 10 })) + " | " + _(e.$t("formComponents.mbLimit", { n: 200 })), 1),
          m("input", {
            ref: "inputFiles",
            type: "file",
            hidden: "",
            multiple: "",
            onChange: r[0] || (r[0] = (...d) => i.onInputChange && i.onInputChange(...d))
          }, null, 544)
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "title", "description", "show-error", "error-message", "required", "section-child"]);
}
const $f = /* @__PURE__ */ D(bf, [["render", Df]]), Fn = 200, Of = {
  components: {
    FcInput: Kn,
    FcChoicePicker: Wn,
    FcScale: Zn,
    FcDropdown: Gn,
    FcTextarea: Xn,
    FcDateTimePicker: Ta,
    FcESignature: Da,
    FcFileUpload: $f,
    FcAuthInput: Pa
  },
  props: {
    modelValue: {
      type: [String, Array, Number],
      default: ""
    },
    question: {
      type: Object,
      default: () => {
      }
    },
    questionIndex: {
      type: Number,
      default: 0
    },
    validate: Boolean,
    focusedByKeyboard: Boolean
  },
  data() {
    return {
      validTime: !1,
      validDate: !1
    };
  },
  setup() {
    return { v$: kr() };
  },
  computed: {
    answer: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    questionType() {
      return this.question.elementType === "EMAIL" ? "email" : this.question.elementType === "PHONE_NUMBER" ? "phone" : "text";
    },
    errorMessage() {
      return this.answer === "" ? this.$t("formComponents.thisFieldIsRequired") : this.question.config.dateTimeType === "date" ? this.$t("formComponents.invalidDate") : this.question.config.dateTimeType === "time" ? this.$t("formComponents.invalidTime") : this.question.config.dateTimeType === "date_time" ? this.$t("formComponents.invalidDateOrTime") : this.question.elementType === "EMAIL" ? this.$t("formComponents.invalidEmail") : this.question.elementType === "PHONE_NUMBER" ? this.$t("formComponents.invalidPhone") : this.question.elementType === "FILE_UPLOAD" && this.answer.length > 10 ? this.$t("formComponents.fileUploadMaxFilesError") : this.question.elementType === "FILE_UPLOAD" && this.answer.reduce((e, r) => e + r.size, 0) >= Fn * 1e6 ? this.$t("formComponents.fileUploadLimitExceeded") : this.$t("formComponents.thisFieldIsRequired");
    },
    questionComponent() {
      switch (this.question.elementType) {
        case "SHORT_ANSWER":
          return "FcInput";
        case "LONG_ANSWER":
          return "FcTextarea";
        case "DATE_TIME":
          return "FcDateTimePicker";
        case "SINGLE_CHOICE":
          return this.question.config.dropdown ? "FcDropdown" : "FcChoicePicker";
        case "MULTIPLE_CHOICE":
          return this.question.config.dropdown ? "FcDropdown" : "FcChoicePicker";
        case "SCALE":
          return "FcScale";
        case "PHONE_NUMBER":
          return "FcInput";
        case "EMAIL":
          return "FcInput";
        case "E_SIGNATURE":
          return "FcESignature";
        case "FILE_UPLOAD":
          return "FcFileUpload";
        default:
          return "";
      }
    },
    placeholder() {
      switch (this.question.elementType) {
        case "PHONE_NUMBER":
          return "000 000 0000";
        case "EMAIL":
          return this.$t("formComponents.enterEmailAddress");
        case "LONG_ANSWER":
          return this.$t("formComponents.longAnswerPlaceholder");
        default:
          return this.$t("formComponents.answerHere");
      }
    }
  },
  watch: {
    answer() {
      this.$emit("touch", !this.v$.$invalid);
    },
    validate() {
      this.validate && this.v$.$touch();
    }
  },
  mounted() {
    this.$emit("touch", !this.v$.$invalid);
  },
  validations() {
    const e = {
      answer: {
        isValid(r) {
          const { elementType: t, config: a } = this.question, { requiredAnswer: n } = a || {};
          return t === "PHONE_NUMBER" && r ? /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
            r
          ) : t === "FILE_UPLOAD" && r ? r.length <= 10 && r.reduce((i, o) => i + o.size, 0) <= Fn * 1e6 : t === "MULTIPLE_CHOICE" && n && Ya(r) ? !!za(r).length : this.question.config.dateTimeType === "date" ? this.validDate : this.question.config.dateTimeType === "time" ? this.validTime : this.question.config.dateTimeType === "date_time" ? this.validDate && this.validTime : n ? !!r : !0;
        }
      }
    };
    return this.question.elementType === "EMAIL" && (e.answer.email = Ea), e;
  },
  methods: {
    setAcceptedAt(e) {
      this.$emit("agree", e);
    }
  }
};
function kf(e, r, t, a, n, i) {
  return w(), g("div", null, [
    (w(), Q(tt(i.questionComponent), {
      modelValue: i.answer,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => i.answer = o),
      id: t.question.id,
      "data-testid": `form-question-${t.question.id}`,
      title: `${t.questionIndex}) ${t.question.title}`,
      description: t.question.config.description,
      "show-error": a.v$.answer.$error,
      "error-message": i.errorMessage,
      placeholder: i.placeholder,
      "show-char-counter": !!t.question.config.characterNoLimit,
      "max-length": t.question.config.characterNoLimit,
      required: t.question.config.requiredAnswer,
      "section-child": !!t.question.sectionId,
      choices: t.question.elementChoices,
      multiple: t.question.elementType === "MULTIPLE_CHOICE",
      dropdown: t.question.config.dropdown,
      "upper-bound": t.question.config.upperBound,
      "left-label": t.question.config.leftLabel,
      "right-label": t.question.config.rightLabel,
      "date-time-type": t.question.config.dateTimeType,
      "focused-by-keyboard": t.focusedByKeyboard,
      type: i.questionType,
      onAgree: i.setAcceptedAt,
      onValidateTime: r[1] || (r[1] = (o) => n.validTime = o),
      onValidateDate: r[2] || (r[2] = (o) => n.validDate = o)
    }, null, 40, ["modelValue", "id", "data-testid", "title", "description", "show-error", "error-message", "placeholder", "show-char-counter", "max-length", "required", "section-child", "choices", "multiple", "dropdown", "upper-bound", "left-label", "right-label", "date-time-type", "focused-by-keyboard", "type", "onAgree"]))
  ]);
}
const Mf = /* @__PURE__ */ D(Of, [["render", kf]]), Ef = ["_blank", "_self", "_parent", "_top", ""], st = "element_choice_id", Fe = "answer_text", Sf = "files", Pf = {
  SINGLE_CHOICE: st,
  MULTIPLE_CHOICE: st,
  SCALE: st,
  RANKING: st,
  SHORT_ANSWER: Fe,
  LONG_ANSWER: Fe,
  PHONE_NUMBER: Fe,
  DATE_TIME: Fe,
  EMAIL: Fe,
  E_SIGNATURE: Fe,
  FILE_UPLOAD: Sf
}, If = {
  name: "FcFormRenderer",
  components: {
    QuestionContainer: Mf,
    SharedAvatar: ac,
    EmailVerificationModal: Fc,
    AuthCodeInput: Pa
  },
  props: {
    form: {
      type: Object,
      default: {}
    },
    disableOtp: {
      type: Boolean,
      default: !1
    },
    primaryColor: {
      type: String,
      default: "#662E80"
    },
    linkColor: {
      type: String,
      default: "#662E80"
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    logo: {
      type: String,
      default: ""
    },
    branding: {
      type: String,
      default: ""
    },
    questions: {
      type: Array,
      required: !0
    },
    previewMode: {
      type: Boolean,
      default: !1
    },
    answers: {
      type: Array,
      default: () => []
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    closeDate: {
      type: String,
      default: ""
    },
    privacyPolicyUrl: {
      type: String,
      default: "#"
    },
    privacyPolicyTarget: {
      type: String,
      default: "",
      validator(e) {
        return Ef.includes(e);
      }
    },
    invalidOtpCode: {
      type: Boolean,
      default: !1
    },
    isValid: {
      type: Boolean,
      default: !1
    },
    answersFormDataFormat: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      version: "1.0.9",
      showEmailModal: !1,
      showAuthModal: !1,
      validate: !1,
      validationsArray: new Array(this.answers.length).fill(!1),
      submittedMessage: ""
    };
  },
  computed: {
    answersValue: {
      get() {
        return this.answers;
      },
      set(e) {
        this.$emit("update:answers", e);
      }
    },
    focusedByKeyboard() {
      return this.form.openedBy === "keyboard";
    },
    requireSignature() {
      return this.questionsArray.some(
        ({ elementType: e, config: r, id: t }) => e === "E_SIGNATURE" && (r.requiredAnswer || this.questionHasAnswer(t))
      );
    },
    formattedQuestions() {
      return Ca(this.questions);
    },
    questionsArray() {
      const e = [];
      return Object.entries(this.formattedQuestions).forEach((r) => {
        const [t, a] = r;
        e.push(a);
      }), e;
    },
    questionsWithoutSections() {
      return this.questionsArray.filter((e) => e.elementType !== "SECTION");
    },
    questionsWithErrors() {
      return this.questionsArray.filter((r, t) => r.elementType === "SECTION" ? !1 : !this.validationsArray[t]);
    },
    answersFormData() {
      return this.answersValue.reduce((e, r) => {
        if (!r.answer) return e;
        const t = r.answer, a = r.question_id, n = r.accepted_at;
        return this.getQuestionType(a) === "FILE_UPLOAD" ? (this.appendFileData(a, t, e), e) : Array.isArray(t) ? (t.forEach(
          (i) => this.appendAnswerData(a, i, e)
        ), e) : (this.appendAnswerData(a, t, e, n), e);
      }, new FormData());
    },
    hasInvalidAnswers() {
      return this.validationsArray.some((e) => !e);
    }
  },
  watch: {
    validationsArray: {
      deep: !0,
      handler() {
        this.$emit("update:is-valid", !this.hasInvalidAnswers);
      }
    },
    answersValue: {
      deep: !0,
      handler() {
        this.$emit("update:answers-form-data-format", this.answersFormData);
      }
    }
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown(e) {
      (e.key === "Escape" || e.code === "Escape") && this.$emit("close-modal");
    },
    submit() {
      if (this.validate = !0, this.submittedMessage = "", this.questionsWithErrors.length) {
        const e = this.questionsWithErrors[0];
        this.$refs[e.id][0].scrollIntoView({
          behavior: "smooth"
        });
        let t = "";
        ["SINGLE_CHOICE", "MULTIPLE_CHOICE", "SCALE"].includes(e.elementType) && !e.config.dropdown ? t = `choice-${e.elementChoices[0].id}` : t = e.id, document.getElementById(t).focus({ preventScroll: !0 }), this.submittedMessage = this.$t("formComponents.formNotSubmitted", {
          questionsWithErrors: this.questionsWithErrors.length,
          totalQuestions: this.questions.length
        });
        return;
      }
      if (this.requireSignature && !this.disableOtp) {
        this.showEmailModal = !0;
        return;
      }
      this.$emit("submit", this.answers);
    },
    setErrorFocus(e) {
      switch (this.questionsWithErrors[0].elementType) {
        case "LONG_ANSWER": {
          e.querySelector("textarea").focus();
          break;
        }
        case "SCALE": {
          e.querySelector(".scale-choice").focus();
          break;
        }
        case "FILE_UPLOAD": {
          e.querySelector(".file-upload").focus();
          break;
        }
        case "ESIGNATURE": {
          e.querySelector(".add-signature").focus();
          break;
        }
        case "SINGLE_CHOICE": {
          this.questionsWithErrors[0].config.dropdown ? e.querySelector("button").focus() : e.querySelectorAll("input")[0].focus();
          break;
        }
        case "MULTIPLE_CHOICE": {
          this.questionsWithErrors[0].config.dropdown ? e.querySelector("button").focus() : e.querySelectorAll("input")[0].focus();
          break;
        }
        default: {
          e.querySelector("input").focus();
          break;
        }
      }
    },
    sendCode(e) {
      this.$emit("send-otp-code", e), this.showEmailModal = !1, this.showAuthModal = !0;
    },
    confirmCode(e) {
      this.$emit("confirm-otp-code", e), this.showAuthModal = !1;
    },
    getRGBColor(e) {
      const r = e.replace(/#/g, ""), t = parseInt(r.substr(0, 2), 16), a = parseInt(r.substr(2, 2), 16), n = parseInt(r.substr(4, 2), 16);
      return `${t} ${a} ${n}`;
    },
    setAcceptedAt(e, r) {
      this.answersValue[e].accepted_at = r;
    },
    findQuestionIndex(e) {
      return this.questionsWithoutSections.findIndex((r) => r.id ? r.id === e.id : r.tmpId === e.tmpId);
    },
    questionHasAnswer(e) {
      return this.answersValue.some(
        ({ question_id: r, answer: t }) => r === e && !!t
      );
    },
    getQuestionType(e) {
      return this.questionsArray.find(({ id: r }) => e === r).elementType;
    },
    getAnswerType(e) {
      return Pf[this.getQuestionType(e)] || "";
    },
    appendAnswerData(e, r, t, a) {
      t.append("data[attributes][answers][][element_id]", e), t.append(
        `data[attributes][answers][][${this.getAnswerType(e)}]`,
        r
      ), this.getQuestionType(e) === "E_SIGNATURE" && t.append("data[attributes][answers][][accepted_at]", a);
    },
    appendFileData(e, r, t) {
      t.append("data[attributes][answers][][element_id]", e), r.forEach(
        (a) => t.append("data[attributes][answers][][files][]", a)
      );
    },
    updateValidation(e, r) {
      this.validationsArray[e] = r, this.validate = !1;
    }
  }
}, Af = { "apptegy-forms": "" }, qf = {
  class: "sr-only",
  "aria-live": "polite",
  "aria-relevant": "all"
}, Rf = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-flex-col"
}, Vf = { class: "tw-text-[24px] tw-mt-[16px] tw-font-bold" }, Lf = { class: "tw-mt-[16px] tw-mx-[24px] tw-bg-white tw-p-[8px] tw-pb-[56px]" }, Uf = {
  class: "tw-text-[32px] tw-text-center tw-mt-[64px] tw-mb-[24px] tw-font-bold tw-leading-normal",
  "data-testid": "form-title"
}, Nf = { class: "tw-flex tw-items-center tw-justify-center" }, Ff = {
  class: "tw-text-base tw-text-gray-regular tw-flex tw-items-center tw-justify-center",
  "data-testid": "form-questions-length"
}, Wf = {
  key: 0,
  class: "tw-text-center tw-flex tw-items-center tw-justify-center",
  "data-testid": "form-close-date"
}, jf = { class: "tw-ml-[4px] tw-bg-gray-20 tw-rounded-[12px] tw-px-[8px] tw-py-[4px]" }, Hf = ["innerHTML"], Bf = {
  key: 0,
  class: "tw-py-5 tw-w-full"
}, Yf = ["id"], zf = ["innerHTML"], Gf = {
  key: 0,
  class: "tw-flex tw-w-full tw-items-center tw-justify-center tw-flex-col"
}, Qf = ["href", "target"];
function Kf(e, r, t, a, n, i) {
  const o = T("shared-avatar"), s = T("QuestionContainer"), u = T("EmailVerificationModal"), l = T("AuthCodeInput");
  return w(), g("div", Af, [
    m("div", {
      class: "tw-text-gray-regular",
      style: je({
        "--primary": i.getRGBColor(t.primaryColor),
        "--brand-color": t.primaryColor,
        "--link-color": t.linkColor,
        "--dscl-calendar-selected-color": t.primaryColor,
        "--dscl-calendar-hover-color": `${t.primaryColor}17`
      })
    }, [
      m("div", qf, _(n.submittedMessage), 1),
      t.hideHeader ? P("", !0) : (w(), g("div", Rf, [
        O(o, {
          src: t.logo,
          size: "medium-plus",
          class: "avatar"
        }, null, 8, ["src"]),
        m("h4", Vf, _(t.branding), 1)
      ])),
      m("div", Lf, [
        r[7] || (r[7] = m("div", { class: "tw-rounded tw-border-b-8 tw-border-b-primary" }, null, -1)),
        m("h3", Uf, _(t.title), 1),
        m("div", Nf, [
          m("p", Ff, _(e.$t("formComponents.question", {
            n: i.questionsWithoutSections.length
          })), 1),
          t.closeDate ? (w(), g("div", Wf, [
            r[6] || (r[6] = m("div", { class: "tw-border-l-[1px] tw-h-[24px] tw-mx-[8px]" }, null, -1)),
            se(" " + _(e.$t("formComponents.closeDate")) + " ", 1),
            m("div", jf, _(t.closeDate), 1)
          ])) : P("", !0)
        ]),
        m("div", {
          class: "no-inherit tw-text-base tw-text-gray-regular tw-mt-[24px] tw-mx-[40px]",
          "data-testid": "form-description",
          innerHTML: t.description
        }, null, 8, Hf),
        r[8] || (r[8] = m("div", { class: "tw-full-width tw-border-[1px] tw-border-primary/10 tw-my-[24px] tw-mx-[40px]" }, null, -1)),
        (w(!0), g(fe, null, he(i.formattedQuestions, (d, h) => {
          var y;
          return w(), g("div", {
            ref_for: !0,
            ref: d.id,
            key: d.id,
            class: re(["tw-mx-[24px]", {
              "tw-border-l-2 tw-border-l-primary tw-p-l-2": d.sectionId,
              "tw-pb-3": d.sectionId && ((y = i.formattedQuestions[h + 1]) == null ? void 0 : y.sectionId),
              "tw-mt-[8px]": !d.sectionId
            }])
          }, [
            d.elementType === "SECTION" ? (w(), g("div", Bf, [
              m("label", {
                id: d.id,
                class: "tw-text-[16px] xs:tw-text-[24px] tw-font-bold tw-tracking-[0.8px]"
              }, _(d.title), 9, Yf),
              d.config.description ? (w(), g("div", {
                key: 0,
                class: "tw-text-[14px] xs:tw-text-[16px] tw-text-gray-regular tw-tracking-[0.4px]",
                innerHTML: d.config.description
              }, null, 8, zf)) : P("", !0)
            ])) : P("", !0),
            d.elementType !== "SECTION" ? (w(), Q(s, {
              key: 1,
              modelValue: i.answersValue[h].answer,
              "onUpdate:modelValue": (v) => i.answersValue[h].answer = v,
              question: d,
              "question-index": i.findQuestionIndex(d) + 1,
              validate: n.validate,
              "focused-by-keyboard": i.focusedByKeyboard,
              onTouch: (v) => i.updateValidation(h, v),
              onAgree: (v) => i.setAcceptedAt(h, v)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "question", "question-index", "validate", "focused-by-keyboard", "onTouch", "onAgree"])) : P("", !0)
          ], 2);
        }), 128)),
        t.previewMode ? P("", !0) : (w(), g("div", Gf, [
          m("button", {
            class: "tw-rounded tw-leading-4 tw-my-1.5 tw-px-4 tw-text-white tw-w-[327px] tw-h-[52px] tw-mb-[40px] tw-focus-visible:outline tw-outline-4 tw-outline-accessible-focus tw-outline-offset-4",
            style: je({ "background-color": t.primaryColor }),
            "data-testid": "submit-form-button",
            onClick: r[0] || (r[0] = (...d) => i.submit && i.submit(...d))
          }, _(e.$t("formComponents.submit")), 5),
          m("a", {
            class: "tw-focus-visible:outline tw-outline-4 tw-outline-accessible-focus tw-outline-offset-4",
            href: t.privacyPolicyUrl,
            target: t.privacyPolicyTarget,
            style: je({ color: t.linkColor, "text-decoration": "underline" }),
            "data-testid": "form-privacy-policy",
            onClick: r[1] || (r[1] = (d) => e.$emit("privacy-policy-click"))
          }, _(e.$t("formComponents.privacyPolicy")), 13, Qf)
        ])),
        n.showEmailModal ? (w(), Q(u, {
          key: 1,
          "brand-color": t.primaryColor,
          onSend: i.sendCode,
          onClose: r[2] || (r[2] = (d) => n.showEmailModal = !1)
        }, null, 8, ["brand-color", "onSend"])) : P("", !0),
        n.showAuthModal ? (w(), Q(l, {
          key: 2,
          "brand-color": t.primaryColor,
          "show-error": t.invalidOtpCode,
          onConfirmCode: i.confirmCode,
          onClose: r[3] || (r[3] = (d) => n.showAuthModal = !1),
          onResendOtpCode: r[4] || (r[4] = (d) => e.$emit("resend-otp-code")),
          onCloseModal: r[5] || (r[5] = (d) => e.$emit("close-modal"))
        }, null, 8, ["brand-color", "show-error", "onConfirmCode"])) : P("", !0)
      ])
    ], 4)
  ]);
}
const Zf = /* @__PURE__ */ D(If, [["render", Kf], ["__scopeId", "data-v-82672a25"]]), lr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChoicePicker: Wn,
  DateTimePicker: Ta,
  Dropdown: Gn,
  ESignature: Da,
  FormRenderer: Zf,
  Input: Kn,
  Phone: $d,
  Scale: Zn,
  Textarea: Xn
}, Symbol.toStringTag, { value: "Module" })), Jf = {
  install(e) {
    Object.keys(lr).forEach(
      (r) => e.component(lr[r].name, lr[r])
    );
  }
};
export {
  Jf as default
};
